(function () {
    'use strict';

    document.addEventListener('DOMContentLoaded', () => {
      const {
        hydrateComponents
      } = window.PoleneLibs.Hydration;
      (async () => {
        const components = [Promise.resolve().then(function () { return productLegacyCarousel$1; }), Promise.resolve().then(function () { return productLegacyHeroInfo$1; }), Promise.resolve().then(function () { return productLegacyBuyBar$1; }), Promise.resolve().then(function () { return productLegacyStickyBuyBar$1; }), Promise.resolve().then(function () { return productLegacyDetailList$1; }), Promise.resolve().then(function () { return componentProductForm$1; }), Promise.resolve().then(function () { return componentTabs$1; }), Promise.resolve().then(function () { return componentZoomableImage$1; }), ...(document.querySelector('product-xyz-3d') ? [Promise.resolve().then(function () { return componentProductXyz3d$1; })] : [])];
        const componentsObj = hydrateComponents(components);
        await componentsObj.hydrate?.();
      })();
    });

    function createElement$1(className, tagName, appendToEl) {
      const el = document.createElement(tagName);
      if (className) {
        el.className = className;
      }
      if (appendToEl) {
        appendToEl.appendChild(el);
      }
      return el;
    }
    function equalizePoints(p1, p2) {
      p1.x = p2.x;
      p1.y = p2.y;
      if (p2.id !== undefined) {
        p1.id = p2.id;
      }
      return p1;
    }
    function roundPoint(p) {
      p.x = Math.round(p.x);
      p.y = Math.round(p.y);
    }
    function getDistanceBetween(p1, p2) {
      const x = Math.abs(p1.x - p2.x);
      const y = Math.abs(p1.y - p2.y);
      return Math.sqrt(x * x + y * y);
    }
    function pointsEqual(p1, p2) {
      return p1.x === p2.x && p1.y === p2.y;
    }
    function clamp(val, min, max) {
      return Math.min(Math.max(val, min), max);
    }
    function toTransformString$1(x, y, scale) {
      let propValue = `translate3d(${x}px,${y || 0}px,0)`;
      if (scale !== undefined) {
        propValue += ` scale3d(${scale},${scale},1)`;
      }
      return propValue;
    }
    function setTransform(el, x, y, scale) {
      el.style.transform = toTransformString$1(x, y, scale);
    }
    const defaultCSSEasing = 'cubic-bezier(.4,0,.22,1)';
    function setTransitionStyle(el, prop, duration, ease) {
      el.style.transition = prop ? `${prop} ${duration}ms ${ease || defaultCSSEasing}` : 'none';
    }
    function setWidthHeight$1(el, w, h) {
      el.style.width = typeof w === 'number' ? `${w}px` : w;
      el.style.height = typeof h === 'number' ? `${h}px` : h;
    }
    function removeTransitionStyle(el) {
      setTransitionStyle(el);
    }
    function decodeImage(img) {
      if ('decode' in img) {
        return img.decode().catch(() => {});
      }
      if (img.complete) {
        return Promise.resolve(img);
      }
      return new Promise((resolve, reject) => {
        img.onload = () => resolve(img);
        img.onerror = reject;
      });
    }
    const LOAD_STATE$1 = {
      IDLE: 'idle',
      LOADING: 'loading',
      LOADED: 'loaded',
      ERROR: 'error'
    };
    function specialKeyUsed$1(e) {
      return 'button' in e && e.button === 1 || e.ctrlKey || e.metaKey || e.altKey || e.shiftKey;
    }
    function getElementsFromOption$1(option, legacySelector, parent = document) {
      let elements = [];
      if (option instanceof Element) {
        elements = [option];
      } else if (option instanceof NodeList || Array.isArray(option)) {
        elements = Array.from(option);
      } else {
        const selector = typeof option === 'string' ? option : legacySelector;
        if (selector) {
          elements = Array.from(parent.querySelectorAll(selector));
        }
      }
      return elements;
    }
    function isSafari$1() {
      return !!(navigator.vendor && navigator.vendor.match(/apple/i));
    }
    let supportsPassive = false;
    try {
      window.addEventListener('test', null, Object.defineProperty({}, 'passive', {
        get: () => {
          supportsPassive = true;
        }
      }));
    } catch (e) {}
    class DOMEvents {
      constructor() {
        this._pool = [];
      }
      add(target, type, listener, passive) {
        this._toggleListener(target, type, listener, passive);
      }
      remove(target, type, listener, passive) {
        this._toggleListener(target, type, listener, passive, true);
      }
      removeAll() {
        this._pool.forEach(poolItem => {
          this._toggleListener(poolItem.target, poolItem.type, poolItem.listener, poolItem.passive, true, true);
        });
        this._pool = [];
      }
      _toggleListener(target, type, listener, passive, unbind, skipPool) {
        if (!target) {
          return;
        }
        const methodName = unbind ? 'removeEventListener' : 'addEventListener';
        const types = type.split(' ');
        types.forEach(eType => {
          if (eType) {
            if (!skipPool) {
              if (unbind) {
                this._pool = this._pool.filter(poolItem => {
                  return poolItem.type !== eType || poolItem.listener !== listener || poolItem.target !== target;
                });
              } else {
                this._pool.push({
                  target,
                  type: eType,
                  listener,
                  passive
                });
              }
            }
            const eventOptions = supportsPassive ? {
              passive: passive || false
            } : false;
            target[methodName](eType, listener, eventOptions);
          }
        });
      }
    }
    function getViewportSize$1(options, pswp) {
      if (options.getViewportSizeFn) {
        const newViewportSize = options.getViewportSizeFn(options, pswp);
        if (newViewportSize) {
          return newViewportSize;
        }
      }
      return {
        x: document.documentElement.clientWidth,
        y: window.innerHeight
      };
    }
    function parsePaddingOption$1(prop, options, viewportSize, itemData, index) {
      let paddingValue = 0;
      if (options.paddingFn) {
        paddingValue = options.paddingFn(viewportSize, itemData, index)[prop];
      } else if (options.padding) {
        paddingValue = options.padding[prop];
      } else {
        const legacyPropName = 'padding' + prop[0].toUpperCase() + prop.slice(1);
        if (options[legacyPropName]) {
          paddingValue = options[legacyPropName];
        }
      }
      return Number(paddingValue) || 0;
    }
    function getPanAreaSize$1(options, viewportSize, itemData, index) {
      return {
        x: viewportSize.x - parsePaddingOption$1('left', options, viewportSize, itemData, index) - parsePaddingOption$1('right', options, viewportSize, itemData, index),
        y: viewportSize.y - parsePaddingOption$1('top', options, viewportSize, itemData, index) - parsePaddingOption$1('bottom', options, viewportSize, itemData, index)
      };
    }
    class PanBounds {
      constructor(slide) {
        this.slide = slide;
        this.currZoomLevel = 1;
        this.center = {
          x: 0,
          y: 0
        };
        this.max = {
          x: 0,
          y: 0
        };
        this.min = {
          x: 0,
          y: 0
        };
      }
      update(currZoomLevel) {
        this.currZoomLevel = currZoomLevel;
        if (!this.slide.width) {
          this.reset();
        } else {
          this._updateAxis('x');
          this._updateAxis('y');
          this.slide.pswp.dispatch('calcBounds', {
            slide: this.slide
          });
        }
      }
      _updateAxis(axis) {
        const {
          pswp
        } = this.slide;
        const elSize = this.slide[axis === 'x' ? 'width' : 'height'] * this.currZoomLevel;
        const paddingProp = axis === 'x' ? 'left' : 'top';
        const padding = parsePaddingOption$1(paddingProp, pswp.options, pswp.viewportSize, this.slide.data, this.slide.index);
        const panAreaSize = this.slide.panAreaSize[axis];
        this.center[axis] = Math.round((panAreaSize - elSize) / 2) + padding;
        this.max[axis] = elSize > panAreaSize ? Math.round(panAreaSize - elSize) + padding : this.center[axis];
        this.min[axis] = elSize > panAreaSize ? padding : this.center[axis];
      }
      reset() {
        this.center.x = 0;
        this.center.y = 0;
        this.max.x = 0;
        this.max.y = 0;
        this.min.x = 0;
        this.min.y = 0;
      }
      correctPan(axis, panOffset) {
        return clamp(panOffset, this.max[axis], this.min[axis]);
      }
    }
    const MAX_IMAGE_WIDTH$1 = 4000;
    let ZoomLevel$1 = class ZoomLevel {
      constructor(options, itemData, index, pswp) {
        this.pswp = pswp;
        this.options = options;
        this.itemData = itemData;
        this.index = index;
        this.panAreaSize = null;
        this.elementSize = null;
        this.fit = 1;
        this.fill = 1;
        this.vFill = 1;
        this.initial = 1;
        this.secondary = 1;
        this.max = 1;
        this.min = 1;
      }
      update(maxWidth, maxHeight, panAreaSize) {
        const elementSize = {
          x: maxWidth,
          y: maxHeight
        };
        this.elementSize = elementSize;
        this.panAreaSize = panAreaSize;
        const hRatio = panAreaSize.x / elementSize.x;
        const vRatio = panAreaSize.y / elementSize.y;
        this.fit = Math.min(1, hRatio < vRatio ? hRatio : vRatio);
        this.fill = Math.min(1, hRatio > vRatio ? hRatio : vRatio);
        this.vFill = Math.min(1, vRatio);
        this.initial = this._getInitial();
        this.secondary = this._getSecondary();
        this.max = Math.max(this.initial, this.secondary, this._getMax());
        this.min = Math.min(this.fit, this.initial, this.secondary);
        if (this.pswp) {
          this.pswp.dispatch('zoomLevelsUpdate', {
            zoomLevels: this,
            slideData: this.itemData
          });
        }
      }
      _parseZoomLevelOption(optionPrefix) {
        const optionName = optionPrefix + 'ZoomLevel';
        const optionValue = this.options[optionName];
        if (!optionValue) {
          return;
        }
        if (typeof optionValue === 'function') {
          return optionValue(this);
        }
        if (optionValue === 'fill') {
          return this.fill;
        }
        if (optionValue === 'fit') {
          return this.fit;
        }
        return Number(optionValue);
      }
      _getSecondary() {
        let currZoomLevel = this._parseZoomLevelOption('secondary');
        if (currZoomLevel) {
          return currZoomLevel;
        }
        currZoomLevel = Math.min(1, this.fit * 3);
        if (this.elementSize && currZoomLevel * this.elementSize.x > MAX_IMAGE_WIDTH$1) {
          currZoomLevel = MAX_IMAGE_WIDTH$1 / this.elementSize.x;
        }
        return currZoomLevel;
      }
      _getInitial() {
        return this._parseZoomLevelOption('initial') || this.fit;
      }
      _getMax() {
        return this._parseZoomLevelOption('max') || Math.max(1, this.fit * 4);
      }
    };
    class Slide {
      constructor(data, index, pswp) {
        this.data = data;
        this.index = index;
        this.pswp = pswp;
        this.isActive = index === pswp.currIndex;
        this.currentResolution = 0;
        this.panAreaSize = {
          x: 0,
          y: 0
        };
        this.pan = {
          x: 0,
          y: 0
        };
        this.isFirstSlide = this.isActive && !pswp.opener.isOpen;
        this.zoomLevels = new ZoomLevel$1(pswp.options, data, index, pswp);
        this.pswp.dispatch('gettingData', {
          slide: this,
          data: this.data,
          index
        });
        this.content = this.pswp.contentLoader.getContentBySlide(this);
        this.container = createElement$1('pswp__zoom-wrap', 'div');
        this.holderElement = null;
        this.currZoomLevel = 1;
        this.width = this.content.width;
        this.height = this.content.height;
        this.heavyAppended = false;
        this.bounds = new PanBounds(this);
        this.prevDisplayedWidth = -1;
        this.prevDisplayedHeight = -1;
        this.pswp.dispatch('slideInit', {
          slide: this
        });
      }
      setIsActive(isActive) {
        if (isActive && !this.isActive) {
          this.activate();
        } else if (!isActive && this.isActive) {
          this.deactivate();
        }
      }
      append(holderElement) {
        this.holderElement = holderElement;
        this.container.style.transformOrigin = '0 0';
        if (!this.data) {
          return;
        }
        this.calculateSize();
        this.load();
        this.updateContentSize();
        this.appendHeavy();
        this.holderElement.appendChild(this.container);
        this.zoomAndPanToInitial();
        this.pswp.dispatch('firstZoomPan', {
          slide: this
        });
        this.applyCurrentZoomPan();
        this.pswp.dispatch('afterSetContent', {
          slide: this
        });
        if (this.isActive) {
          this.activate();
        }
      }
      load() {
        this.content.load(false);
        this.pswp.dispatch('slideLoad', {
          slide: this
        });
      }
      appendHeavy() {
        const {
          pswp
        } = this;
        const appendHeavyNearby = true;
        if (this.heavyAppended || !pswp.opener.isOpen || pswp.mainScroll.isShifted() || !this.isActive && !appendHeavyNearby) {
          return;
        }
        if (this.pswp.dispatch('appendHeavy', {
          slide: this
        }).defaultPrevented) {
          return;
        }
        this.heavyAppended = true;
        this.content.append();
        this.pswp.dispatch('appendHeavyContent', {
          slide: this
        });
      }
      activate() {
        this.isActive = true;
        this.appendHeavy();
        this.content.activate();
        this.pswp.dispatch('slideActivate', {
          slide: this
        });
      }
      deactivate() {
        this.isActive = false;
        this.content.deactivate();
        if (this.currZoomLevel !== this.zoomLevels.initial) {
          this.calculateSize();
        }
        this.currentResolution = 0;
        this.zoomAndPanToInitial();
        this.applyCurrentZoomPan();
        this.updateContentSize();
        this.pswp.dispatch('slideDeactivate', {
          slide: this
        });
      }
      destroy() {
        this.content.hasSlide = false;
        this.content.remove();
        this.container.remove();
        this.pswp.dispatch('slideDestroy', {
          slide: this
        });
      }
      resize() {
        if (this.currZoomLevel === this.zoomLevels.initial || !this.isActive) {
          this.calculateSize();
          this.currentResolution = 0;
          this.zoomAndPanToInitial();
          this.applyCurrentZoomPan();
          this.updateContentSize();
        } else {
          this.calculateSize();
          this.bounds.update(this.currZoomLevel);
          this.panTo(this.pan.x, this.pan.y);
        }
      }
      updateContentSize(force) {
        const scaleMultiplier = this.currentResolution || this.zoomLevels.initial;
        if (!scaleMultiplier) {
          return;
        }
        const width = Math.round(this.width * scaleMultiplier) || this.pswp.viewportSize.x;
        const height = Math.round(this.height * scaleMultiplier) || this.pswp.viewportSize.y;
        if (!this.sizeChanged(width, height) && !force) {
          return;
        }
        this.content.setDisplayedSize(width, height);
      }
      sizeChanged(width, height) {
        if (width !== this.prevDisplayedWidth || height !== this.prevDisplayedHeight) {
          this.prevDisplayedWidth = width;
          this.prevDisplayedHeight = height;
          return true;
        }
        return false;
      }
      getPlaceholderElement() {
        var _this$content$placeho;
        return (_this$content$placeho = this.content.placeholder) === null || _this$content$placeho === void 0 ? void 0 : _this$content$placeho.element;
      }
      zoomTo(destZoomLevel, centerPoint, transitionDuration, ignoreBounds) {
        const {
          pswp
        } = this;
        if (!this.isZoomable() || pswp.mainScroll.isShifted()) {
          return;
        }
        pswp.dispatch('beforeZoomTo', {
          destZoomLevel,
          centerPoint,
          transitionDuration
        });
        pswp.animations.stopAllPan();
        const prevZoomLevel = this.currZoomLevel;
        if (!ignoreBounds) {
          destZoomLevel = clamp(destZoomLevel, this.zoomLevels.min, this.zoomLevels.max);
        }
        this.setZoomLevel(destZoomLevel);
        this.pan.x = this.calculateZoomToPanOffset('x', centerPoint, prevZoomLevel);
        this.pan.y = this.calculateZoomToPanOffset('y', centerPoint, prevZoomLevel);
        roundPoint(this.pan);
        const finishTransition = () => {
          this._setResolution(destZoomLevel);
          this.applyCurrentZoomPan();
        };
        if (!transitionDuration) {
          finishTransition();
        } else {
          pswp.animations.startTransition({
            isPan: true,
            name: 'zoomTo',
            target: this.container,
            transform: this.getCurrentTransform(),
            onComplete: finishTransition,
            duration: transitionDuration,
            easing: pswp.options.easing
          });
        }
      }
      toggleZoom(centerPoint) {
        this.zoomTo(this.currZoomLevel === this.zoomLevels.initial ? this.zoomLevels.secondary : this.zoomLevels.initial, centerPoint, this.pswp.options.zoomAnimationDuration);
      }
      setZoomLevel(currZoomLevel) {
        this.currZoomLevel = currZoomLevel;
        this.bounds.update(this.currZoomLevel);
      }
      calculateZoomToPanOffset(axis, point, prevZoomLevel) {
        const totalPanDistance = this.bounds.max[axis] - this.bounds.min[axis];
        if (totalPanDistance === 0) {
          return this.bounds.center[axis];
        }
        if (!point) {
          point = this.pswp.getViewportCenterPoint();
        }
        if (!prevZoomLevel) {
          prevZoomLevel = this.zoomLevels.initial;
        }
        const zoomFactor = this.currZoomLevel / prevZoomLevel;
        return this.bounds.correctPan(axis, (this.pan[axis] - point[axis]) * zoomFactor + point[axis]);
      }
      panTo(panX, panY) {
        this.pan.x = this.bounds.correctPan('x', panX);
        this.pan.y = this.bounds.correctPan('y', panY);
        this.applyCurrentZoomPan();
      }
      isPannable() {
        return Boolean(this.width) && this.currZoomLevel > this.zoomLevels.fit;
      }
      isZoomable() {
        return Boolean(this.width) && this.content.isZoomable();
      }
      applyCurrentZoomPan() {
        this._applyZoomTransform(this.pan.x, this.pan.y, this.currZoomLevel);
        if (this === this.pswp.currSlide) {
          this.pswp.dispatch('zoomPanUpdate', {
            slide: this
          });
        }
      }
      zoomAndPanToInitial() {
        this.currZoomLevel = this.zoomLevels.initial;
        this.bounds.update(this.currZoomLevel);
        equalizePoints(this.pan, this.bounds.center);
        this.pswp.dispatch('initialZoomPan', {
          slide: this
        });
      }
      _applyZoomTransform(x, y, zoom) {
        zoom /= this.currentResolution || this.zoomLevels.initial;
        setTransform(this.container, x, y, zoom);
      }
      calculateSize() {
        const {
          pswp
        } = this;
        equalizePoints(this.panAreaSize, getPanAreaSize$1(pswp.options, pswp.viewportSize, this.data, this.index));
        this.zoomLevels.update(this.width, this.height, this.panAreaSize);
        pswp.dispatch('calcSlideSize', {
          slide: this
        });
      }
      getCurrentTransform() {
        const scale = this.currZoomLevel / (this.currentResolution || this.zoomLevels.initial);
        return toTransformString$1(this.pan.x, this.pan.y, scale);
      }
      _setResolution(newResolution) {
        if (newResolution === this.currentResolution) {
          return;
        }
        this.currentResolution = newResolution;
        this.updateContentSize();
        this.pswp.dispatch('resolutionChanged');
      }
    }
    const PAN_END_FRICTION = 0.35;
    const VERTICAL_DRAG_FRICTION = 0.6;
    const MIN_RATIO_TO_CLOSE = 0.4;
    const MIN_NEXT_SLIDE_SPEED = 0.5;
    function project(initialVelocity, decelerationRate) {
      return initialVelocity * decelerationRate / (1 - decelerationRate);
    }
    class DragHandler {
      constructor(gestures) {
        this.gestures = gestures;
        this.pswp = gestures.pswp;
        this.startPan = {
          x: 0,
          y: 0
        };
      }
      start() {
        if (this.pswp.currSlide) {
          equalizePoints(this.startPan, this.pswp.currSlide.pan);
        }
        this.pswp.animations.stopAll();
      }
      change() {
        const {
          p1,
          prevP1,
          dragAxis
        } = this.gestures;
        const {
          currSlide
        } = this.pswp;
        if (dragAxis === 'y' && this.pswp.options.closeOnVerticalDrag && currSlide && currSlide.currZoomLevel <= currSlide.zoomLevels.fit && !this.gestures.isMultitouch) {
          const panY = currSlide.pan.y + (p1.y - prevP1.y);
          if (!this.pswp.dispatch('verticalDrag', {
            panY
          }).defaultPrevented) {
            this._setPanWithFriction('y', panY, VERTICAL_DRAG_FRICTION);
            const bgOpacity = 1 - Math.abs(this._getVerticalDragRatio(currSlide.pan.y));
            this.pswp.applyBgOpacity(bgOpacity);
            currSlide.applyCurrentZoomPan();
          }
        } else {
          const mainScrollChanged = this._panOrMoveMainScroll('x');
          if (!mainScrollChanged) {
            this._panOrMoveMainScroll('y');
            if (currSlide) {
              roundPoint(currSlide.pan);
              currSlide.applyCurrentZoomPan();
            }
          }
        }
      }
      end() {
        const {
          velocity
        } = this.gestures;
        const {
          mainScroll,
          currSlide
        } = this.pswp;
        let indexDiff = 0;
        this.pswp.animations.stopAll();
        if (mainScroll.isShifted()) {
          const mainScrollShiftDiff = mainScroll.x - mainScroll.getCurrSlideX();
          const currentSlideVisibilityRatio = mainScrollShiftDiff / this.pswp.viewportSize.x;
          if (velocity.x < -MIN_NEXT_SLIDE_SPEED && currentSlideVisibilityRatio < 0 || velocity.x < 0.1 && currentSlideVisibilityRatio < -0.5) {
            indexDiff = 1;
            velocity.x = Math.min(velocity.x, 0);
          } else if (velocity.x > MIN_NEXT_SLIDE_SPEED && currentSlideVisibilityRatio > 0 || velocity.x > -0.1 && currentSlideVisibilityRatio > 0.5) {
            indexDiff = -1;
            velocity.x = Math.max(velocity.x, 0);
          }
          mainScroll.moveIndexBy(indexDiff, true, velocity.x);
        }
        if (currSlide && currSlide.currZoomLevel > currSlide.zoomLevels.max || this.gestures.isMultitouch) {
          this.gestures.zoomLevels.correctZoomPan(true);
        } else {
          this._finishPanGestureForAxis('x');
          this._finishPanGestureForAxis('y');
        }
      }
      _finishPanGestureForAxis(axis) {
        const {
          velocity
        } = this.gestures;
        const {
          currSlide
        } = this.pswp;
        if (!currSlide) {
          return;
        }
        const {
          pan,
          bounds
        } = currSlide;
        const panPos = pan[axis];
        const restoreBgOpacity = this.pswp.bgOpacity < 1 && axis === 'y';
        const decelerationRate = 0.995;
        const projectedPosition = panPos + project(velocity[axis], decelerationRate);
        if (restoreBgOpacity) {
          const vDragRatio = this._getVerticalDragRatio(panPos);
          const projectedVDragRatio = this._getVerticalDragRatio(projectedPosition);
          if (vDragRatio < 0 && projectedVDragRatio < -MIN_RATIO_TO_CLOSE || vDragRatio > 0 && projectedVDragRatio > MIN_RATIO_TO_CLOSE) {
            this.pswp.close();
            return;
          }
        }
        const correctedPanPosition = bounds.correctPan(axis, projectedPosition);
        if (panPos === correctedPanPosition) {
          return;
        }
        const dampingRatio = correctedPanPosition === projectedPosition ? 1 : 0.82;
        const initialBgOpacity = this.pswp.bgOpacity;
        const totalPanDist = correctedPanPosition - panPos;
        this.pswp.animations.startSpring({
          name: 'panGesture' + axis,
          isPan: true,
          start: panPos,
          end: correctedPanPosition,
          velocity: velocity[axis],
          dampingRatio,
          onUpdate: pos => {
            if (restoreBgOpacity && this.pswp.bgOpacity < 1) {
              const animationProgressRatio = 1 - (correctedPanPosition - pos) / totalPanDist;
              this.pswp.applyBgOpacity(clamp(initialBgOpacity + (1 - initialBgOpacity) * animationProgressRatio, 0, 1));
            }
            pan[axis] = Math.floor(pos);
            currSlide.applyCurrentZoomPan();
          }
        });
      }
      _panOrMoveMainScroll(axis) {
        const {
          p1,
          dragAxis,
          prevP1,
          isMultitouch
        } = this.gestures;
        const {
          currSlide,
          mainScroll
        } = this.pswp;
        const delta = p1[axis] - prevP1[axis];
        const newMainScrollX = mainScroll.x + delta;
        if (!delta || !currSlide) {
          return false;
        }
        if (axis === 'x' && !currSlide.isPannable() && !isMultitouch) {
          mainScroll.moveTo(newMainScrollX, true);
          return true;
        }
        const {
          bounds
        } = currSlide;
        const newPan = currSlide.pan[axis] + delta;
        if (this.pswp.options.allowPanToNext && dragAxis === 'x' && axis === 'x' && !isMultitouch) {
          const currSlideMainScrollX = mainScroll.getCurrSlideX();
          const mainScrollShiftDiff = mainScroll.x - currSlideMainScrollX;
          const isLeftToRight = delta > 0;
          const isRightToLeft = !isLeftToRight;
          if (newPan > bounds.min[axis] && isLeftToRight) {
            const wasAtMinPanPosition = bounds.min[axis] <= this.startPan[axis];
            if (wasAtMinPanPosition) {
              mainScroll.moveTo(newMainScrollX, true);
              return true;
            } else {
              this._setPanWithFriction(axis, newPan);
            }
          } else if (newPan < bounds.max[axis] && isRightToLeft) {
            const wasAtMaxPanPosition = this.startPan[axis] <= bounds.max[axis];
            if (wasAtMaxPanPosition) {
              mainScroll.moveTo(newMainScrollX, true);
              return true;
            } else {
              this._setPanWithFriction(axis, newPan);
            }
          } else {
            if (mainScrollShiftDiff !== 0) {
              if (mainScrollShiftDiff > 0) {
                mainScroll.moveTo(Math.max(newMainScrollX, currSlideMainScrollX), true);
                return true;
              } else if (mainScrollShiftDiff < 0) {
                mainScroll.moveTo(Math.min(newMainScrollX, currSlideMainScrollX), true);
                return true;
              }
            } else {
              this._setPanWithFriction(axis, newPan);
            }
          }
        } else {
          if (axis === 'y') {
            if (!mainScroll.isShifted() && bounds.min.y !== bounds.max.y) {
              this._setPanWithFriction(axis, newPan);
            }
          } else {
            this._setPanWithFriction(axis, newPan);
          }
        }
        return false;
      }
      _getVerticalDragRatio(panY) {
        var _this$pswp$currSlide$, _this$pswp$currSlide;
        return (panY - ((_this$pswp$currSlide$ = (_this$pswp$currSlide = this.pswp.currSlide) === null || _this$pswp$currSlide === void 0 ? void 0 : _this$pswp$currSlide.bounds.center.y) !== null && _this$pswp$currSlide$ !== void 0 ? _this$pswp$currSlide$ : 0)) / (this.pswp.viewportSize.y / 3);
      }
      _setPanWithFriction(axis, potentialPan, customFriction) {
        const {
          currSlide
        } = this.pswp;
        if (!currSlide) {
          return;
        }
        const {
          pan,
          bounds
        } = currSlide;
        const correctedPan = bounds.correctPan(axis, potentialPan);
        if (correctedPan !== potentialPan || customFriction) {
          const delta = Math.round(potentialPan - pan[axis]);
          pan[axis] += delta * (customFriction || PAN_END_FRICTION);
        } else {
          pan[axis] = potentialPan;
        }
      }
    }
    const UPPER_ZOOM_FRICTION = 0.05;
    const LOWER_ZOOM_FRICTION = 0.15;
    function getZoomPointsCenter(p, p1, p2) {
      p.x = (p1.x + p2.x) / 2;
      p.y = (p1.y + p2.y) / 2;
      return p;
    }
    class ZoomHandler {
      constructor(gestures) {
        this.gestures = gestures;
        this._startPan = {
          x: 0,
          y: 0
        };
        this._startZoomPoint = {
          x: 0,
          y: 0
        };
        this._zoomPoint = {
          x: 0,
          y: 0
        };
        this._wasOverFitZoomLevel = false;
        this._startZoomLevel = 1;
      }
      start() {
        const {
          currSlide
        } = this.gestures.pswp;
        if (currSlide) {
          this._startZoomLevel = currSlide.currZoomLevel;
          equalizePoints(this._startPan, currSlide.pan);
        }
        this.gestures.pswp.animations.stopAllPan();
        this._wasOverFitZoomLevel = false;
      }
      change() {
        const {
          p1,
          startP1,
          p2,
          startP2,
          pswp
        } = this.gestures;
        const {
          currSlide
        } = pswp;
        if (!currSlide) {
          return;
        }
        const minZoomLevel = currSlide.zoomLevels.min;
        const maxZoomLevel = currSlide.zoomLevels.max;
        if (!currSlide.isZoomable() || pswp.mainScroll.isShifted()) {
          return;
        }
        getZoomPointsCenter(this._startZoomPoint, startP1, startP2);
        getZoomPointsCenter(this._zoomPoint, p1, p2);
        let currZoomLevel = 1 / getDistanceBetween(startP1, startP2) * getDistanceBetween(p1, p2) * this._startZoomLevel;
        if (currZoomLevel > currSlide.zoomLevels.initial + currSlide.zoomLevels.initial / 15) {
          this._wasOverFitZoomLevel = true;
        }
        if (currZoomLevel < minZoomLevel) {
          if (pswp.options.pinchToClose && !this._wasOverFitZoomLevel && this._startZoomLevel <= currSlide.zoomLevels.initial) {
            const bgOpacity = 1 - (minZoomLevel - currZoomLevel) / (minZoomLevel / 1.2);
            if (!pswp.dispatch('pinchClose', {
              bgOpacity
            }).defaultPrevented) {
              pswp.applyBgOpacity(bgOpacity);
            }
          } else {
            currZoomLevel = minZoomLevel - (minZoomLevel - currZoomLevel) * LOWER_ZOOM_FRICTION;
          }
        } else if (currZoomLevel > maxZoomLevel) {
          currZoomLevel = maxZoomLevel + (currZoomLevel - maxZoomLevel) * UPPER_ZOOM_FRICTION;
        }
        currSlide.pan.x = this._calculatePanForZoomLevel('x', currZoomLevel);
        currSlide.pan.y = this._calculatePanForZoomLevel('y', currZoomLevel);
        currSlide.setZoomLevel(currZoomLevel);
        currSlide.applyCurrentZoomPan();
      }
      end() {
        const {
          pswp
        } = this.gestures;
        const {
          currSlide
        } = pswp;
        if ((!currSlide || currSlide.currZoomLevel < currSlide.zoomLevels.initial) && !this._wasOverFitZoomLevel && pswp.options.pinchToClose) {
          pswp.close();
        } else {
          this.correctZoomPan();
        }
      }
      _calculatePanForZoomLevel(axis, currZoomLevel) {
        const zoomFactor = currZoomLevel / this._startZoomLevel;
        return this._zoomPoint[axis] - (this._startZoomPoint[axis] - this._startPan[axis]) * zoomFactor;
      }
      correctZoomPan(ignoreGesture) {
        const {
          pswp
        } = this.gestures;
        const {
          currSlide
        } = pswp;
        if (!(currSlide !== null && currSlide !== void 0 && currSlide.isZoomable())) {
          return;
        }
        if (this._zoomPoint.x === 0) {
          ignoreGesture = true;
        }
        const prevZoomLevel = currSlide.currZoomLevel;
        let destinationZoomLevel;
        let currZoomLevelNeedsChange = true;
        if (prevZoomLevel < currSlide.zoomLevels.initial) {
          destinationZoomLevel = currSlide.zoomLevels.initial;
        } else if (prevZoomLevel > currSlide.zoomLevels.max) {
          destinationZoomLevel = currSlide.zoomLevels.max;
        } else {
          currZoomLevelNeedsChange = false;
          destinationZoomLevel = prevZoomLevel;
        }
        const initialBgOpacity = pswp.bgOpacity;
        const restoreBgOpacity = pswp.bgOpacity < 1;
        const initialPan = equalizePoints({
          x: 0,
          y: 0
        }, currSlide.pan);
        let destinationPan = equalizePoints({
          x: 0,
          y: 0
        }, initialPan);
        if (ignoreGesture) {
          this._zoomPoint.x = 0;
          this._zoomPoint.y = 0;
          this._startZoomPoint.x = 0;
          this._startZoomPoint.y = 0;
          this._startZoomLevel = prevZoomLevel;
          equalizePoints(this._startPan, initialPan);
        }
        if (currZoomLevelNeedsChange) {
          destinationPan = {
            x: this._calculatePanForZoomLevel('x', destinationZoomLevel),
            y: this._calculatePanForZoomLevel('y', destinationZoomLevel)
          };
        }
        currSlide.setZoomLevel(destinationZoomLevel);
        destinationPan = {
          x: currSlide.bounds.correctPan('x', destinationPan.x),
          y: currSlide.bounds.correctPan('y', destinationPan.y)
        };
        currSlide.setZoomLevel(prevZoomLevel);
        const panNeedsChange = !pointsEqual(destinationPan, initialPan);
        if (!panNeedsChange && !currZoomLevelNeedsChange && !restoreBgOpacity) {
          currSlide._setResolution(destinationZoomLevel);
          currSlide.applyCurrentZoomPan();
          return;
        }
        pswp.animations.stopAllPan();
        pswp.animations.startSpring({
          isPan: true,
          start: 0,
          end: 1000,
          velocity: 0,
          dampingRatio: 1,
          naturalFrequency: 40,
          onUpdate: now => {
            now /= 1000;
            if (panNeedsChange || currZoomLevelNeedsChange) {
              if (panNeedsChange) {
                currSlide.pan.x = initialPan.x + (destinationPan.x - initialPan.x) * now;
                currSlide.pan.y = initialPan.y + (destinationPan.y - initialPan.y) * now;
              }
              if (currZoomLevelNeedsChange) {
                const newZoomLevel = prevZoomLevel + (destinationZoomLevel - prevZoomLevel) * now;
                currSlide.setZoomLevel(newZoomLevel);
              }
              currSlide.applyCurrentZoomPan();
            }
            if (restoreBgOpacity && pswp.bgOpacity < 1) {
              pswp.applyBgOpacity(clamp(initialBgOpacity + (1 - initialBgOpacity) * now, 0, 1));
            }
          },
          onComplete: () => {
            currSlide._setResolution(destinationZoomLevel);
            currSlide.applyCurrentZoomPan();
          }
        });
      }
    }
    function didTapOnMainContent(event) {
      return !!event.target.closest('.pswp__container');
    }
    class TapHandler {
      constructor(gestures) {
        this.gestures = gestures;
      }
      click(point, originalEvent) {
        const targetClassList = originalEvent.target.classList;
        const isImageClick = targetClassList.contains('pswp__img');
        const isBackgroundClick = targetClassList.contains('pswp__item') || targetClassList.contains('pswp__zoom-wrap');
        if (isImageClick) {
          this._doClickOrTapAction('imageClick', point, originalEvent);
        } else if (isBackgroundClick) {
          this._doClickOrTapAction('bgClick', point, originalEvent);
        }
      }
      tap(point, originalEvent) {
        if (didTapOnMainContent(originalEvent)) {
          this._doClickOrTapAction('tap', point, originalEvent);
        }
      }
      doubleTap(point, originalEvent) {
        if (didTapOnMainContent(originalEvent)) {
          this._doClickOrTapAction('doubleTap', point, originalEvent);
        }
      }
      _doClickOrTapAction(actionName, point, originalEvent) {
        var _this$gestures$pswp$e;
        const {
          pswp
        } = this.gestures;
        const {
          currSlide
        } = pswp;
        const actionFullName = actionName + 'Action';
        const optionValue = pswp.options[actionFullName];
        if (pswp.dispatch(actionFullName, {
          point,
          originalEvent
        }).defaultPrevented) {
          return;
        }
        if (typeof optionValue === 'function') {
          optionValue.call(pswp, point, originalEvent);
          return;
        }
        switch (optionValue) {
          case 'close':
          case 'next':
            pswp[optionValue]();
            break;
          case 'zoom':
            currSlide === null || currSlide === void 0 || currSlide.toggleZoom(point);
            break;
          case 'zoom-or-close':
            if (currSlide !== null && currSlide !== void 0 && currSlide.isZoomable() && currSlide.zoomLevels.secondary !== currSlide.zoomLevels.initial) {
              currSlide.toggleZoom(point);
            } else if (pswp.options.clickToCloseNonZoomable) {
              pswp.close();
            }
            break;
          case 'toggle-controls':
            (_this$gestures$pswp$e = this.gestures.pswp.element) === null || _this$gestures$pswp$e === void 0 || _this$gestures$pswp$e.classList.toggle('pswp--ui-visible');
            break;
        }
      }
    }
    const AXIS_SWIPE_HYSTERISIS = 10;
    const DOUBLE_TAP_DELAY = 300;
    const MIN_TAP_DISTANCE = 25;
    class Gestures {
      constructor(pswp) {
        this.pswp = pswp;
        this.dragAxis = null;
        this.p1 = {
          x: 0,
          y: 0
        };
        this.p2 = {
          x: 0,
          y: 0
        };
        this.prevP1 = {
          x: 0,
          y: 0
        };
        this.prevP2 = {
          x: 0,
          y: 0
        };
        this.startP1 = {
          x: 0,
          y: 0
        };
        this.startP2 = {
          x: 0,
          y: 0
        };
        this.velocity = {
          x: 0,
          y: 0
        };
        this._lastStartP1 = {
          x: 0,
          y: 0
        };
        this._intervalP1 = {
          x: 0,
          y: 0
        };
        this._numActivePoints = 0;
        this._ongoingPointers = [];
        this._touchEventEnabled = 'ontouchstart' in window;
        this._pointerEventEnabled = !!window.PointerEvent;
        this.supportsTouch = this._touchEventEnabled || this._pointerEventEnabled && navigator.maxTouchPoints > 1;
        this._numActivePoints = 0;
        this._intervalTime = 0;
        this._velocityCalculated = false;
        this.isMultitouch = false;
        this.isDragging = false;
        this.isZooming = false;
        this.raf = null;
        this._tapTimer = null;
        if (!this.supportsTouch) {
          pswp.options.allowPanToNext = false;
        }
        this.drag = new DragHandler(this);
        this.zoomLevels = new ZoomHandler(this);
        this.tapHandler = new TapHandler(this);
        pswp.on('bindEvents', () => {
          pswp.events.add(pswp.scrollWrap, 'click', this._onClick.bind(this));
          if (this._pointerEventEnabled) {
            this._bindEvents('pointer', 'down', 'up', 'cancel');
          } else if (this._touchEventEnabled) {
            this._bindEvents('touch', 'start', 'end', 'cancel');
            if (pswp.scrollWrap) {
              pswp.scrollWrap.ontouchmove = () => {};
              pswp.scrollWrap.ontouchend = () => {};
            }
          } else {
            this._bindEvents('mouse', 'down', 'up');
          }
        });
      }
      _bindEvents(pref, down, up, cancel) {
        const {
          pswp
        } = this;
        const {
          events
        } = pswp;
        const cancelEvent = cancel ? pref + cancel : '';
        events.add(pswp.scrollWrap, pref + down, this.onPointerDown.bind(this));
        events.add(window, pref + 'move', this.onPointerMove.bind(this));
        events.add(window, pref + up, this.onPointerUp.bind(this));
        if (cancelEvent) {
          events.add(pswp.scrollWrap, cancelEvent, this.onPointerUp.bind(this));
        }
      }
      onPointerDown(e) {
        const isMousePointer = e.type === 'mousedown' || e.pointerType === 'mouse';
        if (isMousePointer && e.button > 0) {
          return;
        }
        const {
          pswp
        } = this;
        if (!pswp.opener.isOpen) {
          e.preventDefault();
          return;
        }
        if (pswp.dispatch('pointerDown', {
          originalEvent: e
        }).defaultPrevented) {
          return;
        }
        if (isMousePointer) {
          pswp.mouseDetected();
          this._preventPointerEventBehaviour(e, 'down');
        }
        pswp.animations.stopAll();
        this._updatePoints(e, 'down');
        if (this._numActivePoints === 1) {
          this.dragAxis = null;
          equalizePoints(this.startP1, this.p1);
        }
        if (this._numActivePoints > 1) {
          this._clearTapTimer();
          this.isMultitouch = true;
        } else {
          this.isMultitouch = false;
        }
      }
      onPointerMove(e) {
        this._preventPointerEventBehaviour(e, 'move');
        if (!this._numActivePoints) {
          return;
        }
        this._updatePoints(e, 'move');
        if (this.pswp.dispatch('pointerMove', {
          originalEvent: e
        }).defaultPrevented) {
          return;
        }
        if (this._numActivePoints === 1 && !this.isDragging) {
          if (!this.dragAxis) {
            this._calculateDragDirection();
          }
          if (this.dragAxis && !this.isDragging) {
            if (this.isZooming) {
              this.isZooming = false;
              this.zoomLevels.end();
            }
            this.isDragging = true;
            this._clearTapTimer();
            this._updateStartPoints();
            this._intervalTime = Date.now();
            this._velocityCalculated = false;
            equalizePoints(this._intervalP1, this.p1);
            this.velocity.x = 0;
            this.velocity.y = 0;
            this.drag.start();
            this._rafStopLoop();
            this._rafRenderLoop();
          }
        } else if (this._numActivePoints > 1 && !this.isZooming) {
          this._finishDrag();
          this.isZooming = true;
          this._updateStartPoints();
          this.zoomLevels.start();
          this._rafStopLoop();
          this._rafRenderLoop();
        }
      }
      _finishDrag() {
        if (this.isDragging) {
          this.isDragging = false;
          if (!this._velocityCalculated) {
            this._updateVelocity(true);
          }
          this.drag.end();
          this.dragAxis = null;
        }
      }
      onPointerUp(e) {
        if (!this._numActivePoints) {
          return;
        }
        this._updatePoints(e, 'up');
        if (this.pswp.dispatch('pointerUp', {
          originalEvent: e
        }).defaultPrevented) {
          return;
        }
        if (this._numActivePoints === 0) {
          this._rafStopLoop();
          if (this.isDragging) {
            this._finishDrag();
          } else if (!this.isZooming && !this.isMultitouch) {
            this._finishTap(e);
          }
        }
        if (this._numActivePoints < 2 && this.isZooming) {
          this.isZooming = false;
          this.zoomLevels.end();
          if (this._numActivePoints === 1) {
            this.dragAxis = null;
            this._updateStartPoints();
          }
        }
      }
      _rafRenderLoop() {
        if (this.isDragging || this.isZooming) {
          this._updateVelocity();
          if (this.isDragging) {
            if (!pointsEqual(this.p1, this.prevP1)) {
              this.drag.change();
            }
          } else {
              if (!pointsEqual(this.p1, this.prevP1) || !pointsEqual(this.p2, this.prevP2)) {
                this.zoomLevels.change();
              }
            }
          this._updatePrevPoints();
          this.raf = requestAnimationFrame(this._rafRenderLoop.bind(this));
        }
      }
      _updateVelocity(force) {
        const time = Date.now();
        const duration = time - this._intervalTime;
        if (duration < 50 && !force) {
          return;
        }
        this.velocity.x = this._getVelocity('x', duration);
        this.velocity.y = this._getVelocity('y', duration);
        this._intervalTime = time;
        equalizePoints(this._intervalP1, this.p1);
        this._velocityCalculated = true;
      }
      _finishTap(e) {
        const {
          mainScroll
        } = this.pswp;
        if (mainScroll.isShifted()) {
          mainScroll.moveIndexBy(0, true);
          return;
        }
        if (e.type.indexOf('cancel') > 0) {
          return;
        }
        if (e.type === 'mouseup' || e.pointerType === 'mouse') {
          this.tapHandler.click(this.startP1, e);
          return;
        }
        const tapDelay = this.pswp.options.doubleTapAction ? DOUBLE_TAP_DELAY : 0;
        if (this._tapTimer) {
          this._clearTapTimer();
          if (getDistanceBetween(this._lastStartP1, this.startP1) < MIN_TAP_DISTANCE) {
            this.tapHandler.doubleTap(this.startP1, e);
          }
        } else {
          equalizePoints(this._lastStartP1, this.startP1);
          this._tapTimer = setTimeout(() => {
            this.tapHandler.tap(this.startP1, e);
            this._clearTapTimer();
          }, tapDelay);
        }
      }
      _clearTapTimer() {
        if (this._tapTimer) {
          clearTimeout(this._tapTimer);
          this._tapTimer = null;
        }
      }
      _getVelocity(axis, duration) {
        const displacement = this.p1[axis] - this._intervalP1[axis];
        if (Math.abs(displacement) > 1 && duration > 5) {
          return displacement / duration;
        }
        return 0;
      }
      _rafStopLoop() {
        if (this.raf) {
          cancelAnimationFrame(this.raf);
          this.raf = null;
        }
      }
      _preventPointerEventBehaviour(e, pointerType) {
        const preventPointerEvent = this.pswp.applyFilters('preventPointerEvent', true, e, pointerType);
        if (preventPointerEvent) {
          e.preventDefault();
        }
      }
      _updatePoints(e, pointerType) {
        if (this._pointerEventEnabled) {
          const pointerEvent = e;
          const pointerIndex = this._ongoingPointers.findIndex(ongoingPointer => {
            return ongoingPointer.id === pointerEvent.pointerId;
          });
          if (pointerType === 'up' && pointerIndex > -1) {
            this._ongoingPointers.splice(pointerIndex, 1);
          } else if (pointerType === 'down' && pointerIndex === -1) {
            this._ongoingPointers.push(this._convertEventPosToPoint(pointerEvent, {
              x: 0,
              y: 0
            }));
          } else if (pointerIndex > -1) {
            this._convertEventPosToPoint(pointerEvent, this._ongoingPointers[pointerIndex]);
          }
          this._numActivePoints = this._ongoingPointers.length;
          if (this._numActivePoints > 0) {
            equalizePoints(this.p1, this._ongoingPointers[0]);
          }
          if (this._numActivePoints > 1) {
            equalizePoints(this.p2, this._ongoingPointers[1]);
          }
        } else {
          const touchEvent = e;
          this._numActivePoints = 0;
          if (touchEvent.type.indexOf('touch') > -1) {
            if (touchEvent.touches && touchEvent.touches.length > 0) {
              this._convertEventPosToPoint(touchEvent.touches[0], this.p1);
              this._numActivePoints++;
              if (touchEvent.touches.length > 1) {
                this._convertEventPosToPoint(touchEvent.touches[1], this.p2);
                this._numActivePoints++;
              }
            }
          } else {
            this._convertEventPosToPoint(e, this.p1);
            if (pointerType === 'up') {
              this._numActivePoints = 0;
            } else {
              this._numActivePoints++;
            }
          }
        }
      }
      _updatePrevPoints() {
        equalizePoints(this.prevP1, this.p1);
        equalizePoints(this.prevP2, this.p2);
      }
      _updateStartPoints() {
        equalizePoints(this.startP1, this.p1);
        equalizePoints(this.startP2, this.p2);
        this._updatePrevPoints();
      }
      _calculateDragDirection() {
        if (this.pswp.mainScroll.isShifted()) {
          this.dragAxis = 'x';
        } else {
          const diff = Math.abs(this.p1.x - this.startP1.x) - Math.abs(this.p1.y - this.startP1.y);
          if (diff !== 0) {
            const axisToCheck = diff > 0 ? 'x' : 'y';
            if (Math.abs(this.p1[axisToCheck] - this.startP1[axisToCheck]) >= AXIS_SWIPE_HYSTERISIS) {
              this.dragAxis = axisToCheck;
            }
          }
        }
      }
      _convertEventPosToPoint(e, p) {
        p.x = e.pageX - this.pswp.offset.x;
        p.y = e.pageY - this.pswp.offset.y;
        if ('pointerId' in e) {
          p.id = e.pointerId;
        } else if (e.identifier !== undefined) {
          p.id = e.identifier;
        }
        return p;
      }
      _onClick(e) {
        if (this.pswp.mainScroll.isShifted()) {
          e.preventDefault();
          e.stopPropagation();
        }
      }
    }
    const MAIN_SCROLL_END_FRICTION = 0.35;
    class MainScroll {
      constructor(pswp) {
        this.pswp = pswp;
        this.x = 0;
        this.slideWidth = 0;
        this._currPositionIndex = 0;
        this._prevPositionIndex = 0;
        this._containerShiftIndex = -1;
        this.itemHolders = [];
      }
      resize(resizeSlides) {
        const {
          pswp
        } = this;
        const newSlideWidth = Math.round(pswp.viewportSize.x + pswp.viewportSize.x * pswp.options.spacing);
        const slideWidthChanged = newSlideWidth !== this.slideWidth;
        if (slideWidthChanged) {
          this.slideWidth = newSlideWidth;
          this.moveTo(this.getCurrSlideX());
        }
        this.itemHolders.forEach((itemHolder, index) => {
          if (slideWidthChanged) {
            setTransform(itemHolder.el, (index + this._containerShiftIndex) * this.slideWidth);
          }
          if (resizeSlides && itemHolder.slide) {
            itemHolder.slide.resize();
          }
        });
      }
      resetPosition() {
        this._currPositionIndex = 0;
        this._prevPositionIndex = 0;
        this.slideWidth = 0;
        this._containerShiftIndex = -1;
      }
      appendHolders() {
        this.itemHolders = [];
        for (let i = 0; i < 3; i++) {
          const el = createElement$1('pswp__item', 'div', this.pswp.container);
          el.setAttribute('role', 'group');
          el.setAttribute('aria-roledescription', 'slide');
          el.setAttribute('aria-hidden', 'true');
          el.style.display = i === 1 ? 'block' : 'none';
          this.itemHolders.push({
            el
          });
        }
      }
      canBeSwiped() {
        return this.pswp.getNumItems() > 1;
      }
      moveIndexBy(diff, animate, velocityX) {
        const {
          pswp
        } = this;
        let newIndex = pswp.potentialIndex + diff;
        const numSlides = pswp.getNumItems();
        if (pswp.canLoop()) {
          newIndex = pswp.getLoopedIndex(newIndex);
          const distance = (diff + numSlides) % numSlides;
          if (distance <= numSlides / 2) {
            diff = distance;
          } else {
            diff = distance - numSlides;
          }
        } else {
          if (newIndex < 0) {
            newIndex = 0;
          } else if (newIndex >= numSlides) {
            newIndex = numSlides - 1;
          }
          diff = newIndex - pswp.potentialIndex;
        }
        pswp.potentialIndex = newIndex;
        this._currPositionIndex -= diff;
        pswp.animations.stopMainScroll();
        const destinationX = this.getCurrSlideX();
        if (!animate) {
          this.moveTo(destinationX);
          this.updateCurrItem();
        } else {
          pswp.animations.startSpring({
            isMainScroll: true,
            start: this.x,
            end: destinationX,
            velocity: velocityX || 0,
            naturalFrequency: 30,
            dampingRatio: 1,
            onUpdate: x => {
              this.moveTo(x);
            },
            onComplete: () => {
              this.updateCurrItem();
              pswp.appendHeavy();
            }
          });
          let currDiff = pswp.potentialIndex - pswp.currIndex;
          if (pswp.canLoop()) {
            const currDistance = (currDiff + numSlides) % numSlides;
            if (currDistance <= numSlides / 2) {
              currDiff = currDistance;
            } else {
              currDiff = currDistance - numSlides;
            }
          }
          if (Math.abs(currDiff) > 1) {
            this.updateCurrItem();
          }
        }
        return Boolean(diff);
      }
      getCurrSlideX() {
        return this.slideWidth * this._currPositionIndex;
      }
      isShifted() {
        return this.x !== this.getCurrSlideX();
      }
      updateCurrItem() {
        var _this$itemHolders$;
        const {
          pswp
        } = this;
        const positionDifference = this._prevPositionIndex - this._currPositionIndex;
        if (!positionDifference) {
          return;
        }
        this._prevPositionIndex = this._currPositionIndex;
        pswp.currIndex = pswp.potentialIndex;
        let diffAbs = Math.abs(positionDifference);
        let tempHolder;
        if (diffAbs >= 3) {
          this._containerShiftIndex += positionDifference + (positionDifference > 0 ? -3 : 3);
          diffAbs = 3;
          this.itemHolders.forEach(itemHolder => {
            var _itemHolder$slide;
            (_itemHolder$slide = itemHolder.slide) === null || _itemHolder$slide === void 0 || _itemHolder$slide.destroy();
            itemHolder.slide = undefined;
          });
        }
        for (let i = 0; i < diffAbs; i++) {
          if (positionDifference > 0) {
            tempHolder = this.itemHolders.shift();
            if (tempHolder) {
              this.itemHolders[2] = tempHolder;
              this._containerShiftIndex++;
              setTransform(tempHolder.el, (this._containerShiftIndex + 2) * this.slideWidth);
              pswp.setContent(tempHolder, pswp.currIndex - diffAbs + i + 2);
            }
          } else {
            tempHolder = this.itemHolders.pop();
            if (tempHolder) {
              this.itemHolders.unshift(tempHolder);
              this._containerShiftIndex--;
              setTransform(tempHolder.el, this._containerShiftIndex * this.slideWidth);
              pswp.setContent(tempHolder, pswp.currIndex + diffAbs - i - 2);
            }
          }
        }
        if (Math.abs(this._containerShiftIndex) > 50 && !this.isShifted()) {
          this.resetPosition();
          this.resize();
        }
        pswp.animations.stopAllPan();
        this.itemHolders.forEach((itemHolder, i) => {
          if (itemHolder.slide) {
            itemHolder.slide.setIsActive(i === 1);
          }
        });
        pswp.currSlide = (_this$itemHolders$ = this.itemHolders[1]) === null || _this$itemHolders$ === void 0 ? void 0 : _this$itemHolders$.slide;
        pswp.contentLoader.updateLazy(positionDifference);
        if (pswp.currSlide) {
          pswp.currSlide.applyCurrentZoomPan();
        }
        pswp.dispatch('change');
      }
      moveTo(x, dragging) {
        if (!this.pswp.canLoop() && dragging) {
          let newSlideIndexOffset = (this.slideWidth * this._currPositionIndex - x) / this.slideWidth;
          newSlideIndexOffset += this.pswp.currIndex;
          const delta = Math.round(x - this.x);
          if (newSlideIndexOffset < 0 && delta > 0 || newSlideIndexOffset >= this.pswp.getNumItems() - 1 && delta < 0) {
            x = this.x + delta * MAIN_SCROLL_END_FRICTION;
          }
        }
        this.x = x;
        if (this.pswp.container) {
          setTransform(this.pswp.container, x);
        }
        this.pswp.dispatch('moveMainScroll', {
          x,
          dragging: dragging !== null && dragging !== void 0 ? dragging : false
        });
      }
    }
    const KeyboardKeyCodesMap = {
      Escape: 27,
      z: 90,
      ArrowLeft: 37,
      ArrowUp: 38,
      ArrowRight: 39,
      ArrowDown: 40,
      Tab: 9
    };
    const getKeyboardEventKey = (key, isKeySupported) => {
      return isKeySupported ? key : KeyboardKeyCodesMap[key];
    };
    class Keyboard {
      constructor(pswp) {
        this.pswp = pswp;
        this._wasFocused = false;
        pswp.on('bindEvents', () => {
          if (pswp.options.trapFocus) {
            if (!pswp.options.initialPointerPos) {
              this._focusRoot();
            }
            pswp.events.add(document, 'focusin', this._onFocusIn.bind(this));
          }
          pswp.events.add(document, 'keydown', this._onKeyDown.bind(this));
        });
        const lastActiveElement = document.activeElement;
        pswp.on('destroy', () => {
          if (pswp.options.returnFocus && lastActiveElement && this._wasFocused) {
            lastActiveElement.focus();
          }
        });
      }
      _focusRoot() {
        if (!this._wasFocused && this.pswp.element) {
          this.pswp.element.focus();
          this._wasFocused = true;
        }
      }
      _onKeyDown(e) {
        const {
          pswp
        } = this;
        if (pswp.dispatch('keydown', {
          originalEvent: e
        }).defaultPrevented) {
          return;
        }
        if (specialKeyUsed$1(e)) {
          return;
        }
        let keydownAction;
        let axis;
        let isForward = false;
        const isKeySupported = 'key' in e;
        switch (isKeySupported ? e.key : e.keyCode) {
          case getKeyboardEventKey('Escape', isKeySupported):
            if (pswp.options.escKey) {
              keydownAction = 'close';
            }
            break;
          case getKeyboardEventKey('z', isKeySupported):
            keydownAction = 'toggleZoom';
            break;
          case getKeyboardEventKey('ArrowLeft', isKeySupported):
            axis = 'x';
            break;
          case getKeyboardEventKey('ArrowUp', isKeySupported):
            axis = 'y';
            break;
          case getKeyboardEventKey('ArrowRight', isKeySupported):
            axis = 'x';
            isForward = true;
            break;
          case getKeyboardEventKey('ArrowDown', isKeySupported):
            isForward = true;
            axis = 'y';
            break;
          case getKeyboardEventKey('Tab', isKeySupported):
            this._focusRoot();
            break;
        }
        if (axis) {
          e.preventDefault();
          const {
            currSlide
          } = pswp;
          if (pswp.options.arrowKeys && axis === 'x' && pswp.getNumItems() > 1) {
            keydownAction = isForward ? 'next' : 'prev';
          } else if (currSlide && currSlide.currZoomLevel > currSlide.zoomLevels.fit) {
            currSlide.pan[axis] += isForward ? -80 : 80;
            currSlide.panTo(currSlide.pan.x, currSlide.pan.y);
          }
        }
        if (keydownAction) {
          e.preventDefault();
          pswp[keydownAction]();
        }
      }
      _onFocusIn(e) {
        const {
          template
        } = this.pswp;
        if (template && document !== e.target && template !== e.target && !template.contains(e.target)) {
          template.focus();
        }
      }
    }
    const DEFAULT_EASING = 'cubic-bezier(.4,0,.22,1)';
    class CSSAnimation {
      constructor(props) {
        var _props$prop;
        this.props = props;
        const {
          target,
          onComplete,
          transform,
          onFinish = () => {},
          duration = 333,
          easing = DEFAULT_EASING
        } = props;
        this.onFinish = onFinish;
        const prop = transform ? 'transform' : 'opacity';
        const propValue = (_props$prop = props[prop]) !== null && _props$prop !== void 0 ? _props$prop : '';
        this._target = target;
        this._onComplete = onComplete;
        this._finished = false;
        this._onTransitionEnd = this._onTransitionEnd.bind(this);
        this._helperTimeout = setTimeout(() => {
          setTransitionStyle(target, prop, duration, easing);
          this._helperTimeout = setTimeout(() => {
            target.addEventListener('transitionend', this._onTransitionEnd, false);
            target.addEventListener('transitioncancel', this._onTransitionEnd, false);
            this._helperTimeout = setTimeout(() => {
              this._finalizeAnimation();
            }, duration + 500);
            target.style[prop] = propValue;
          }, 30);
        }, 0);
      }
      _onTransitionEnd(e) {
        if (e.target === this._target) {
          this._finalizeAnimation();
        }
      }
      _finalizeAnimation() {
        if (!this._finished) {
          this._finished = true;
          this.onFinish();
          if (this._onComplete) {
            this._onComplete();
          }
        }
      }
      destroy() {
        if (this._helperTimeout) {
          clearTimeout(this._helperTimeout);
        }
        removeTransitionStyle(this._target);
        this._target.removeEventListener('transitionend', this._onTransitionEnd, false);
        this._target.removeEventListener('transitioncancel', this._onTransitionEnd, false);
        if (!this._finished) {
          this._finalizeAnimation();
        }
      }
    }
    const DEFAULT_NATURAL_FREQUENCY = 12;
    const DEFAULT_DAMPING_RATIO = 0.75;
    class SpringEaser {
      constructor(initialVelocity, dampingRatio, naturalFrequency) {
        this.velocity = initialVelocity * 1000;
        this._dampingRatio = dampingRatio || DEFAULT_DAMPING_RATIO;
        this._naturalFrequency = naturalFrequency || DEFAULT_NATURAL_FREQUENCY;
        this._dampedFrequency = this._naturalFrequency;
        if (this._dampingRatio < 1) {
          this._dampedFrequency *= Math.sqrt(1 - this._dampingRatio * this._dampingRatio);
        }
      }
      easeFrame(deltaPosition, deltaTime) {
        let displacement = 0;
        let coeff;
        deltaTime /= 1000;
        const naturalDumpingPow = Math.E ** (-this._dampingRatio * this._naturalFrequency * deltaTime);
        if (this._dampingRatio === 1) {
          coeff = this.velocity + this._naturalFrequency * deltaPosition;
          displacement = (deltaPosition + coeff * deltaTime) * naturalDumpingPow;
          this.velocity = displacement * -this._naturalFrequency + coeff * naturalDumpingPow;
        } else if (this._dampingRatio < 1) {
          coeff = 1 / this._dampedFrequency * (this._dampingRatio * this._naturalFrequency * deltaPosition + this.velocity);
          const dumpedFCos = Math.cos(this._dampedFrequency * deltaTime);
          const dumpedFSin = Math.sin(this._dampedFrequency * deltaTime);
          displacement = naturalDumpingPow * (deltaPosition * dumpedFCos + coeff * dumpedFSin);
          this.velocity = displacement * -this._naturalFrequency * this._dampingRatio + naturalDumpingPow * (-this._dampedFrequency * deltaPosition * dumpedFSin + this._dampedFrequency * coeff * dumpedFCos);
        }
        return displacement;
      }
    }
    class SpringAnimation {
      constructor(props) {
        this.props = props;
        this._raf = 0;
        const {
          start,
          end,
          velocity,
          onUpdate,
          onComplete,
          onFinish = () => {},
          dampingRatio,
          naturalFrequency
        } = props;
        this.onFinish = onFinish;
        const easer = new SpringEaser(velocity, dampingRatio, naturalFrequency);
        let prevTime = Date.now();
        let deltaPosition = start - end;
        const animationLoop = () => {
          if (this._raf) {
            deltaPosition = easer.easeFrame(deltaPosition, Date.now() - prevTime);
            if (Math.abs(deltaPosition) < 1 && Math.abs(easer.velocity) < 50) {
              onUpdate(end);
              if (onComplete) {
                onComplete();
              }
              this.onFinish();
            } else {
              prevTime = Date.now();
              onUpdate(deltaPosition + end);
              this._raf = requestAnimationFrame(animationLoop);
            }
          }
        };
        this._raf = requestAnimationFrame(animationLoop);
      }
      destroy() {
        if (this._raf >= 0) {
          cancelAnimationFrame(this._raf);
        }
        this._raf = 0;
      }
    }
    class Animations {
      constructor() {
        this.activeAnimations = [];
      }
      startSpring(props) {
        this._start(props, true);
      }
      startTransition(props) {
        this._start(props);
      }
      _start(props, isSpring) {
        const animation = isSpring ? new SpringAnimation(props) : new CSSAnimation(props);
        this.activeAnimations.push(animation);
        animation.onFinish = () => this.stop(animation);
        return animation;
      }
      stop(animation) {
        animation.destroy();
        const index = this.activeAnimations.indexOf(animation);
        if (index > -1) {
          this.activeAnimations.splice(index, 1);
        }
      }
      stopAll() {
        this.activeAnimations.forEach(animation => {
          animation.destroy();
        });
        this.activeAnimations = [];
      }
      stopAllPan() {
        this.activeAnimations = this.activeAnimations.filter(animation => {
          if (animation.props.isPan) {
            animation.destroy();
            return false;
          }
          return true;
        });
      }
      stopMainScroll() {
        this.activeAnimations = this.activeAnimations.filter(animation => {
          if (animation.props.isMainScroll) {
            animation.destroy();
            return false;
          }
          return true;
        });
      }
      isPanRunning() {
        return this.activeAnimations.some(animation => {
          return animation.props.isPan;
        });
      }
    }
    class ScrollWheel {
      constructor(pswp) {
        this.pswp = pswp;
        pswp.events.add(pswp.element, 'wheel', this._onWheel.bind(this));
      }
      _onWheel(e) {
        e.preventDefault();
        const {
          currSlide
        } = this.pswp;
        let {
          deltaX,
          deltaY
        } = e;
        if (!currSlide) {
          return;
        }
        if (this.pswp.dispatch('wheel', {
          originalEvent: e
        }).defaultPrevented) {
          return;
        }
        if (e.ctrlKey || this.pswp.options.wheelToZoom) {
          if (currSlide.isZoomable()) {
            let zoomFactor = -deltaY;
            if (e.deltaMode === 1) {
              zoomFactor *= 0.05;
            } else {
              zoomFactor *= e.deltaMode ? 1 : 0.002;
            }
            zoomFactor = 2 ** zoomFactor;
            const destZoomLevel = currSlide.currZoomLevel * zoomFactor;
            currSlide.zoomTo(destZoomLevel, {
              x: e.clientX,
              y: e.clientY
            });
          }
        } else {
          if (currSlide.isPannable()) {
            if (e.deltaMode === 1) {
              deltaX *= 18;
              deltaY *= 18;
            }
            currSlide.panTo(currSlide.pan.x - deltaX, currSlide.pan.y - deltaY);
          }
        }
      }
    }
    function addElementHTML(htmlData) {
      if (typeof htmlData === 'string') {
        return htmlData;
      }
      if (!htmlData || !htmlData.isCustomSVG) {
        return '';
      }
      const svgData = htmlData;
      let out = '<svg aria-hidden="true" class="pswp__icn" viewBox="0 0 %d %d" width="%d" height="%d">';
      out = out.split('%d').join(svgData.size || 32);
      if (svgData.outlineID) {
        out += '<use class="pswp__icn-shadow" xlink:href="#' + svgData.outlineID + '"/>';
      }
      out += svgData.inner;
      out += '</svg>';
      return out;
    }
    class UIElement {
      constructor(pswp, data) {
        var _container;
        const name = data.name || data.className;
        let elementHTML = data.html;
        if (pswp.options[name] === false) {
          return;
        }
        if (typeof pswp.options[name + 'SVG'] === 'string') {
          elementHTML = pswp.options[name + 'SVG'];
        }
        pswp.dispatch('uiElementCreate', {
          data
        });
        let className = '';
        if (data.isButton) {
          className += 'pswp__button ';
          className += data.className || `pswp__button--${data.name}`;
        } else {
          className += data.className || `pswp__${data.name}`;
        }
        let tagName = data.isButton ? data.tagName || 'button' : data.tagName || 'div';
        tagName = tagName.toLowerCase();
        const element = createElement$1(className, tagName);
        if (data.isButton) {
          if (tagName === 'button') {
            element.type = 'button';
          }
          let {
            title
          } = data;
          const {
            ariaLabel
          } = data;
          if (typeof pswp.options[name + 'Title'] === 'string') {
            title = pswp.options[name + 'Title'];
          }
          if (title) {
            element.title = title;
          }
          const ariaText = ariaLabel || title;
          if (ariaText) {
            element.setAttribute('aria-label', ariaText);
          }
        }
        element.innerHTML = addElementHTML(elementHTML);
        if (data.onInit) {
          data.onInit(element, pswp);
        }
        if (data.onClick) {
          element.onclick = e => {
            if (typeof data.onClick === 'string') {
              pswp[data.onClick]();
            } else if (typeof data.onClick === 'function') {
              data.onClick(e, element, pswp);
            }
          };
        }
        const appendTo = data.appendTo || 'bar';
        let container = pswp.element;
        if (appendTo === 'bar') {
          if (!pswp.topBar) {
            pswp.topBar = createElement$1('pswp__top-bar pswp__hide-on-close', 'div', pswp.scrollWrap);
          }
          container = pswp.topBar;
        } else {
          element.classList.add('pswp__hide-on-close');
          if (appendTo === 'wrapper') {
            container = pswp.scrollWrap;
          }
        }
        (_container = container) === null || _container === void 0 || _container.appendChild(pswp.applyFilters('uiElement', element, data));
      }
    }
    function initArrowButton(element, pswp, isNextButton) {
      element.classList.add('pswp__button--arrow');
      element.setAttribute('aria-controls', 'pswp__items');
      pswp.on('change', () => {
        if (!pswp.options.loop) {
          if (isNextButton) {
            element.disabled = !(pswp.currIndex < pswp.getNumItems() - 1);
          } else {
            element.disabled = !(pswp.currIndex > 0);
          }
        }
      });
    }
    const arrowPrev = {
      name: 'arrowPrev',
      className: 'pswp__button--arrow--prev',
      title: 'Previous',
      order: 10,
      isButton: true,
      appendTo: 'wrapper',
      html: {
        isCustomSVG: true,
        size: 60,
        inner: '<path d="M29 43l-3 3-16-16 16-16 3 3-13 13 13 13z" id="pswp__icn-arrow"/>',
        outlineID: 'pswp__icn-arrow'
      },
      onClick: 'prev',
      onInit: initArrowButton
    };
    const arrowNext = {
      name: 'arrowNext',
      className: 'pswp__button--arrow--next',
      title: 'Next',
      order: 11,
      isButton: true,
      appendTo: 'wrapper',
      html: {
        isCustomSVG: true,
        size: 60,
        inner: '<use xlink:href="#pswp__icn-arrow"/>',
        outlineID: 'pswp__icn-arrow'
      },
      onClick: 'next',
      onInit: (el, pswp) => {
        initArrowButton(el, pswp, true);
      }
    };
    const closeButton = {
      name: 'close',
      title: 'Close',
      order: 20,
      isButton: true,
      html: {
        isCustomSVG: true,
        inner: '<path d="M24 10l-2-2-6 6-6-6-2 2 6 6-6 6 2 2 6-6 6 6 2-2-6-6z" id="pswp__icn-close"/>',
        outlineID: 'pswp__icn-close'
      },
      onClick: 'close'
    };
    const zoomButton = {
      name: 'zoom',
      title: 'Zoom',
      order: 10,
      isButton: true,
      html: {
        isCustomSVG: true,
        inner: '<path d="M17.426 19.926a6 6 0 1 1 1.5-1.5L23 22.5 21.5 24l-4.074-4.074z" id="pswp__icn-zoom"/>' + '<path fill="currentColor" class="pswp__zoom-icn-bar-h" d="M11 16v-2h6v2z"/>' + '<path fill="currentColor" class="pswp__zoom-icn-bar-v" d="M13 12h2v6h-2z"/>',
        outlineID: 'pswp__icn-zoom'
      },
      onClick: 'toggleZoom'
    };
    const loadingIndicator = {
      name: 'preloader',
      appendTo: 'bar',
      order: 7,
      html: {
        isCustomSVG: true,
        inner: '<path fill-rule="evenodd" clip-rule="evenodd" d="M21.2 16a5.2 5.2 0 1 1-5.2-5.2V8a8 8 0 1 0 8 8h-2.8Z" id="pswp__icn-loading"/>',
        outlineID: 'pswp__icn-loading'
      },
      onInit: (indicatorElement, pswp) => {
        let isVisible;
        let delayTimeout = null;
        const toggleIndicatorClass = (className, add) => {
          indicatorElement.classList.toggle('pswp__preloader--' + className, add);
        };
        const setIndicatorVisibility = visible => {
          if (isVisible !== visible) {
            isVisible = visible;
            toggleIndicatorClass('active', visible);
          }
        };
        const updatePreloaderVisibility = () => {
          var _pswp$currSlide;
          if (!((_pswp$currSlide = pswp.currSlide) !== null && _pswp$currSlide !== void 0 && _pswp$currSlide.content.isLoading())) {
            setIndicatorVisibility(false);
            if (delayTimeout) {
              clearTimeout(delayTimeout);
              delayTimeout = null;
            }
            return;
          }
          if (!delayTimeout) {
            delayTimeout = setTimeout(() => {
              var _pswp$currSlide2;
              setIndicatorVisibility(Boolean((_pswp$currSlide2 = pswp.currSlide) === null || _pswp$currSlide2 === void 0 ? void 0 : _pswp$currSlide2.content.isLoading()));
              delayTimeout = null;
            }, pswp.options.preloaderDelay);
          }
        };
        pswp.on('change', updatePreloaderVisibility);
        pswp.on('loadComplete', e => {
          if (pswp.currSlide === e.slide) {
            updatePreloaderVisibility();
          }
        });
        if (pswp.ui) {
          pswp.ui.updatePreloaderVisibility = updatePreloaderVisibility;
        }
      }
    };
    const counterIndicator = {
      name: 'counter',
      order: 5,
      onInit: (counterElement, pswp) => {
        pswp.on('change', () => {
          counterElement.innerText = pswp.currIndex + 1 + pswp.options.indexIndicatorSep + pswp.getNumItems();
        });
      }
    };
    function setZoomedIn(el, isZoomedIn) {
      el.classList.toggle('pswp--zoomed-in', isZoomedIn);
    }
    class UI {
      constructor(pswp) {
        this.pswp = pswp;
        this.isRegistered = false;
        this.uiElementsData = [];
        this.items = [];
        this.updatePreloaderVisibility = () => {};
        this._lastUpdatedZoomLevel = undefined;
      }
      init() {
        const {
          pswp
        } = this;
        this.isRegistered = false;
        this.uiElementsData = [closeButton, arrowPrev, arrowNext, zoomButton, loadingIndicator, counterIndicator];
        pswp.dispatch('uiRegister');
        this.uiElementsData.sort((a, b) => {
          return (a.order || 0) - (b.order || 0);
        });
        this.items = [];
        this.isRegistered = true;
        this.uiElementsData.forEach(uiElementData => {
          this.registerElement(uiElementData);
        });
        pswp.on('change', () => {
          var _pswp$element;
          (_pswp$element = pswp.element) === null || _pswp$element === void 0 || _pswp$element.classList.toggle('pswp--one-slide', pswp.getNumItems() === 1);
        });
        pswp.on('zoomPanUpdate', () => this._onZoomPanUpdate());
      }
      registerElement(elementData) {
        if (this.isRegistered) {
          this.items.push(new UIElement(this.pswp, elementData));
        } else {
          this.uiElementsData.push(elementData);
        }
      }
      _onZoomPanUpdate() {
        const {
          template,
          currSlide,
          options
        } = this.pswp;
        if (this.pswp.opener.isClosing || !template || !currSlide) {
          return;
        }
        let {
          currZoomLevel
        } = currSlide;
        if (!this.pswp.opener.isOpen) {
          currZoomLevel = currSlide.zoomLevels.initial;
        }
        if (currZoomLevel === this._lastUpdatedZoomLevel) {
          return;
        }
        this._lastUpdatedZoomLevel = currZoomLevel;
        const currZoomLevelDiff = currSlide.zoomLevels.initial - currSlide.zoomLevels.secondary;
        if (Math.abs(currZoomLevelDiff) < 0.01 || !currSlide.isZoomable()) {
          setZoomedIn(template, false);
          template.classList.remove('pswp--zoom-allowed');
          return;
        }
        template.classList.add('pswp--zoom-allowed');
        const potentialZoomLevel = currZoomLevel === currSlide.zoomLevels.initial ? currSlide.zoomLevels.secondary : currSlide.zoomLevels.initial;
        setZoomedIn(template, potentialZoomLevel <= currZoomLevel);
        if (options.imageClickAction === 'zoom' || options.imageClickAction === 'zoom-or-close') {
          template.classList.add('pswp--click-to-zoom');
        }
      }
    }
    function getBoundsByElement(el) {
      const thumbAreaRect = el.getBoundingClientRect();
      return {
        x: thumbAreaRect.left,
        y: thumbAreaRect.top,
        w: thumbAreaRect.width
      };
    }
    function getCroppedBoundsByElement(el, imageWidth, imageHeight) {
      const thumbAreaRect = el.getBoundingClientRect();
      const hRatio = thumbAreaRect.width / imageWidth;
      const vRatio = thumbAreaRect.height / imageHeight;
      const fillZoomLevel = hRatio > vRatio ? hRatio : vRatio;
      const offsetX = (thumbAreaRect.width - imageWidth * fillZoomLevel) / 2;
      const offsetY = (thumbAreaRect.height - imageHeight * fillZoomLevel) / 2;
      const bounds = {
        x: thumbAreaRect.left + offsetX,
        y: thumbAreaRect.top + offsetY,
        w: imageWidth * fillZoomLevel
      };
      bounds.innerRect = {
        w: thumbAreaRect.width,
        h: thumbAreaRect.height,
        x: offsetX,
        y: offsetY
      };
      return bounds;
    }
    function getThumbBounds(index, itemData, instance) {
      const event = instance.dispatch('thumbBounds', {
        index,
        itemData,
        instance
      });
      if (event.thumbBounds) {
        return event.thumbBounds;
      }
      const {
        element
      } = itemData;
      let thumbBounds;
      let thumbnail;
      if (element && instance.options.thumbSelector !== false) {
        const thumbSelector = instance.options.thumbSelector || 'img';
        thumbnail = element.matches(thumbSelector) ? element : element.querySelector(thumbSelector);
      }
      thumbnail = instance.applyFilters('thumbEl', thumbnail, itemData, index);
      if (thumbnail) {
        if (!itemData.thumbCropped) {
          thumbBounds = getBoundsByElement(thumbnail);
        } else {
          thumbBounds = getCroppedBoundsByElement(thumbnail, itemData.width || itemData.w || 0, itemData.height || itemData.h || 0);
        }
      }
      return instance.applyFilters('thumbBounds', thumbBounds, itemData, index);
    }
    let PhotoSwipeEvent$1 = class PhotoSwipeEvent {
      constructor(type, details) {
        this.type = type;
        this.defaultPrevented = false;
        if (details) {
          Object.assign(this, details);
        }
      }
      preventDefault() {
        this.defaultPrevented = true;
      }
    };
    let Eventable$1 = class Eventable {
      constructor() {
        this._listeners = {};
        this._filters = {};
        this.pswp = undefined;
        this.options = undefined;
      }
      addFilter(name, fn, priority = 100) {
        var _this$_filters$name, _this$_filters$name2, _this$pswp;
        if (!this._filters[name]) {
          this._filters[name] = [];
        }
        (_this$_filters$name = this._filters[name]) === null || _this$_filters$name === void 0 || _this$_filters$name.push({
          fn,
          priority
        });
        (_this$_filters$name2 = this._filters[name]) === null || _this$_filters$name2 === void 0 || _this$_filters$name2.sort((f1, f2) => f1.priority - f2.priority);
        (_this$pswp = this.pswp) === null || _this$pswp === void 0 || _this$pswp.addFilter(name, fn, priority);
      }
      removeFilter(name, fn) {
        if (this._filters[name]) {
          this._filters[name] = this._filters[name].filter(filter => filter.fn !== fn);
        }
        if (this.pswp) {
          this.pswp.removeFilter(name, fn);
        }
      }
      applyFilters(name, ...args) {
        var _this$_filters$name3;
        (_this$_filters$name3 = this._filters[name]) === null || _this$_filters$name3 === void 0 || _this$_filters$name3.forEach(filter => {
          args[0] = filter.fn.apply(this, args);
        });
        return args[0];
      }
      on(name, fn) {
        var _this$_listeners$name, _this$pswp2;
        if (!this._listeners[name]) {
          this._listeners[name] = [];
        }
        (_this$_listeners$name = this._listeners[name]) === null || _this$_listeners$name === void 0 || _this$_listeners$name.push(fn);
        (_this$pswp2 = this.pswp) === null || _this$pswp2 === void 0 || _this$pswp2.on(name, fn);
      }
      off(name, fn) {
        var _this$pswp3;
        if (this._listeners[name]) {
          this._listeners[name] = this._listeners[name].filter(listener => fn !== listener);
        }
        (_this$pswp3 = this.pswp) === null || _this$pswp3 === void 0 || _this$pswp3.off(name, fn);
      }
      dispatch(name, details) {
        var _this$_listeners$name2;
        if (this.pswp) {
          return this.pswp.dispatch(name, details);
        }
        const event = new PhotoSwipeEvent$1(name, details);
        (_this$_listeners$name2 = this._listeners[name]) === null || _this$_listeners$name2 === void 0 || _this$_listeners$name2.forEach(listener => {
          listener.call(this, event);
        });
        return event;
      }
    };
    let Placeholder$1 = class Placeholder {
      constructor(imageSrc, container) {
        this.element = createElement$1('pswp__img pswp__img--placeholder', imageSrc ? 'img' : 'div', container);
        if (imageSrc) {
          const imgEl = this.element;
          imgEl.decoding = 'async';
          imgEl.alt = '';
          imgEl.src = imageSrc;
          imgEl.setAttribute('role', 'presentation');
        }
        this.element.setAttribute('aria-hidden', 'true');
      }
      setDisplayedSize(width, height) {
        if (!this.element) {
          return;
        }
        if (this.element.tagName === 'IMG') {
          setWidthHeight$1(this.element, 250, 'auto');
          this.element.style.transformOrigin = '0 0';
          this.element.style.transform = toTransformString$1(0, 0, width / 250);
        } else {
          setWidthHeight$1(this.element, width, height);
        }
      }
      destroy() {
        var _this$element;
        if ((_this$element = this.element) !== null && _this$element !== void 0 && _this$element.parentNode) {
          this.element.remove();
        }
        this.element = null;
      }
    };
    let Content$1 = class Content {
      constructor(itemData, instance, index) {
        this.instance = instance;
        this.data = itemData;
        this.index = index;
        this.element = undefined;
        this.placeholder = undefined;
        this.slide = undefined;
        this.displayedImageWidth = 0;
        this.displayedImageHeight = 0;
        this.width = Number(this.data.w) || Number(this.data.width) || 0;
        this.height = Number(this.data.h) || Number(this.data.height) || 0;
        this.isAttached = false;
        this.hasSlide = false;
        this.isDecoding = false;
        this.state = LOAD_STATE$1.IDLE;
        if (this.data.type) {
          this.type = this.data.type;
        } else if (this.data.src) {
          this.type = 'image';
        } else {
          this.type = 'html';
        }
        this.instance.dispatch('contentInit', {
          content: this
        });
      }
      removePlaceholder() {
        if (this.placeholder && !this.keepPlaceholder()) {
          setTimeout(() => {
            if (this.placeholder) {
              this.placeholder.destroy();
              this.placeholder = undefined;
            }
          }, 1000);
        }
      }
      load(isLazy, reload) {
        if (this.slide && this.usePlaceholder()) {
          if (!this.placeholder) {
            const placeholderSrc = this.instance.applyFilters('placeholderSrc', this.data.msrc && this.slide.isFirstSlide ? this.data.msrc : false, this);
            this.placeholder = new Placeholder$1(placeholderSrc, this.slide.container);
          } else {
            const placeholderEl = this.placeholder.element;
            if (placeholderEl && !placeholderEl.parentElement) {
              this.slide.container.prepend(placeholderEl);
            }
          }
        }
        if (this.element && !reload) {
          return;
        }
        if (this.instance.dispatch('contentLoad', {
          content: this,
          isLazy
        }).defaultPrevented) {
          return;
        }
        if (this.isImageContent()) {
          this.element = createElement$1('pswp__img', 'img');
          if (this.displayedImageWidth) {
            this.loadImage(isLazy);
          }
        } else {
          this.element = createElement$1('pswp__content', 'div');
          this.element.innerHTML = this.data.html || '';
        }
        if (reload && this.slide) {
          this.slide.updateContentSize(true);
        }
      }
      loadImage(isLazy) {
        var _this$data$src, _this$data$alt;
        if (!this.isImageContent() || !this.element || this.instance.dispatch('contentLoadImage', {
          content: this,
          isLazy
        }).defaultPrevented) {
          return;
        }
        const imageElement = this.element;
        this.updateSrcsetSizes();
        if (this.data.srcset) {
          imageElement.srcset = this.data.srcset;
        }
        imageElement.src = (_this$data$src = this.data.src) !== null && _this$data$src !== void 0 ? _this$data$src : '';
        imageElement.alt = (_this$data$alt = this.data.alt) !== null && _this$data$alt !== void 0 ? _this$data$alt : '';
        this.state = LOAD_STATE$1.LOADING;
        if (imageElement.complete) {
          this.onLoaded();
        } else {
          imageElement.onload = () => {
            this.onLoaded();
          };
          imageElement.onerror = () => {
            this.onError();
          };
        }
      }
      setSlide(slide) {
        this.slide = slide;
        this.hasSlide = true;
        this.instance = slide.pswp;
      }
      onLoaded() {
        this.state = LOAD_STATE$1.LOADED;
        if (this.slide && this.element) {
          this.instance.dispatch('loadComplete', {
            slide: this.slide,
            content: this
          });
          if (this.slide.isActive && this.slide.heavyAppended && !this.element.parentNode) {
            this.append();
            this.slide.updateContentSize(true);
          }
          if (this.state === LOAD_STATE$1.LOADED || this.state === LOAD_STATE$1.ERROR) {
            this.removePlaceholder();
          }
        }
      }
      onError() {
        this.state = LOAD_STATE$1.ERROR;
        if (this.slide) {
          this.displayError();
          this.instance.dispatch('loadComplete', {
            slide: this.slide,
            isError: true,
            content: this
          });
          this.instance.dispatch('loadError', {
            slide: this.slide,
            content: this
          });
        }
      }
      isLoading() {
        return this.instance.applyFilters('isContentLoading', this.state === LOAD_STATE$1.LOADING, this);
      }
      isError() {
        return this.state === LOAD_STATE$1.ERROR;
      }
      isImageContent() {
        return this.type === 'image';
      }
      setDisplayedSize(width, height) {
        if (!this.element) {
          return;
        }
        if (this.placeholder) {
          this.placeholder.setDisplayedSize(width, height);
        }
        if (this.instance.dispatch('contentResize', {
          content: this,
          width,
          height
        }).defaultPrevented) {
          return;
        }
        setWidthHeight$1(this.element, width, height);
        if (this.isImageContent() && !this.isError()) {
          const isInitialSizeUpdate = !this.displayedImageWidth && width;
          this.displayedImageWidth = width;
          this.displayedImageHeight = height;
          if (isInitialSizeUpdate) {
            this.loadImage(false);
          } else {
            this.updateSrcsetSizes();
          }
          if (this.slide) {
            this.instance.dispatch('imageSizeChange', {
              slide: this.slide,
              width,
              height,
              content: this
            });
          }
        }
      }
      isZoomable() {
        return this.instance.applyFilters('isContentZoomable', this.isImageContent() && this.state !== LOAD_STATE$1.ERROR, this);
      }
      updateSrcsetSizes() {
        if (!this.isImageContent() || !this.element || !this.data.srcset) {
          return;
        }
        const image = this.element;
        const sizesWidth = this.instance.applyFilters('srcsetSizesWidth', this.displayedImageWidth, this);
        if (!image.dataset.largestUsedSize || sizesWidth > parseInt(image.dataset.largestUsedSize, 10)) {
          image.sizes = sizesWidth + 'px';
          image.dataset.largestUsedSize = String(sizesWidth);
        }
      }
      usePlaceholder() {
        return this.instance.applyFilters('useContentPlaceholder', this.isImageContent(), this);
      }
      lazyLoad() {
        if (this.instance.dispatch('contentLazyLoad', {
          content: this
        }).defaultPrevented) {
          return;
        }
        this.load(true);
      }
      keepPlaceholder() {
        return this.instance.applyFilters('isKeepingPlaceholder', this.isLoading(), this);
      }
      destroy() {
        this.hasSlide = false;
        this.slide = undefined;
        if (this.instance.dispatch('contentDestroy', {
          content: this
        }).defaultPrevented) {
          return;
        }
        this.remove();
        if (this.placeholder) {
          this.placeholder.destroy();
          this.placeholder = undefined;
        }
        if (this.isImageContent() && this.element) {
          this.element.onload = null;
          this.element.onerror = null;
          this.element = undefined;
        }
      }
      displayError() {
        if (this.slide) {
          var _this$instance$option, _this$instance$option2;
          let errorMsgEl = createElement$1('pswp__error-msg', 'div');
          errorMsgEl.innerText = (_this$instance$option = (_this$instance$option2 = this.instance.options) === null || _this$instance$option2 === void 0 ? void 0 : _this$instance$option2.errorMsg) !== null && _this$instance$option !== void 0 ? _this$instance$option : '';
          errorMsgEl = this.instance.applyFilters('contentErrorElement', errorMsgEl, this);
          this.element = createElement$1('pswp__content pswp__error-msg-container', 'div');
          this.element.appendChild(errorMsgEl);
          this.slide.container.innerText = '';
          this.slide.container.appendChild(this.element);
          this.slide.updateContentSize(true);
          this.removePlaceholder();
        }
      }
      append() {
        if (this.isAttached || !this.element) {
          return;
        }
        this.isAttached = true;
        if (this.state === LOAD_STATE$1.ERROR) {
          this.displayError();
          return;
        }
        if (this.instance.dispatch('contentAppend', {
          content: this
        }).defaultPrevented) {
          return;
        }
        const supportsDecode = 'decode' in this.element;
        if (this.isImageContent()) {
          if (supportsDecode && this.slide && (!this.slide.isActive || isSafari$1())) {
            this.isDecoding = true;
            this.element.decode().catch(() => {}).finally(() => {
              this.isDecoding = false;
              this.appendImage();
            });
          } else {
            this.appendImage();
          }
        } else if (this.slide && !this.element.parentNode) {
          this.slide.container.appendChild(this.element);
        }
      }
      activate() {
        if (this.instance.dispatch('contentActivate', {
          content: this
        }).defaultPrevented || !this.slide) {
          return;
        }
        if (this.isImageContent() && this.isDecoding && !isSafari$1()) {
          this.appendImage();
        } else if (this.isError()) {
          this.load(false, true);
        }
        if (this.slide.holderElement) {
          this.slide.holderElement.setAttribute('aria-hidden', 'false');
        }
      }
      deactivate() {
        this.instance.dispatch('contentDeactivate', {
          content: this
        });
        if (this.slide && this.slide.holderElement) {
          this.slide.holderElement.setAttribute('aria-hidden', 'true');
        }
      }
      remove() {
        this.isAttached = false;
        if (this.instance.dispatch('contentRemove', {
          content: this
        }).defaultPrevented) {
          return;
        }
        if (this.element && this.element.parentNode) {
          this.element.remove();
        }
        if (this.placeholder && this.placeholder.element) {
          this.placeholder.element.remove();
        }
      }
      appendImage() {
        if (!this.isAttached) {
          return;
        }
        if (this.instance.dispatch('contentAppendImage', {
          content: this
        }).defaultPrevented) {
          return;
        }
        if (this.slide && this.element && !this.element.parentNode) {
          this.slide.container.appendChild(this.element);
        }
        if (this.state === LOAD_STATE$1.LOADED || this.state === LOAD_STATE$1.ERROR) {
          this.removePlaceholder();
        }
      }
    };
    const MIN_SLIDES_TO_CACHE = 5;
    function lazyLoadData$1(itemData, instance, index) {
      const content = instance.createContentFromData(itemData, index);
      let zoomLevel;
      const {
        options
      } = instance;
      if (options) {
        zoomLevel = new ZoomLevel$1(options, itemData, -1);
        let viewportSize;
        if (instance.pswp) {
          viewportSize = instance.pswp.viewportSize;
        } else {
          viewportSize = getViewportSize$1(options, instance);
        }
        const panAreaSize = getPanAreaSize$1(options, viewportSize, itemData, index);
        zoomLevel.update(content.width, content.height, panAreaSize);
      }
      content.lazyLoad();
      if (zoomLevel) {
        content.setDisplayedSize(Math.ceil(content.width * zoomLevel.initial), Math.ceil(content.height * zoomLevel.initial));
      }
      return content;
    }
    function lazyLoadSlide$1(index, instance) {
      const itemData = instance.getItemData(index);
      if (instance.dispatch('lazyLoadSlide', {
        index,
        itemData
      }).defaultPrevented) {
        return;
      }
      return lazyLoadData$1(itemData, instance, index);
    }
    class ContentLoader {
      constructor(pswp) {
        this.pswp = pswp;
        this.limit = Math.max(pswp.options.preload[0] + pswp.options.preload[1] + 1, MIN_SLIDES_TO_CACHE);
        this._cachedItems = [];
      }
      updateLazy(diff) {
        const {
          pswp
        } = this;
        if (pswp.dispatch('lazyLoad').defaultPrevented) {
          return;
        }
        const {
          preload
        } = pswp.options;
        const isForward = diff === undefined ? true : diff >= 0;
        let i;
        for (i = 0; i <= preload[1]; i++) {
          this.loadSlideByIndex(pswp.currIndex + (isForward ? i : -i));
        }
        for (i = 1; i <= preload[0]; i++) {
          this.loadSlideByIndex(pswp.currIndex + (isForward ? -i : i));
        }
      }
      loadSlideByIndex(initialIndex) {
        const index = this.pswp.getLoopedIndex(initialIndex);
        let content = this.getContentByIndex(index);
        if (!content) {
          content = lazyLoadSlide$1(index, this.pswp);
          if (content) {
            this.addToCache(content);
          }
        }
      }
      getContentBySlide(slide) {
        let content = this.getContentByIndex(slide.index);
        if (!content) {
          content = this.pswp.createContentFromData(slide.data, slide.index);
          this.addToCache(content);
        }
        content.setSlide(slide);
        return content;
      }
      addToCache(content) {
        this.removeByIndex(content.index);
        this._cachedItems.push(content);
        if (this._cachedItems.length > this.limit) {
          const indexToRemove = this._cachedItems.findIndex(item => {
            return !item.isAttached && !item.hasSlide;
          });
          if (indexToRemove !== -1) {
            const removedItem = this._cachedItems.splice(indexToRemove, 1)[0];
            removedItem.destroy();
          }
        }
      }
      removeByIndex(index) {
        const indexToRemove = this._cachedItems.findIndex(item => item.index === index);
        if (indexToRemove !== -1) {
          this._cachedItems.splice(indexToRemove, 1);
        }
      }
      getContentByIndex(index) {
        return this._cachedItems.find(content => content.index === index);
      }
      destroy() {
        this._cachedItems.forEach(content => content.destroy());
        this._cachedItems = [];
      }
    }
    let PhotoSwipeBase$1 = class PhotoSwipeBase extends Eventable$1 {
      getNumItems() {
        var _this$options;
        let numItems = 0;
        const dataSource = (_this$options = this.options) === null || _this$options === void 0 ? void 0 : _this$options.dataSource;
        if (dataSource && 'length' in dataSource) {
          numItems = dataSource.length;
        } else if (dataSource && 'gallery' in dataSource) {
          if (!dataSource.items) {
            dataSource.items = this._getGalleryDOMElements(dataSource.gallery);
          }
          if (dataSource.items) {
            numItems = dataSource.items.length;
          }
        }
        const event = this.dispatch('numItems', {
          dataSource,
          numItems
        });
        return this.applyFilters('numItems', event.numItems, dataSource);
      }
      createContentFromData(slideData, index) {
        return new Content$1(slideData, this, index);
      }
      getItemData(index) {
        var _this$options2;
        const dataSource = (_this$options2 = this.options) === null || _this$options2 === void 0 ? void 0 : _this$options2.dataSource;
        let dataSourceItem = {};
        if (Array.isArray(dataSource)) {
          dataSourceItem = dataSource[index];
        } else if (dataSource && 'gallery' in dataSource) {
          if (!dataSource.items) {
            dataSource.items = this._getGalleryDOMElements(dataSource.gallery);
          }
          dataSourceItem = dataSource.items[index];
        }
        let itemData = dataSourceItem;
        if (itemData instanceof Element) {
          itemData = this._domElementToItemData(itemData);
        }
        const event = this.dispatch('itemData', {
          itemData: itemData || {},
          index
        });
        return this.applyFilters('itemData', event.itemData, index);
      }
      _getGalleryDOMElements(galleryElement) {
        var _this$options3, _this$options4;
        if ((_this$options3 = this.options) !== null && _this$options3 !== void 0 && _this$options3.children || (_this$options4 = this.options) !== null && _this$options4 !== void 0 && _this$options4.childSelector) {
          return getElementsFromOption$1(this.options.children, this.options.childSelector, galleryElement) || [];
        }
        return [galleryElement];
      }
      _domElementToItemData(element) {
        const itemData = {
          element
        };
        const linkEl = element.tagName === 'A' ? element : element.querySelector('a');
        if (linkEl) {
          itemData.src = linkEl.dataset.pswpSrc || linkEl.href;
          if (linkEl.dataset.pswpSrcset) {
            itemData.srcset = linkEl.dataset.pswpSrcset;
          }
          itemData.width = linkEl.dataset.pswpWidth ? parseInt(linkEl.dataset.pswpWidth, 10) : 0;
          itemData.height = linkEl.dataset.pswpHeight ? parseInt(linkEl.dataset.pswpHeight, 10) : 0;
          itemData.w = itemData.width;
          itemData.h = itemData.height;
          if (linkEl.dataset.pswpType) {
            itemData.type = linkEl.dataset.pswpType;
          }
          const thumbnailEl = element.querySelector('img');
          if (thumbnailEl) {
            var _thumbnailEl$getAttri;
            itemData.msrc = thumbnailEl.currentSrc || thumbnailEl.src;
            itemData.alt = (_thumbnailEl$getAttri = thumbnailEl.getAttribute('alt')) !== null && _thumbnailEl$getAttri !== void 0 ? _thumbnailEl$getAttri : '';
          }
          if (linkEl.dataset.pswpCropped || linkEl.dataset.cropped) {
            itemData.thumbCropped = true;
          }
        }
        return this.applyFilters('domItemData', itemData, element, linkEl);
      }
      lazyLoadData(itemData, index) {
        return lazyLoadData$1(itemData, this, index);
      }
    };
    const MIN_OPACITY = 0.003;
    class Opener {
      constructor(pswp) {
        this.pswp = pswp;
        this.isClosed = true;
        this.isOpen = false;
        this.isClosing = false;
        this.isOpening = false;
        this._duration = undefined;
        this._useAnimation = false;
        this._croppedZoom = false;
        this._animateRootOpacity = false;
        this._animateBgOpacity = false;
        this._placeholder = undefined;
        this._opacityElement = undefined;
        this._cropContainer1 = undefined;
        this._cropContainer2 = undefined;
        this._thumbBounds = undefined;
        this._prepareOpen = this._prepareOpen.bind(this);
        pswp.on('firstZoomPan', this._prepareOpen);
      }
      open() {
        this._prepareOpen();
        this._start();
      }
      close() {
        if (this.isClosed || this.isClosing || this.isOpening) {
          return;
        }
        const slide = this.pswp.currSlide;
        this.isOpen = false;
        this.isOpening = false;
        this.isClosing = true;
        this._duration = this.pswp.options.hideAnimationDuration;
        if (slide && slide.currZoomLevel * slide.width >= this.pswp.options.maxWidthToAnimate) {
          this._duration = 0;
        }
        this._applyStartProps();
        setTimeout(() => {
          this._start();
        }, this._croppedZoom ? 30 : 0);
      }
      _prepareOpen() {
        this.pswp.off('firstZoomPan', this._prepareOpen);
        if (!this.isOpening) {
          const slide = this.pswp.currSlide;
          this.isOpening = true;
          this.isClosing = false;
          this._duration = this.pswp.options.showAnimationDuration;
          if (slide && slide.zoomLevels.initial * slide.width >= this.pswp.options.maxWidthToAnimate) {
            this._duration = 0;
          }
          this._applyStartProps();
        }
      }
      _applyStartProps() {
        const {
          pswp
        } = this;
        const slide = this.pswp.currSlide;
        const {
          options
        } = pswp;
        if (options.showHideAnimationType === 'fade') {
          options.showHideOpacity = true;
          this._thumbBounds = undefined;
        } else if (options.showHideAnimationType === 'none') {
          options.showHideOpacity = false;
          this._duration = 0;
          this._thumbBounds = undefined;
        } else if (this.isOpening && pswp._initialThumbBounds) {
          this._thumbBounds = pswp._initialThumbBounds;
        } else {
          this._thumbBounds = this.pswp.getThumbBounds();
        }
        this._placeholder = slide === null || slide === void 0 ? void 0 : slide.getPlaceholderElement();
        pswp.animations.stopAll();
        this._useAnimation = Boolean(this._duration && this._duration > 50);
        this._animateZoom = Boolean(this._thumbBounds) && (slide === null || slide === void 0 ? void 0 : slide.content.usePlaceholder()) && (!this.isClosing || !pswp.mainScroll.isShifted());
        if (!this._animateZoom) {
          this._animateRootOpacity = true;
          if (this.isOpening && slide) {
            slide.zoomAndPanToInitial();
            slide.applyCurrentZoomPan();
          }
        } else {
          var _options$showHideOpac;
          this._animateRootOpacity = (_options$showHideOpac = options.showHideOpacity) !== null && _options$showHideOpac !== void 0 ? _options$showHideOpac : false;
        }
        this._animateBgOpacity = !this._animateRootOpacity && this.pswp.options.bgOpacity > MIN_OPACITY;
        this._opacityElement = this._animateRootOpacity ? pswp.element : pswp.bg;
        if (!this._useAnimation) {
          this._duration = 0;
          this._animateZoom = false;
          this._animateBgOpacity = false;
          this._animateRootOpacity = true;
          if (this.isOpening) {
            if (pswp.element) {
              pswp.element.style.opacity = String(MIN_OPACITY);
            }
            pswp.applyBgOpacity(1);
          }
          return;
        }
        if (this._animateZoom && this._thumbBounds && this._thumbBounds.innerRect) {
          var _this$pswp$currSlide;
          this._croppedZoom = true;
          this._cropContainer1 = this.pswp.container;
          this._cropContainer2 = (_this$pswp$currSlide = this.pswp.currSlide) === null || _this$pswp$currSlide === void 0 ? void 0 : _this$pswp$currSlide.holderElement;
          if (pswp.container) {
            pswp.container.style.overflow = 'hidden';
            pswp.container.style.width = pswp.viewportSize.x + 'px';
          }
        } else {
          this._croppedZoom = false;
        }
        if (this.isOpening) {
          if (this._animateRootOpacity) {
            if (pswp.element) {
              pswp.element.style.opacity = String(MIN_OPACITY);
            }
            pswp.applyBgOpacity(1);
          } else {
            if (this._animateBgOpacity && pswp.bg) {
              pswp.bg.style.opacity = String(MIN_OPACITY);
            }
            if (pswp.element) {
              pswp.element.style.opacity = '1';
            }
          }
          if (this._animateZoom) {
            this._setClosedStateZoomPan();
            if (this._placeholder) {
              this._placeholder.style.willChange = 'transform';
              this._placeholder.style.opacity = String(MIN_OPACITY);
            }
          }
        } else if (this.isClosing) {
          if (pswp.mainScroll.itemHolders[0]) {
            pswp.mainScroll.itemHolders[0].el.style.display = 'none';
          }
          if (pswp.mainScroll.itemHolders[2]) {
            pswp.mainScroll.itemHolders[2].el.style.display = 'none';
          }
          if (this._croppedZoom) {
            if (pswp.mainScroll.x !== 0) {
              pswp.mainScroll.resetPosition();
              pswp.mainScroll.resize();
            }
          }
        }
      }
      _start() {
        if (this.isOpening && this._useAnimation && this._placeholder && this._placeholder.tagName === 'IMG') {
          new Promise(resolve => {
            let decoded = false;
            let isDelaying = true;
            decodeImage(this._placeholder).finally(() => {
              decoded = true;
              if (!isDelaying) {
                resolve(true);
              }
            });
            setTimeout(() => {
              isDelaying = false;
              if (decoded) {
                resolve(true);
              }
            }, 50);
            setTimeout(resolve, 250);
          }).finally(() => this._initiate());
        } else {
          this._initiate();
        }
      }
      _initiate() {
        var _this$pswp$element, _this$pswp$element2;
        (_this$pswp$element = this.pswp.element) === null || _this$pswp$element === void 0 || _this$pswp$element.style.setProperty('--pswp-transition-duration', this._duration + 'ms');
        this.pswp.dispatch(this.isOpening ? 'openingAnimationStart' : 'closingAnimationStart');
        this.pswp.dispatch('initialZoom' + (this.isOpening ? 'In' : 'Out'));
        (_this$pswp$element2 = this.pswp.element) === null || _this$pswp$element2 === void 0 || _this$pswp$element2.classList.toggle('pswp--ui-visible', this.isOpening);
        if (this.isOpening) {
          if (this._placeholder) {
            this._placeholder.style.opacity = '1';
          }
          this._animateToOpenState();
        } else if (this.isClosing) {
          this._animateToClosedState();
        }
        if (!this._useAnimation) {
          this._onAnimationComplete();
        }
      }
      _onAnimationComplete() {
        const {
          pswp
        } = this;
        this.isOpen = this.isOpening;
        this.isClosed = this.isClosing;
        this.isOpening = false;
        this.isClosing = false;
        pswp.dispatch(this.isOpen ? 'openingAnimationEnd' : 'closingAnimationEnd');
        pswp.dispatch('initialZoom' + (this.isOpen ? 'InEnd' : 'OutEnd'));
        if (this.isClosed) {
          pswp.destroy();
        } else if (this.isOpen) {
          var _pswp$currSlide;
          if (this._animateZoom && pswp.container) {
            pswp.container.style.overflow = 'visible';
            pswp.container.style.width = '100%';
          }
          (_pswp$currSlide = pswp.currSlide) === null || _pswp$currSlide === void 0 || _pswp$currSlide.applyCurrentZoomPan();
        }
      }
      _animateToOpenState() {
        const {
          pswp
        } = this;
        if (this._animateZoom) {
          if (this._croppedZoom && this._cropContainer1 && this._cropContainer2) {
            this._animateTo(this._cropContainer1, 'transform', 'translate3d(0,0,0)');
            this._animateTo(this._cropContainer2, 'transform', 'none');
          }
          if (pswp.currSlide) {
            pswp.currSlide.zoomAndPanToInitial();
            this._animateTo(pswp.currSlide.container, 'transform', pswp.currSlide.getCurrentTransform());
          }
        }
        if (this._animateBgOpacity && pswp.bg) {
          this._animateTo(pswp.bg, 'opacity', String(pswp.options.bgOpacity));
        }
        if (this._animateRootOpacity && pswp.element) {
          this._animateTo(pswp.element, 'opacity', '1');
        }
      }
      _animateToClosedState() {
        const {
          pswp
        } = this;
        if (this._animateZoom) {
          this._setClosedStateZoomPan(true);
        }
        if (this._animateBgOpacity && pswp.bgOpacity > 0.01 && pswp.bg) {
          this._animateTo(pswp.bg, 'opacity', '0');
        }
        if (this._animateRootOpacity && pswp.element) {
          this._animateTo(pswp.element, 'opacity', '0');
        }
      }
      _setClosedStateZoomPan(animate) {
        if (!this._thumbBounds) return;
        const {
          pswp
        } = this;
        const {
          innerRect
        } = this._thumbBounds;
        const {
          currSlide,
          viewportSize
        } = pswp;
        if (this._croppedZoom && innerRect && this._cropContainer1 && this._cropContainer2) {
          const containerOnePanX = -viewportSize.x + (this._thumbBounds.x - innerRect.x) + innerRect.w;
          const containerOnePanY = -viewportSize.y + (this._thumbBounds.y - innerRect.y) + innerRect.h;
          const containerTwoPanX = viewportSize.x - innerRect.w;
          const containerTwoPanY = viewportSize.y - innerRect.h;
          if (animate) {
            this._animateTo(this._cropContainer1, 'transform', toTransformString$1(containerOnePanX, containerOnePanY));
            this._animateTo(this._cropContainer2, 'transform', toTransformString$1(containerTwoPanX, containerTwoPanY));
          } else {
            setTransform(this._cropContainer1, containerOnePanX, containerOnePanY);
            setTransform(this._cropContainer2, containerTwoPanX, containerTwoPanY);
          }
        }
        if (currSlide) {
          equalizePoints(currSlide.pan, innerRect || this._thumbBounds);
          currSlide.currZoomLevel = this._thumbBounds.w / currSlide.width;
          if (animate) {
            this._animateTo(currSlide.container, 'transform', currSlide.getCurrentTransform());
          } else {
            currSlide.applyCurrentZoomPan();
          }
        }
      }
      _animateTo(target, prop, propValue) {
        if (!this._duration) {
          target.style[prop] = propValue;
          return;
        }
        const {
          animations
        } = this.pswp;
        const animProps = {
          duration: this._duration,
          easing: this.pswp.options.easing,
          onComplete: () => {
            if (!animations.activeAnimations.length) {
              this._onAnimationComplete();
            }
          },
          target
        };
        animProps[prop] = propValue;
        animations.startTransition(animProps);
      }
    }
    const defaultOptions = {
      allowPanToNext: true,
      spacing: 0.1,
      loop: true,
      pinchToClose: true,
      closeOnVerticalDrag: true,
      hideAnimationDuration: 333,
      showAnimationDuration: 333,
      zoomAnimationDuration: 333,
      escKey: true,
      arrowKeys: true,
      trapFocus: true,
      returnFocus: true,
      maxWidthToAnimate: 4000,
      clickToCloseNonZoomable: true,
      imageClickAction: 'zoom-or-close',
      bgClickAction: 'close',
      tapAction: 'toggle-controls',
      doubleTapAction: 'zoom',
      indexIndicatorSep: ' / ',
      preloaderDelay: 2000,
      bgOpacity: 0.8,
      index: 0,
      errorMsg: 'The image cannot be loaded',
      preload: [1, 2],
      easing: 'cubic-bezier(.4,0,.22,1)'
    };
    class PhotoSwipe extends PhotoSwipeBase$1 {
      constructor(options) {
        super();
        this.options = this._prepareOptions(options || {});
        this.offset = {
          x: 0,
          y: 0
        };
        this._prevViewportSize = {
          x: 0,
          y: 0
        };
        this.viewportSize = {
          x: 0,
          y: 0
        };
        this.bgOpacity = 1;
        this.currIndex = 0;
        this.potentialIndex = 0;
        this.isOpen = false;
        this.isDestroying = false;
        this.hasMouse = false;
        this._initialItemData = {};
        this._initialThumbBounds = undefined;
        this.topBar = undefined;
        this.element = undefined;
        this.template = undefined;
        this.container = undefined;
        this.scrollWrap = undefined;
        this.currSlide = undefined;
        this.events = new DOMEvents();
        this.animations = new Animations();
        this.mainScroll = new MainScroll(this);
        this.gestures = new Gestures(this);
        this.opener = new Opener(this);
        this.keyboard = new Keyboard(this);
        this.contentLoader = new ContentLoader(this);
      }
      init() {
        if (this.isOpen || this.isDestroying) {
          return false;
        }
        this.isOpen = true;
        this.dispatch('init');
        this.dispatch('beforeOpen');
        this._createMainStructure();
        let rootClasses = 'pswp--open';
        if (this.gestures.supportsTouch) {
          rootClasses += ' pswp--touch';
        }
        if (this.options.mainClass) {
          rootClasses += ' ' + this.options.mainClass;
        }
        if (this.element) {
          this.element.className += ' ' + rootClasses;
        }
        this.currIndex = this.options.index || 0;
        this.potentialIndex = this.currIndex;
        this.dispatch('firstUpdate');
        this.scrollWheel = new ScrollWheel(this);
        if (Number.isNaN(this.currIndex) || this.currIndex < 0 || this.currIndex >= this.getNumItems()) {
          this.currIndex = 0;
        }
        if (!this.gestures.supportsTouch) {
          this.mouseDetected();
        }
        this.updateSize();
        this.offset.y = window.pageYOffset;
        this._initialItemData = this.getItemData(this.currIndex);
        this.dispatch('gettingData', {
          index: this.currIndex,
          data: this._initialItemData,
          slide: undefined
        });
        this._initialThumbBounds = this.getThumbBounds();
        this.dispatch('initialLayout');
        this.on('openingAnimationEnd', () => {
          const {
            itemHolders
          } = this.mainScroll;
          if (itemHolders[0]) {
            itemHolders[0].el.style.display = 'block';
            this.setContent(itemHolders[0], this.currIndex - 1);
          }
          if (itemHolders[2]) {
            itemHolders[2].el.style.display = 'block';
            this.setContent(itemHolders[2], this.currIndex + 1);
          }
          this.appendHeavy();
          this.contentLoader.updateLazy();
          this.events.add(window, 'resize', this._handlePageResize.bind(this));
          this.events.add(window, 'scroll', this._updatePageScrollOffset.bind(this));
          this.dispatch('bindEvents');
        });
        if (this.mainScroll.itemHolders[1]) {
          this.setContent(this.mainScroll.itemHolders[1], this.currIndex);
        }
        this.dispatch('change');
        this.opener.open();
        this.dispatch('afterInit');
        return true;
      }
      getLoopedIndex(index) {
        const numSlides = this.getNumItems();
        if (this.options.loop) {
          if (index > numSlides - 1) {
            index -= numSlides;
          }
          if (index < 0) {
            index += numSlides;
          }
        }
        return clamp(index, 0, numSlides - 1);
      }
      appendHeavy() {
        this.mainScroll.itemHolders.forEach(itemHolder => {
          var _itemHolder$slide;
          (_itemHolder$slide = itemHolder.slide) === null || _itemHolder$slide === void 0 || _itemHolder$slide.appendHeavy();
        });
      }
      goTo(index) {
        this.mainScroll.moveIndexBy(this.getLoopedIndex(index) - this.potentialIndex);
      }
      next() {
        this.goTo(this.potentialIndex + 1);
      }
      prev() {
        this.goTo(this.potentialIndex - 1);
      }
      zoomTo(...args) {
        var _this$currSlide;
        (_this$currSlide = this.currSlide) === null || _this$currSlide === void 0 || _this$currSlide.zoomTo(...args);
      }
      toggleZoom() {
        var _this$currSlide2;
        (_this$currSlide2 = this.currSlide) === null || _this$currSlide2 === void 0 || _this$currSlide2.toggleZoom();
      }
      close() {
        if (!this.opener.isOpen || this.isDestroying) {
          return;
        }
        this.isDestroying = true;
        this.dispatch('close');
        this.events.removeAll();
        this.opener.close();
      }
      destroy() {
        var _this$element;
        if (!this.isDestroying) {
          this.options.showHideAnimationType = 'none';
          this.close();
          return;
        }
        this.dispatch('destroy');
        this._listeners = {};
        if (this.scrollWrap) {
          this.scrollWrap.ontouchmove = null;
          this.scrollWrap.ontouchend = null;
        }
        (_this$element = this.element) === null || _this$element === void 0 || _this$element.remove();
        this.mainScroll.itemHolders.forEach(itemHolder => {
          var _itemHolder$slide2;
          (_itemHolder$slide2 = itemHolder.slide) === null || _itemHolder$slide2 === void 0 || _itemHolder$slide2.destroy();
        });
        this.contentLoader.destroy();
        this.events.removeAll();
      }
      refreshSlideContent(slideIndex) {
        this.contentLoader.removeByIndex(slideIndex);
        this.mainScroll.itemHolders.forEach((itemHolder, i) => {
          var _this$currSlide$index, _this$currSlide3;
          let potentialHolderIndex = ((_this$currSlide$index = (_this$currSlide3 = this.currSlide) === null || _this$currSlide3 === void 0 ? void 0 : _this$currSlide3.index) !== null && _this$currSlide$index !== void 0 ? _this$currSlide$index : 0) - 1 + i;
          if (this.canLoop()) {
            potentialHolderIndex = this.getLoopedIndex(potentialHolderIndex);
          }
          if (potentialHolderIndex === slideIndex) {
            this.setContent(itemHolder, slideIndex, true);
            if (i === 1) {
              var _itemHolder$slide3;
              this.currSlide = itemHolder.slide;
              (_itemHolder$slide3 = itemHolder.slide) === null || _itemHolder$slide3 === void 0 || _itemHolder$slide3.setIsActive(true);
            }
          }
        });
        this.dispatch('change');
      }
      setContent(holder, index, force) {
        if (this.canLoop()) {
          index = this.getLoopedIndex(index);
        }
        if (holder.slide) {
          if (holder.slide.index === index && !force) {
            return;
          }
          holder.slide.destroy();
          holder.slide = undefined;
        }
        if (!this.canLoop() && (index < 0 || index >= this.getNumItems())) {
          return;
        }
        const itemData = this.getItemData(index);
        holder.slide = new Slide(itemData, index, this);
        if (index === this.currIndex) {
          this.currSlide = holder.slide;
        }
        holder.slide.append(holder.el);
      }
      getViewportCenterPoint() {
        return {
          x: this.viewportSize.x / 2,
          y: this.viewportSize.y / 2
        };
      }
      updateSize(force) {
        if (this.isDestroying) {
          return;
        }
        const newViewportSize = getViewportSize$1(this.options, this);
        if (!force && pointsEqual(newViewportSize, this._prevViewportSize)) {
          return;
        }
        equalizePoints(this._prevViewportSize, newViewportSize);
        this.dispatch('beforeResize');
        equalizePoints(this.viewportSize, this._prevViewportSize);
        this._updatePageScrollOffset();
        this.dispatch('viewportSize');
        this.mainScroll.resize(this.opener.isOpen);
        if (!this.hasMouse && window.matchMedia('(any-hover: hover)').matches) {
          this.mouseDetected();
        }
        this.dispatch('resize');
      }
      applyBgOpacity(opacity) {
        this.bgOpacity = Math.max(opacity, 0);
        if (this.bg) {
          this.bg.style.opacity = String(this.bgOpacity * this.options.bgOpacity);
        }
      }
      mouseDetected() {
        if (!this.hasMouse) {
          var _this$element2;
          this.hasMouse = true;
          (_this$element2 = this.element) === null || _this$element2 === void 0 || _this$element2.classList.add('pswp--has_mouse');
        }
      }
      _handlePageResize() {
        this.updateSize();
        if (/iPhone|iPad|iPod/i.test(window.navigator.userAgent)) {
          setTimeout(() => {
            this.updateSize();
          }, 500);
        }
      }
      _updatePageScrollOffset() {
        this.setScrollOffset(0, window.pageYOffset);
      }
      setScrollOffset(x, y) {
        this.offset.x = x;
        this.offset.y = y;
        this.dispatch('updateScrollOffset');
      }
      _createMainStructure() {
        this.element = createElement$1('pswp', 'div');
        this.element.setAttribute('tabindex', '-1');
        this.element.setAttribute('role', 'dialog');
        this.template = this.element;
        this.bg = createElement$1('pswp__bg', 'div', this.element);
        this.scrollWrap = createElement$1('pswp__scroll-wrap', 'section', this.element);
        this.container = createElement$1('pswp__container', 'div', this.scrollWrap);
        this.scrollWrap.setAttribute('aria-roledescription', 'carousel');
        this.container.setAttribute('aria-live', 'off');
        this.container.setAttribute('id', 'pswp__items');
        this.mainScroll.appendHolders();
        this.ui = new UI(this);
        this.ui.init();
        (this.options.appendToEl || document.body).appendChild(this.element);
      }
      getThumbBounds() {
        return getThumbBounds(this.currIndex, this.currSlide ? this.currSlide.data : this._initialItemData, this);
      }
      canLoop() {
        return this.options.loop && this.getNumItems() > 2;
      }
      _prepareOptions(options) {
        if (window.matchMedia('(prefers-reduced-motion), (update: slow)').matches) {
          options.showHideAnimationType = 'none';
          options.zoomAnimationDuration = 0;
        }
        return {
          ...defaultOptions,
          ...options
        };
      }
    }

    function createElement(className, tagName, appendToEl) {
      const el = document.createElement(tagName);
      if (className) {
        el.className = className;
      }
      if (appendToEl) {
        appendToEl.appendChild(el);
      }
      return el;
    }
    function toTransformString(x, y, scale) {
      let propValue = `translate3d(${x}px,${y || 0}px,0)`;
      if (scale !== undefined) {
        propValue += ` scale3d(${scale},${scale},1)`;
      }
      return propValue;
    }
    function setWidthHeight(el, w, h) {
      el.style.width = typeof w === 'number' ? `${w}px` : w;
      el.style.height = typeof h === 'number' ? `${h}px` : h;
    }
    const LOAD_STATE = {
      IDLE: 'idle',
      LOADING: 'loading',
      LOADED: 'loaded',
      ERROR: 'error'
    };
    function specialKeyUsed(e) {
      return 'button' in e && e.button === 1 || e.ctrlKey || e.metaKey || e.altKey || e.shiftKey;
    }
    function getElementsFromOption(option, legacySelector, parent = document) {
      let elements = [];
      if (option instanceof Element) {
        elements = [option];
      } else if (option instanceof NodeList || Array.isArray(option)) {
        elements = Array.from(option);
      } else {
        const selector = typeof option === 'string' ? option : legacySelector;
        if (selector) {
          elements = Array.from(parent.querySelectorAll(selector));
        }
      }
      return elements;
    }
    function isPswpClass(fn) {
      return typeof fn === 'function' && fn.prototype && fn.prototype.goTo;
    }
    function isSafari() {
      return !!(navigator.vendor && navigator.vendor.match(/apple/i));
    }
    class PhotoSwipeEvent {
      constructor(type, details) {
        this.type = type;
        this.defaultPrevented = false;
        if (details) {
          Object.assign(this, details);
        }
      }
      preventDefault() {
        this.defaultPrevented = true;
      }
    }
    class Eventable {
      constructor() {
        this._listeners = {};
        this._filters = {};
        this.pswp = undefined;
        this.options = undefined;
      }
      addFilter(name, fn, priority = 100) {
        var _this$_filters$name, _this$_filters$name2, _this$pswp;
        if (!this._filters[name]) {
          this._filters[name] = [];
        }
        (_this$_filters$name = this._filters[name]) === null || _this$_filters$name === void 0 || _this$_filters$name.push({
          fn,
          priority
        });
        (_this$_filters$name2 = this._filters[name]) === null || _this$_filters$name2 === void 0 || _this$_filters$name2.sort((f1, f2) => f1.priority - f2.priority);
        (_this$pswp = this.pswp) === null || _this$pswp === void 0 || _this$pswp.addFilter(name, fn, priority);
      }
      removeFilter(name, fn) {
        if (this._filters[name]) {
          this._filters[name] = this._filters[name].filter(filter => filter.fn !== fn);
        }
        if (this.pswp) {
          this.pswp.removeFilter(name, fn);
        }
      }
      applyFilters(name, ...args) {
        var _this$_filters$name3;
        (_this$_filters$name3 = this._filters[name]) === null || _this$_filters$name3 === void 0 || _this$_filters$name3.forEach(filter => {
          args[0] = filter.fn.apply(this, args);
        });
        return args[0];
      }
      on(name, fn) {
        var _this$_listeners$name, _this$pswp2;
        if (!this._listeners[name]) {
          this._listeners[name] = [];
        }
        (_this$_listeners$name = this._listeners[name]) === null || _this$_listeners$name === void 0 || _this$_listeners$name.push(fn);
        (_this$pswp2 = this.pswp) === null || _this$pswp2 === void 0 || _this$pswp2.on(name, fn);
      }
      off(name, fn) {
        var _this$pswp3;
        if (this._listeners[name]) {
          this._listeners[name] = this._listeners[name].filter(listener => fn !== listener);
        }
        (_this$pswp3 = this.pswp) === null || _this$pswp3 === void 0 || _this$pswp3.off(name, fn);
      }
      dispatch(name, details) {
        var _this$_listeners$name2;
        if (this.pswp) {
          return this.pswp.dispatch(name, details);
        }
        const event = new PhotoSwipeEvent(name, details);
        (_this$_listeners$name2 = this._listeners[name]) === null || _this$_listeners$name2 === void 0 || _this$_listeners$name2.forEach(listener => {
          listener.call(this, event);
        });
        return event;
      }
    }
    class Placeholder {
      constructor(imageSrc, container) {
        this.element = createElement('pswp__img pswp__img--placeholder', imageSrc ? 'img' : 'div', container);
        if (imageSrc) {
          const imgEl = this.element;
          imgEl.decoding = 'async';
          imgEl.alt = '';
          imgEl.src = imageSrc;
          imgEl.setAttribute('role', 'presentation');
        }
        this.element.setAttribute('aria-hidden', 'true');
      }
      setDisplayedSize(width, height) {
        if (!this.element) {
          return;
        }
        if (this.element.tagName === 'IMG') {
          setWidthHeight(this.element, 250, 'auto');
          this.element.style.transformOrigin = '0 0';
          this.element.style.transform = toTransformString(0, 0, width / 250);
        } else {
          setWidthHeight(this.element, width, height);
        }
      }
      destroy() {
        var _this$element;
        if ((_this$element = this.element) !== null && _this$element !== void 0 && _this$element.parentNode) {
          this.element.remove();
        }
        this.element = null;
      }
    }
    class Content {
      constructor(itemData, instance, index) {
        this.instance = instance;
        this.data = itemData;
        this.index = index;
        this.element = undefined;
        this.placeholder = undefined;
        this.slide = undefined;
        this.displayedImageWidth = 0;
        this.displayedImageHeight = 0;
        this.width = Number(this.data.w) || Number(this.data.width) || 0;
        this.height = Number(this.data.h) || Number(this.data.height) || 0;
        this.isAttached = false;
        this.hasSlide = false;
        this.isDecoding = false;
        this.state = LOAD_STATE.IDLE;
        if (this.data.type) {
          this.type = this.data.type;
        } else if (this.data.src) {
          this.type = 'image';
        } else {
          this.type = 'html';
        }
        this.instance.dispatch('contentInit', {
          content: this
        });
      }
      removePlaceholder() {
        if (this.placeholder && !this.keepPlaceholder()) {
          setTimeout(() => {
            if (this.placeholder) {
              this.placeholder.destroy();
              this.placeholder = undefined;
            }
          }, 1000);
        }
      }
      load(isLazy, reload) {
        if (this.slide && this.usePlaceholder()) {
          if (!this.placeholder) {
            const placeholderSrc = this.instance.applyFilters('placeholderSrc', this.data.msrc && this.slide.isFirstSlide ? this.data.msrc : false, this);
            this.placeholder = new Placeholder(placeholderSrc, this.slide.container);
          } else {
            const placeholderEl = this.placeholder.element;
            if (placeholderEl && !placeholderEl.parentElement) {
              this.slide.container.prepend(placeholderEl);
            }
          }
        }
        if (this.element && !reload) {
          return;
        }
        if (this.instance.dispatch('contentLoad', {
          content: this,
          isLazy
        }).defaultPrevented) {
          return;
        }
        if (this.isImageContent()) {
          this.element = createElement('pswp__img', 'img');
          if (this.displayedImageWidth) {
            this.loadImage(isLazy);
          }
        } else {
          this.element = createElement('pswp__content', 'div');
          this.element.innerHTML = this.data.html || '';
        }
        if (reload && this.slide) {
          this.slide.updateContentSize(true);
        }
      }
      loadImage(isLazy) {
        var _this$data$src, _this$data$alt;
        if (!this.isImageContent() || !this.element || this.instance.dispatch('contentLoadImage', {
          content: this,
          isLazy
        }).defaultPrevented) {
          return;
        }
        const imageElement = this.element;
        this.updateSrcsetSizes();
        if (this.data.srcset) {
          imageElement.srcset = this.data.srcset;
        }
        imageElement.src = (_this$data$src = this.data.src) !== null && _this$data$src !== void 0 ? _this$data$src : '';
        imageElement.alt = (_this$data$alt = this.data.alt) !== null && _this$data$alt !== void 0 ? _this$data$alt : '';
        this.state = LOAD_STATE.LOADING;
        if (imageElement.complete) {
          this.onLoaded();
        } else {
          imageElement.onload = () => {
            this.onLoaded();
          };
          imageElement.onerror = () => {
            this.onError();
          };
        }
      }
      setSlide(slide) {
        this.slide = slide;
        this.hasSlide = true;
        this.instance = slide.pswp;
      }
      onLoaded() {
        this.state = LOAD_STATE.LOADED;
        if (this.slide && this.element) {
          this.instance.dispatch('loadComplete', {
            slide: this.slide,
            content: this
          });
          if (this.slide.isActive && this.slide.heavyAppended && !this.element.parentNode) {
            this.append();
            this.slide.updateContentSize(true);
          }
          if (this.state === LOAD_STATE.LOADED || this.state === LOAD_STATE.ERROR) {
            this.removePlaceholder();
          }
        }
      }
      onError() {
        this.state = LOAD_STATE.ERROR;
        if (this.slide) {
          this.displayError();
          this.instance.dispatch('loadComplete', {
            slide: this.slide,
            isError: true,
            content: this
          });
          this.instance.dispatch('loadError', {
            slide: this.slide,
            content: this
          });
        }
      }
      isLoading() {
        return this.instance.applyFilters('isContentLoading', this.state === LOAD_STATE.LOADING, this);
      }
      isError() {
        return this.state === LOAD_STATE.ERROR;
      }
      isImageContent() {
        return this.type === 'image';
      }
      setDisplayedSize(width, height) {
        if (!this.element) {
          return;
        }
        if (this.placeholder) {
          this.placeholder.setDisplayedSize(width, height);
        }
        if (this.instance.dispatch('contentResize', {
          content: this,
          width,
          height
        }).defaultPrevented) {
          return;
        }
        setWidthHeight(this.element, width, height);
        if (this.isImageContent() && !this.isError()) {
          const isInitialSizeUpdate = !this.displayedImageWidth && width;
          this.displayedImageWidth = width;
          this.displayedImageHeight = height;
          if (isInitialSizeUpdate) {
            this.loadImage(false);
          } else {
            this.updateSrcsetSizes();
          }
          if (this.slide) {
            this.instance.dispatch('imageSizeChange', {
              slide: this.slide,
              width,
              height,
              content: this
            });
          }
        }
      }
      isZoomable() {
        return this.instance.applyFilters('isContentZoomable', this.isImageContent() && this.state !== LOAD_STATE.ERROR, this);
      }
      updateSrcsetSizes() {
        if (!this.isImageContent() || !this.element || !this.data.srcset) {
          return;
        }
        const image = this.element;
        const sizesWidth = this.instance.applyFilters('srcsetSizesWidth', this.displayedImageWidth, this);
        if (!image.dataset.largestUsedSize || sizesWidth > parseInt(image.dataset.largestUsedSize, 10)) {
          image.sizes = sizesWidth + 'px';
          image.dataset.largestUsedSize = String(sizesWidth);
        }
      }
      usePlaceholder() {
        return this.instance.applyFilters('useContentPlaceholder', this.isImageContent(), this);
      }
      lazyLoad() {
        if (this.instance.dispatch('contentLazyLoad', {
          content: this
        }).defaultPrevented) {
          return;
        }
        this.load(true);
      }
      keepPlaceholder() {
        return this.instance.applyFilters('isKeepingPlaceholder', this.isLoading(), this);
      }
      destroy() {
        this.hasSlide = false;
        this.slide = undefined;
        if (this.instance.dispatch('contentDestroy', {
          content: this
        }).defaultPrevented) {
          return;
        }
        this.remove();
        if (this.placeholder) {
          this.placeholder.destroy();
          this.placeholder = undefined;
        }
        if (this.isImageContent() && this.element) {
          this.element.onload = null;
          this.element.onerror = null;
          this.element = undefined;
        }
      }
      displayError() {
        if (this.slide) {
          var _this$instance$option, _this$instance$option2;
          let errorMsgEl = createElement('pswp__error-msg', 'div');
          errorMsgEl.innerText = (_this$instance$option = (_this$instance$option2 = this.instance.options) === null || _this$instance$option2 === void 0 ? void 0 : _this$instance$option2.errorMsg) !== null && _this$instance$option !== void 0 ? _this$instance$option : '';
          errorMsgEl = this.instance.applyFilters('contentErrorElement', errorMsgEl, this);
          this.element = createElement('pswp__content pswp__error-msg-container', 'div');
          this.element.appendChild(errorMsgEl);
          this.slide.container.innerText = '';
          this.slide.container.appendChild(this.element);
          this.slide.updateContentSize(true);
          this.removePlaceholder();
        }
      }
      append() {
        if (this.isAttached || !this.element) {
          return;
        }
        this.isAttached = true;
        if (this.state === LOAD_STATE.ERROR) {
          this.displayError();
          return;
        }
        if (this.instance.dispatch('contentAppend', {
          content: this
        }).defaultPrevented) {
          return;
        }
        const supportsDecode = 'decode' in this.element;
        if (this.isImageContent()) {
          if (supportsDecode && this.slide && (!this.slide.isActive || isSafari())) {
            this.isDecoding = true;
            this.element.decode().catch(() => {}).finally(() => {
              this.isDecoding = false;
              this.appendImage();
            });
          } else {
            this.appendImage();
          }
        } else if (this.slide && !this.element.parentNode) {
          this.slide.container.appendChild(this.element);
        }
      }
      activate() {
        if (this.instance.dispatch('contentActivate', {
          content: this
        }).defaultPrevented || !this.slide) {
          return;
        }
        if (this.isImageContent() && this.isDecoding && !isSafari()) {
          this.appendImage();
        } else if (this.isError()) {
          this.load(false, true);
        }
        if (this.slide.holderElement) {
          this.slide.holderElement.setAttribute('aria-hidden', 'false');
        }
      }
      deactivate() {
        this.instance.dispatch('contentDeactivate', {
          content: this
        });
        if (this.slide && this.slide.holderElement) {
          this.slide.holderElement.setAttribute('aria-hidden', 'true');
        }
      }
      remove() {
        this.isAttached = false;
        if (this.instance.dispatch('contentRemove', {
          content: this
        }).defaultPrevented) {
          return;
        }
        if (this.element && this.element.parentNode) {
          this.element.remove();
        }
        if (this.placeholder && this.placeholder.element) {
          this.placeholder.element.remove();
        }
      }
      appendImage() {
        if (!this.isAttached) {
          return;
        }
        if (this.instance.dispatch('contentAppendImage', {
          content: this
        }).defaultPrevented) {
          return;
        }
        if (this.slide && this.element && !this.element.parentNode) {
          this.slide.container.appendChild(this.element);
        }
        if (this.state === LOAD_STATE.LOADED || this.state === LOAD_STATE.ERROR) {
          this.removePlaceholder();
        }
      }
    }
    function getViewportSize(options, pswp) {
      if (options.getViewportSizeFn) {
        const newViewportSize = options.getViewportSizeFn(options, pswp);
        if (newViewportSize) {
          return newViewportSize;
        }
      }
      return {
        x: document.documentElement.clientWidth,
        y: window.innerHeight
      };
    }
    function parsePaddingOption(prop, options, viewportSize, itemData, index) {
      let paddingValue = 0;
      if (options.paddingFn) {
        paddingValue = options.paddingFn(viewportSize, itemData, index)[prop];
      } else if (options.padding) {
        paddingValue = options.padding[prop];
      } else {
        const legacyPropName = 'padding' + prop[0].toUpperCase() + prop.slice(1);
        if (options[legacyPropName]) {
          paddingValue = options[legacyPropName];
        }
      }
      return Number(paddingValue) || 0;
    }
    function getPanAreaSize(options, viewportSize, itemData, index) {
      return {
        x: viewportSize.x - parsePaddingOption('left', options, viewportSize, itemData, index) - parsePaddingOption('right', options, viewportSize, itemData, index),
        y: viewportSize.y - parsePaddingOption('top', options, viewportSize, itemData, index) - parsePaddingOption('bottom', options, viewportSize, itemData, index)
      };
    }
    const MAX_IMAGE_WIDTH = 4000;
    class ZoomLevel {
      constructor(options, itemData, index, pswp) {
        this.pswp = pswp;
        this.options = options;
        this.itemData = itemData;
        this.index = index;
        this.panAreaSize = null;
        this.elementSize = null;
        this.fit = 1;
        this.fill = 1;
        this.vFill = 1;
        this.initial = 1;
        this.secondary = 1;
        this.max = 1;
        this.min = 1;
      }
      update(maxWidth, maxHeight, panAreaSize) {
        const elementSize = {
          x: maxWidth,
          y: maxHeight
        };
        this.elementSize = elementSize;
        this.panAreaSize = panAreaSize;
        const hRatio = panAreaSize.x / elementSize.x;
        const vRatio = panAreaSize.y / elementSize.y;
        this.fit = Math.min(1, hRatio < vRatio ? hRatio : vRatio);
        this.fill = Math.min(1, hRatio > vRatio ? hRatio : vRatio);
        this.vFill = Math.min(1, vRatio);
        this.initial = this._getInitial();
        this.secondary = this._getSecondary();
        this.max = Math.max(this.initial, this.secondary, this._getMax());
        this.min = Math.min(this.fit, this.initial, this.secondary);
        if (this.pswp) {
          this.pswp.dispatch('zoomLevelsUpdate', {
            zoomLevels: this,
            slideData: this.itemData
          });
        }
      }
      _parseZoomLevelOption(optionPrefix) {
        const optionName = optionPrefix + 'ZoomLevel';
        const optionValue = this.options[optionName];
        if (!optionValue) {
          return;
        }
        if (typeof optionValue === 'function') {
          return optionValue(this);
        }
        if (optionValue === 'fill') {
          return this.fill;
        }
        if (optionValue === 'fit') {
          return this.fit;
        }
        return Number(optionValue);
      }
      _getSecondary() {
        let currZoomLevel = this._parseZoomLevelOption('secondary');
        if (currZoomLevel) {
          return currZoomLevel;
        }
        currZoomLevel = Math.min(1, this.fit * 3);
        if (this.elementSize && currZoomLevel * this.elementSize.x > MAX_IMAGE_WIDTH) {
          currZoomLevel = MAX_IMAGE_WIDTH / this.elementSize.x;
        }
        return currZoomLevel;
      }
      _getInitial() {
        return this._parseZoomLevelOption('initial') || this.fit;
      }
      _getMax() {
        return this._parseZoomLevelOption('max') || Math.max(1, this.fit * 4);
      }
    }
    function lazyLoadData(itemData, instance, index) {
      const content = instance.createContentFromData(itemData, index);
      let zoomLevel;
      const {
        options
      } = instance;
      if (options) {
        zoomLevel = new ZoomLevel(options, itemData, -1);
        let viewportSize;
        if (instance.pswp) {
          viewportSize = instance.pswp.viewportSize;
        } else {
          viewportSize = getViewportSize(options, instance);
        }
        const panAreaSize = getPanAreaSize(options, viewportSize, itemData, index);
        zoomLevel.update(content.width, content.height, panAreaSize);
      }
      content.lazyLoad();
      if (zoomLevel) {
        content.setDisplayedSize(Math.ceil(content.width * zoomLevel.initial), Math.ceil(content.height * zoomLevel.initial));
      }
      return content;
    }
    function lazyLoadSlide(index, instance) {
      const itemData = instance.getItemData(index);
      if (instance.dispatch('lazyLoadSlide', {
        index,
        itemData
      }).defaultPrevented) {
        return;
      }
      return lazyLoadData(itemData, instance, index);
    }
    class PhotoSwipeBase extends Eventable {
      getNumItems() {
        var _this$options;
        let numItems = 0;
        const dataSource = (_this$options = this.options) === null || _this$options === void 0 ? void 0 : _this$options.dataSource;
        if (dataSource && 'length' in dataSource) {
          numItems = dataSource.length;
        } else if (dataSource && 'gallery' in dataSource) {
          if (!dataSource.items) {
            dataSource.items = this._getGalleryDOMElements(dataSource.gallery);
          }
          if (dataSource.items) {
            numItems = dataSource.items.length;
          }
        }
        const event = this.dispatch('numItems', {
          dataSource,
          numItems
        });
        return this.applyFilters('numItems', event.numItems, dataSource);
      }
      createContentFromData(slideData, index) {
        return new Content(slideData, this, index);
      }
      getItemData(index) {
        var _this$options2;
        const dataSource = (_this$options2 = this.options) === null || _this$options2 === void 0 ? void 0 : _this$options2.dataSource;
        let dataSourceItem = {};
        if (Array.isArray(dataSource)) {
          dataSourceItem = dataSource[index];
        } else if (dataSource && 'gallery' in dataSource) {
          if (!dataSource.items) {
            dataSource.items = this._getGalleryDOMElements(dataSource.gallery);
          }
          dataSourceItem = dataSource.items[index];
        }
        let itemData = dataSourceItem;
        if (itemData instanceof Element) {
          itemData = this._domElementToItemData(itemData);
        }
        const event = this.dispatch('itemData', {
          itemData: itemData || {},
          index
        });
        return this.applyFilters('itemData', event.itemData, index);
      }
      _getGalleryDOMElements(galleryElement) {
        var _this$options3, _this$options4;
        if ((_this$options3 = this.options) !== null && _this$options3 !== void 0 && _this$options3.children || (_this$options4 = this.options) !== null && _this$options4 !== void 0 && _this$options4.childSelector) {
          return getElementsFromOption(this.options.children, this.options.childSelector, galleryElement) || [];
        }
        return [galleryElement];
      }
      _domElementToItemData(element) {
        const itemData = {
          element
        };
        const linkEl = element.tagName === 'A' ? element : element.querySelector('a');
        if (linkEl) {
          itemData.src = linkEl.dataset.pswpSrc || linkEl.href;
          if (linkEl.dataset.pswpSrcset) {
            itemData.srcset = linkEl.dataset.pswpSrcset;
          }
          itemData.width = linkEl.dataset.pswpWidth ? parseInt(linkEl.dataset.pswpWidth, 10) : 0;
          itemData.height = linkEl.dataset.pswpHeight ? parseInt(linkEl.dataset.pswpHeight, 10) : 0;
          itemData.w = itemData.width;
          itemData.h = itemData.height;
          if (linkEl.dataset.pswpType) {
            itemData.type = linkEl.dataset.pswpType;
          }
          const thumbnailEl = element.querySelector('img');
          if (thumbnailEl) {
            var _thumbnailEl$getAttri;
            itemData.msrc = thumbnailEl.currentSrc || thumbnailEl.src;
            itemData.alt = (_thumbnailEl$getAttri = thumbnailEl.getAttribute('alt')) !== null && _thumbnailEl$getAttri !== void 0 ? _thumbnailEl$getAttri : '';
          }
          if (linkEl.dataset.pswpCropped || linkEl.dataset.cropped) {
            itemData.thumbCropped = true;
          }
        }
        return this.applyFilters('domItemData', itemData, element, linkEl);
      }
      lazyLoadData(itemData, index) {
        return lazyLoadData(itemData, this, index);
      }
    }
    class PhotoSwipeLightbox extends PhotoSwipeBase {
      constructor(options) {
        super();
        this.options = options || {};
        this._uid = 0;
        this.shouldOpen = false;
        this._preloadedContent = undefined;
        this.onThumbnailsClick = this.onThumbnailsClick.bind(this);
      }
      init() {
        getElementsFromOption(this.options.gallery, this.options.gallerySelector).forEach(galleryElement => {
          galleryElement.addEventListener('click', this.onThumbnailsClick, false);
        });
      }
      onThumbnailsClick(e) {
        if (specialKeyUsed(e) || window.pswp) {
          return;
        }
        let initialPoint = {
          x: e.clientX,
          y: e.clientY
        };
        if (!initialPoint.x && !initialPoint.y) {
          initialPoint = null;
        }
        let clickedIndex = this.getClickedIndex(e);
        clickedIndex = this.applyFilters('clickedIndex', clickedIndex, e, this);
        const dataSource = {
          gallery: e.currentTarget
        };
        if (clickedIndex >= 0) {
          e.preventDefault();
          this.loadAndOpen(clickedIndex, dataSource, initialPoint);
        }
      }
      getClickedIndex(e) {
        if (this.options.getClickedIndexFn) {
          return this.options.getClickedIndexFn.call(this, e);
        }
        const clickedTarget = e.target;
        const childElements = getElementsFromOption(this.options.children, this.options.childSelector, e.currentTarget);
        const clickedChildIndex = childElements.findIndex(child => child === clickedTarget || child.contains(clickedTarget));
        if (clickedChildIndex !== -1) {
          return clickedChildIndex;
        } else if (this.options.children || this.options.childSelector) {
          return -1;
        }
        return 0;
      }
      loadAndOpen(index, dataSource, initialPoint) {
        if (window.pswp || !this.options) {
          return false;
        }
        if (!dataSource && this.options.gallery && this.options.children) {
          const galleryElements = getElementsFromOption(this.options.gallery);
          if (galleryElements[0]) {
            dataSource = {
              gallery: galleryElements[0]
            };
          }
        }
        this.options.index = index;
        this.options.initialPointerPos = initialPoint;
        this.shouldOpen = true;
        this.preload(index, dataSource);
        return true;
      }
      preload(index, dataSource) {
        const {
          options
        } = this;
        if (dataSource) {
          options.dataSource = dataSource;
        }
        const promiseArray = [];
        const pswpModuleType = typeof options.pswpModule;
        if (isPswpClass(options.pswpModule)) {
          promiseArray.push(Promise.resolve(options.pswpModule));
        } else if (pswpModuleType === 'string') {
          throw new Error('pswpModule as string is no longer supported');
        } else if (pswpModuleType === 'function') {
          promiseArray.push(options.pswpModule());
        } else {
          throw new Error('pswpModule is not valid');
        }
        if (typeof options.openPromise === 'function') {
          promiseArray.push(options.openPromise());
        }
        if (options.preloadFirstSlide !== false && index >= 0) {
          this._preloadedContent = lazyLoadSlide(index, this);
        }
        const uid = ++this._uid;
        Promise.all(promiseArray).then(iterableModules => {
          if (this.shouldOpen) {
            const mainModule = iterableModules[0];
            this._openPhotoswipe(mainModule, uid);
          }
        });
      }
      _openPhotoswipe(module, uid) {
        if (uid !== this._uid && this.shouldOpen) {
          return;
        }
        this.shouldOpen = false;
        if (window.pswp) {
          return;
        }
        const pswp = typeof module === 'object' ? new module.default(this.options) : new module(this.options);
        this.pswp = pswp;
        window.pswp = pswp;
        Object.keys(this._listeners).forEach(name => {
          var _this$_listeners$name;
          (_this$_listeners$name = this._listeners[name]) === null || _this$_listeners$name === void 0 || _this$_listeners$name.forEach(fn => {
            pswp.on(name, fn);
          });
        });
        Object.keys(this._filters).forEach(name => {
          var _this$_filters$name;
          (_this$_filters$name = this._filters[name]) === null || _this$_filters$name === void 0 || _this$_filters$name.forEach(filter => {
            pswp.addFilter(name, filter.fn, filter.priority);
          });
        });
        if (this._preloadedContent) {
          pswp.contentLoader.addToCache(this._preloadedContent);
          this._preloadedContent = undefined;
        }
        pswp.on('destroy', () => {
          this.pswp = undefined;
          delete window.pswp;
        });
        pswp.init();
      }
      destroy() {
        var _this$pswp;
        (_this$pswp = this.pswp) === null || _this$pswp === void 0 || _this$pswp.destroy();
        this.shouldOpen = false;
        this._listeners = {};
        getElementsFromOption(this.options.gallery, this.options.gallerySelector).forEach(galleryElement => {
          galleryElement.removeEventListener('click', this.onThumbnailsClick, false);
        });
      }
    }

    function isObject$1(obj) {
      return obj !== null && typeof obj === 'object' && 'constructor' in obj && obj.constructor === Object;
    }
    function extend$1(target = {}, src = {}) {
      Object.keys(src).forEach(key => {
        if (typeof target[key] === 'undefined') target[key] = src[key];else if (isObject$1(src[key]) && isObject$1(target[key]) && Object.keys(src[key]).length > 0) {
          extend$1(target[key], src[key]);
        }
      });
    }
    const ssrDocument = {
      body: {},
      addEventListener() {},
      removeEventListener() {},
      activeElement: {
        blur() {},
        nodeName: ''
      },
      querySelector() {
        return null;
      },
      querySelectorAll() {
        return [];
      },
      getElementById() {
        return null;
      },
      createEvent() {
        return {
          initEvent() {}
        };
      },
      createElement() {
        return {
          children: [],
          childNodes: [],
          style: {},
          setAttribute() {},
          getElementsByTagName() {
            return [];
          }
        };
      },
      createElementNS() {
        return {};
      },
      importNode() {
        return null;
      },
      location: {
        hash: '',
        host: '',
        hostname: '',
        href: '',
        origin: '',
        pathname: '',
        protocol: '',
        search: ''
      }
    };
    function getDocument() {
      const doc = typeof document !== 'undefined' ? document : {};
      extend$1(doc, ssrDocument);
      return doc;
    }
    const ssrWindow = {
      document: ssrDocument,
      navigator: {
        userAgent: ''
      },
      location: {
        hash: '',
        host: '',
        hostname: '',
        href: '',
        origin: '',
        pathname: '',
        protocol: '',
        search: ''
      },
      history: {
        replaceState() {},
        pushState() {},
        go() {},
        back() {}
      },
      CustomEvent: function CustomEvent() {
        return this;
      },
      addEventListener() {},
      removeEventListener() {},
      getComputedStyle() {
        return {
          getPropertyValue() {
            return '';
          }
        };
      },
      Image() {},
      Date() {},
      screen: {},
      setTimeout() {},
      clearTimeout() {},
      matchMedia() {
        return {};
      },
      requestAnimationFrame(callback) {
        if (typeof setTimeout === 'undefined') {
          callback();
          return null;
        }
        return setTimeout(callback, 0);
      },
      cancelAnimationFrame(id) {
        if (typeof setTimeout === 'undefined') {
          return;
        }
        clearTimeout(id);
      }
    };
    function getWindow() {
      const win = typeof window !== 'undefined' ? window : {};
      extend$1(win, ssrWindow);
      return win;
    }

    function makeReactive(obj) {
      const proto = obj.__proto__;
      Object.defineProperty(obj, '__proto__', {
        get() {
          return proto;
        },
        set(value) {
          proto.__proto__ = value;
        }
      });
    }
    class Dom7 extends Array {
      constructor(items) {
        if (typeof items === 'number') {
          super(items);
        } else {
          super(...(items || []));
          makeReactive(this);
        }
      }
    }
    function arrayFlat(arr = []) {
      const res = [];
      arr.forEach(el => {
        if (Array.isArray(el)) {
          res.push(...arrayFlat(el));
        } else {
          res.push(el);
        }
      });
      return res;
    }
    function arrayFilter(arr, callback) {
      return Array.prototype.filter.call(arr, callback);
    }
    function arrayUnique(arr) {
      const uniqueArray = [];
      for (let i = 0; i < arr.length; i += 1) {
        if (uniqueArray.indexOf(arr[i]) === -1) uniqueArray.push(arr[i]);
      }
      return uniqueArray;
    }
    function qsa(selector, context) {
      if (typeof selector !== 'string') {
        return [selector];
      }
      const a = [];
      const res = context.querySelectorAll(selector);
      for (let i = 0; i < res.length; i += 1) {
        a.push(res[i]);
      }
      return a;
    }
    function $(selector, context) {
      const window = getWindow();
      const document = getDocument();
      let arr = [];
      if (!context && selector instanceof Dom7) {
        return selector;
      }
      if (!selector) {
        return new Dom7(arr);
      }
      if (typeof selector === 'string') {
        const html = selector.trim();
        if (html.indexOf('<') >= 0 && html.indexOf('>') >= 0) {
          let toCreate = 'div';
          if (html.indexOf('<li') === 0) toCreate = 'ul';
          if (html.indexOf('<tr') === 0) toCreate = 'tbody';
          if (html.indexOf('<td') === 0 || html.indexOf('<th') === 0) toCreate = 'tr';
          if (html.indexOf('<tbody') === 0) toCreate = 'table';
          if (html.indexOf('<option') === 0) toCreate = 'select';
          const tempParent = document.createElement(toCreate);
          tempParent.innerHTML = html;
          for (let i = 0; i < tempParent.childNodes.length; i += 1) {
            arr.push(tempParent.childNodes[i]);
          }
        } else {
          arr = qsa(selector.trim(), context || document);
        }
      } else if (selector.nodeType || selector === window || selector === document) {
        arr.push(selector);
      } else if (Array.isArray(selector)) {
        if (selector instanceof Dom7) return selector;
        arr = selector;
      }
      return new Dom7(arrayUnique(arr));
    }
    $.fn = Dom7.prototype;
    function addClass(...classes) {
      const classNames = arrayFlat(classes.map(c => c.split(' ')));
      this.forEach(el => {
        el.classList.add(...classNames);
      });
      return this;
    }
    function removeClass(...classes) {
      const classNames = arrayFlat(classes.map(c => c.split(' ')));
      this.forEach(el => {
        el.classList.remove(...classNames);
      });
      return this;
    }
    function toggleClass(...classes) {
      const classNames = arrayFlat(classes.map(c => c.split(' ')));
      this.forEach(el => {
        classNames.forEach(className => {
          el.classList.toggle(className);
        });
      });
    }
    function hasClass(...classes) {
      const classNames = arrayFlat(classes.map(c => c.split(' ')));
      return arrayFilter(this, el => {
        return classNames.filter(className => el.classList.contains(className)).length > 0;
      }).length > 0;
    }
    function attr(attrs, value) {
      if (arguments.length === 1 && typeof attrs === 'string') {
        if (this[0]) return this[0].getAttribute(attrs);
        return undefined;
      }
      for (let i = 0; i < this.length; i += 1) {
        if (arguments.length === 2) {
          this[i].setAttribute(attrs, value);
        } else {
          for (const attrName in attrs) {
            this[i][attrName] = attrs[attrName];
            this[i].setAttribute(attrName, attrs[attrName]);
          }
        }
      }
      return this;
    }
    function removeAttr(attr) {
      for (let i = 0; i < this.length; i += 1) {
        this[i].removeAttribute(attr);
      }
      return this;
    }
    function transform(transform) {
      for (let i = 0; i < this.length; i += 1) {
        this[i].style.transform = transform;
      }
      return this;
    }
    function transition$1(duration) {
      for (let i = 0; i < this.length; i += 1) {
        this[i].style.transitionDuration = typeof duration !== 'string' ? `${duration}ms` : duration;
      }
      return this;
    }
    function on(...args) {
      let [eventType, targetSelector, listener, capture] = args;
      if (typeof args[1] === 'function') {
        [eventType, listener, capture] = args;
        targetSelector = undefined;
      }
      if (!capture) capture = false;
      function handleLiveEvent(e) {
        const target = e.target;
        if (!target) return;
        const eventData = e.target.dom7EventData || [];
        if (eventData.indexOf(e) < 0) {
          eventData.unshift(e);
        }
        if ($(target).is(targetSelector)) listener.apply(target, eventData);else {
          const parents = $(target).parents();
          for (let k = 0; k < parents.length; k += 1) {
            if ($(parents[k]).is(targetSelector)) listener.apply(parents[k], eventData);
          }
        }
      }
      function handleEvent(e) {
        const eventData = e && e.target ? e.target.dom7EventData || [] : [];
        if (eventData.indexOf(e) < 0) {
          eventData.unshift(e);
        }
        listener.apply(this, eventData);
      }
      const events = eventType.split(' ');
      let j;
      for (let i = 0; i < this.length; i += 1) {
        const el = this[i];
        if (!targetSelector) {
          for (j = 0; j < events.length; j += 1) {
            const event = events[j];
            if (!el.dom7Listeners) el.dom7Listeners = {};
            if (!el.dom7Listeners[event]) el.dom7Listeners[event] = [];
            el.dom7Listeners[event].push({
              listener,
              proxyListener: handleEvent
            });
            el.addEventListener(event, handleEvent, capture);
          }
        } else {
          for (j = 0; j < events.length; j += 1) {
            const event = events[j];
            if (!el.dom7LiveListeners) el.dom7LiveListeners = {};
            if (!el.dom7LiveListeners[event]) el.dom7LiveListeners[event] = [];
            el.dom7LiveListeners[event].push({
              listener,
              proxyListener: handleLiveEvent
            });
            el.addEventListener(event, handleLiveEvent, capture);
          }
        }
      }
      return this;
    }
    function off(...args) {
      let [eventType, targetSelector, listener, capture] = args;
      if (typeof args[1] === 'function') {
        [eventType, listener, capture] = args;
        targetSelector = undefined;
      }
      if (!capture) capture = false;
      const events = eventType.split(' ');
      for (let i = 0; i < events.length; i += 1) {
        const event = events[i];
        for (let j = 0; j < this.length; j += 1) {
          const el = this[j];
          let handlers;
          if (!targetSelector && el.dom7Listeners) {
            handlers = el.dom7Listeners[event];
          } else if (targetSelector && el.dom7LiveListeners) {
            handlers = el.dom7LiveListeners[event];
          }
          if (handlers && handlers.length) {
            for (let k = handlers.length - 1; k >= 0; k -= 1) {
              const handler = handlers[k];
              if (listener && handler.listener === listener) {
                el.removeEventListener(event, handler.proxyListener, capture);
                handlers.splice(k, 1);
              } else if (listener && handler.listener && handler.listener.dom7proxy && handler.listener.dom7proxy === listener) {
                el.removeEventListener(event, handler.proxyListener, capture);
                handlers.splice(k, 1);
              } else if (!listener) {
                el.removeEventListener(event, handler.proxyListener, capture);
                handlers.splice(k, 1);
              }
            }
          }
        }
      }
      return this;
    }
    function trigger(...args) {
      const window = getWindow();
      const events = args[0].split(' ');
      const eventData = args[1];
      for (let i = 0; i < events.length; i += 1) {
        const event = events[i];
        for (let j = 0; j < this.length; j += 1) {
          const el = this[j];
          if (window.CustomEvent) {
            const evt = new window.CustomEvent(event, {
              detail: eventData,
              bubbles: true,
              cancelable: true
            });
            el.dom7EventData = args.filter((data, dataIndex) => dataIndex > 0);
            el.dispatchEvent(evt);
            el.dom7EventData = [];
            delete el.dom7EventData;
          }
        }
      }
      return this;
    }
    function transitionEnd$1(callback) {
      const dom = this;
      function fireCallBack(e) {
        if (e.target !== this) return;
        callback.call(this, e);
        dom.off('transitionend', fireCallBack);
      }
      if (callback) {
        dom.on('transitionend', fireCallBack);
      }
      return this;
    }
    function outerWidth(includeMargins) {
      if (this.length > 0) {
        if (includeMargins) {
          const styles = this.styles();
          return this[0].offsetWidth + parseFloat(styles.getPropertyValue('margin-right')) + parseFloat(styles.getPropertyValue('margin-left'));
        }
        return this[0].offsetWidth;
      }
      return null;
    }
    function outerHeight(includeMargins) {
      if (this.length > 0) {
        if (includeMargins) {
          const styles = this.styles();
          return this[0].offsetHeight + parseFloat(styles.getPropertyValue('margin-top')) + parseFloat(styles.getPropertyValue('margin-bottom'));
        }
        return this[0].offsetHeight;
      }
      return null;
    }
    function offset() {
      if (this.length > 0) {
        const window = getWindow();
        const document = getDocument();
        const el = this[0];
        const box = el.getBoundingClientRect();
        const body = document.body;
        const clientTop = el.clientTop || body.clientTop || 0;
        const clientLeft = el.clientLeft || body.clientLeft || 0;
        const scrollTop = el === window ? window.scrollY : el.scrollTop;
        const scrollLeft = el === window ? window.scrollX : el.scrollLeft;
        return {
          top: box.top + scrollTop - clientTop,
          left: box.left + scrollLeft - clientLeft
        };
      }
      return null;
    }
    function styles() {
      const window = getWindow();
      if (this[0]) return window.getComputedStyle(this[0], null);
      return {};
    }
    function css(props, value) {
      const window = getWindow();
      let i;
      if (arguments.length === 1) {
        if (typeof props === 'string') {
          if (this[0]) return window.getComputedStyle(this[0], null).getPropertyValue(props);
        } else {
          for (i = 0; i < this.length; i += 1) {
            for (const prop in props) {
              this[i].style[prop] = props[prop];
            }
          }
          return this;
        }
      }
      if (arguments.length === 2 && typeof props === 'string') {
        for (i = 0; i < this.length; i += 1) {
          this[i].style[props] = value;
        }
        return this;
      }
      return this;
    }
    function each(callback) {
      if (!callback) return this;
      this.forEach((el, index) => {
        callback.apply(el, [el, index]);
      });
      return this;
    }
    function filter(callback) {
      const result = arrayFilter(this, callback);
      return $(result);
    }
    function html(html) {
      if (typeof html === 'undefined') {
        return this[0] ? this[0].innerHTML : null;
      }
      for (let i = 0; i < this.length; i += 1) {
        this[i].innerHTML = html;
      }
      return this;
    }
    function text(text) {
      if (typeof text === 'undefined') {
        return this[0] ? this[0].textContent.trim() : null;
      }
      for (let i = 0; i < this.length; i += 1) {
        this[i].textContent = text;
      }
      return this;
    }
    function is(selector) {
      const window = getWindow();
      const document = getDocument();
      const el = this[0];
      let compareWith;
      let i;
      if (!el || typeof selector === 'undefined') return false;
      if (typeof selector === 'string') {
        if (el.matches) return el.matches(selector);
        if (el.webkitMatchesSelector) return el.webkitMatchesSelector(selector);
        if (el.msMatchesSelector) return el.msMatchesSelector(selector);
        compareWith = $(selector);
        for (i = 0; i < compareWith.length; i += 1) {
          if (compareWith[i] === el) return true;
        }
        return false;
      }
      if (selector === document) {
        return el === document;
      }
      if (selector === window) {
        return el === window;
      }
      if (selector.nodeType || selector instanceof Dom7) {
        compareWith = selector.nodeType ? [selector] : selector;
        for (i = 0; i < compareWith.length; i += 1) {
          if (compareWith[i] === el) return true;
        }
        return false;
      }
      return false;
    }
    function index() {
      let child = this[0];
      let i;
      if (child) {
        i = 0;
        while ((child = child.previousSibling) !== null) {
          if (child.nodeType === 1) i += 1;
        }
        return i;
      }
      return undefined;
    }
    function eq(index) {
      if (typeof index === 'undefined') return this;
      const length = this.length;
      if (index > length - 1) {
        return $([]);
      }
      if (index < 0) {
        const returnIndex = length + index;
        if (returnIndex < 0) return $([]);
        return $([this[returnIndex]]);
      }
      return $([this[index]]);
    }
    function append(...els) {
      let newChild;
      const document = getDocument();
      for (let k = 0; k < els.length; k += 1) {
        newChild = els[k];
        for (let i = 0; i < this.length; i += 1) {
          if (typeof newChild === 'string') {
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = newChild;
            while (tempDiv.firstChild) {
              this[i].appendChild(tempDiv.firstChild);
            }
          } else if (newChild instanceof Dom7) {
            for (let j = 0; j < newChild.length; j += 1) {
              this[i].appendChild(newChild[j]);
            }
          } else {
            this[i].appendChild(newChild);
          }
        }
      }
      return this;
    }
    function prepend(newChild) {
      const document = getDocument();
      let i;
      let j;
      for (i = 0; i < this.length; i += 1) {
        if (typeof newChild === 'string') {
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = newChild;
          for (j = tempDiv.childNodes.length - 1; j >= 0; j -= 1) {
            this[i].insertBefore(tempDiv.childNodes[j], this[i].childNodes[0]);
          }
        } else if (newChild instanceof Dom7) {
          for (j = 0; j < newChild.length; j += 1) {
            this[i].insertBefore(newChild[j], this[i].childNodes[0]);
          }
        } else {
          this[i].insertBefore(newChild, this[i].childNodes[0]);
        }
      }
      return this;
    }
    function next(selector) {
      if (this.length > 0) {
        if (selector) {
          if (this[0].nextElementSibling && $(this[0].nextElementSibling).is(selector)) {
            return $([this[0].nextElementSibling]);
          }
          return $([]);
        }
        if (this[0].nextElementSibling) return $([this[0].nextElementSibling]);
        return $([]);
      }
      return $([]);
    }
    function nextAll(selector) {
      const nextEls = [];
      let el = this[0];
      if (!el) return $([]);
      while (el.nextElementSibling) {
        const next = el.nextElementSibling;
        if (selector) {
          if ($(next).is(selector)) nextEls.push(next);
        } else nextEls.push(next);
        el = next;
      }
      return $(nextEls);
    }
    function prev(selector) {
      if (this.length > 0) {
        const el = this[0];
        if (selector) {
          if (el.previousElementSibling && $(el.previousElementSibling).is(selector)) {
            return $([el.previousElementSibling]);
          }
          return $([]);
        }
        if (el.previousElementSibling) return $([el.previousElementSibling]);
        return $([]);
      }
      return $([]);
    }
    function prevAll(selector) {
      const prevEls = [];
      let el = this[0];
      if (!el) return $([]);
      while (el.previousElementSibling) {
        const prev = el.previousElementSibling;
        if (selector) {
          if ($(prev).is(selector)) prevEls.push(prev);
        } else prevEls.push(prev);
        el = prev;
      }
      return $(prevEls);
    }
    function parent(selector) {
      const parents = [];
      for (let i = 0; i < this.length; i += 1) {
        if (this[i].parentNode !== null) {
          if (selector) {
            if ($(this[i].parentNode).is(selector)) parents.push(this[i].parentNode);
          } else {
            parents.push(this[i].parentNode);
          }
        }
      }
      return $(parents);
    }
    function parents(selector) {
      const parents = [];
      for (let i = 0; i < this.length; i += 1) {
        let parent = this[i].parentNode;
        while (parent) {
          if (selector) {
            if ($(parent).is(selector)) parents.push(parent);
          } else {
            parents.push(parent);
          }
          parent = parent.parentNode;
        }
      }
      return $(parents);
    }
    function closest(selector) {
      let closest = this;
      if (typeof selector === 'undefined') {
        return $([]);
      }
      if (!closest.is(selector)) {
        closest = closest.parents(selector).eq(0);
      }
      return closest;
    }
    function find(selector) {
      const foundElements = [];
      for (let i = 0; i < this.length; i += 1) {
        const found = this[i].querySelectorAll(selector);
        for (let j = 0; j < found.length; j += 1) {
          foundElements.push(found[j]);
        }
      }
      return $(foundElements);
    }
    function children(selector) {
      const children = [];
      for (let i = 0; i < this.length; i += 1) {
        const childNodes = this[i].children;
        for (let j = 0; j < childNodes.length; j += 1) {
          if (!selector || $(childNodes[j]).is(selector)) {
            children.push(childNodes[j]);
          }
        }
      }
      return $(children);
    }
    function remove() {
      for (let i = 0; i < this.length; i += 1) {
        if (this[i].parentNode) this[i].parentNode.removeChild(this[i]);
      }
      return this;
    }

    const Methods = {
      addClass,
      removeClass,
      hasClass,
      toggleClass,
      attr,
      removeAttr,
      transform,
      transition: transition$1,
      on,
      off,
      trigger,
      transitionEnd: transitionEnd$1,
      outerWidth,
      outerHeight,
      styles,
      offset,
      css,
      each,
      html,
      text,
      is,
      index,
      eq,
      append,
      prepend,
      next,
      nextAll,
      prev,
      prevAll,
      parent,
      parents,
      closest,
      find,
      children,
      filter,
      remove
    };
    Object.keys(Methods).forEach(methodName => {
      Object.defineProperty($.fn, methodName, {
        value: Methods[methodName],
        writable: true
      });
    });

    function deleteProps(obj) {
      const object = obj;
      Object.keys(object).forEach(key => {
        try {
          object[key] = null;
        } catch (e) {}
        try {
          delete object[key];
        } catch (e) {}
      });
    }
    function nextTick(callback, delay = 0) {
      return setTimeout(callback, delay);
    }
    function now() {
      return Date.now();
    }
    function getComputedStyle$1(el) {
      const window = getWindow();
      let style;
      if (window.getComputedStyle) {
        style = window.getComputedStyle(el, null);
      }
      if (!style && el.currentStyle) {
        style = el.currentStyle;
      }
      if (!style) {
        style = el.style;
      }
      return style;
    }
    function getTranslate(el, axis = 'x') {
      const window = getWindow();
      let matrix;
      let curTransform;
      let transformMatrix;
      const curStyle = getComputedStyle$1(el);
      if (window.WebKitCSSMatrix) {
        curTransform = curStyle.transform || curStyle.webkitTransform;
        if (curTransform.split(',').length > 6) {
          curTransform = curTransform.split(', ').map(a => a.replace(',', '.')).join(', ');
        }
        transformMatrix = new window.WebKitCSSMatrix(curTransform === 'none' ? '' : curTransform);
      } else {
        transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue('transform').replace('translate(', 'matrix(1, 0, 0, 1,');
        matrix = transformMatrix.toString().split(',');
      }
      if (axis === 'x') {
        if (window.WebKitCSSMatrix) curTransform = transformMatrix.m41;else if (matrix.length === 16) curTransform = parseFloat(matrix[12]);else curTransform = parseFloat(matrix[4]);
      }
      if (axis === 'y') {
        if (window.WebKitCSSMatrix) curTransform = transformMatrix.m42;else if (matrix.length === 16) curTransform = parseFloat(matrix[13]);else curTransform = parseFloat(matrix[5]);
      }
      return curTransform || 0;
    }
    function isObject(o) {
      return typeof o === 'object' && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === 'Object';
    }
    function isNode(node) {
      if (typeof window !== 'undefined' && typeof window.HTMLElement !== 'undefined') {
        return node instanceof HTMLElement;
      }
      return node && (node.nodeType === 1 || node.nodeType === 11);
    }
    function extend(...args) {
      const to = Object(args[0]);
      const noExtend = ['__proto__', 'constructor', 'prototype'];
      for (let i = 1; i < args.length; i += 1) {
        const nextSource = args[i];
        if (nextSource !== undefined && nextSource !== null && !isNode(nextSource)) {
          const keysArray = Object.keys(Object(nextSource)).filter(key => noExtend.indexOf(key) < 0);
          for (let nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1) {
            const nextKey = keysArray[nextIndex];
            const desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
            if (desc !== undefined && desc.enumerable) {
              if (isObject(to[nextKey]) && isObject(nextSource[nextKey])) {
                if (nextSource[nextKey].__swiper__) {
                  to[nextKey] = nextSource[nextKey];
                } else {
                  extend(to[nextKey], nextSource[nextKey]);
                }
              } else if (!isObject(to[nextKey]) && isObject(nextSource[nextKey])) {
                to[nextKey] = {};
                if (nextSource[nextKey].__swiper__) {
                  to[nextKey] = nextSource[nextKey];
                } else {
                  extend(to[nextKey], nextSource[nextKey]);
                }
              } else {
                to[nextKey] = nextSource[nextKey];
              }
            }
          }
        }
      }
      return to;
    }
    function setCSSProperty(el, varName, varValue) {
      el.style.setProperty(varName, varValue);
    }
    function animateCSSModeScroll({
      swiper,
      targetPosition,
      side
    }) {
      const window = getWindow();
      const startPosition = -swiper.translate;
      let startTime = null;
      let time;
      const duration = swiper.params.speed;
      swiper.wrapperEl.style.scrollSnapType = 'none';
      window.cancelAnimationFrame(swiper.cssModeFrameID);
      const dir = targetPosition > startPosition ? 'next' : 'prev';
      const isOutOfBound = (current, target) => {
        return dir === 'next' && current >= target || dir === 'prev' && current <= target;
      };
      const animate = () => {
        time = new Date().getTime();
        if (startTime === null) {
          startTime = time;
        }
        const progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
        const easeProgress = 0.5 - Math.cos(progress * Math.PI) / 2;
        let currentPosition = startPosition + easeProgress * (targetPosition - startPosition);
        if (isOutOfBound(currentPosition, targetPosition)) {
          currentPosition = targetPosition;
        }
        swiper.wrapperEl.scrollTo({
          [side]: currentPosition
        });
        if (isOutOfBound(currentPosition, targetPosition)) {
          swiper.wrapperEl.style.overflow = 'hidden';
          swiper.wrapperEl.style.scrollSnapType = '';
          setTimeout(() => {
            swiper.wrapperEl.style.overflow = '';
            swiper.wrapperEl.scrollTo({
              [side]: currentPosition
            });
          });
          window.cancelAnimationFrame(swiper.cssModeFrameID);
          return;
        }
        swiper.cssModeFrameID = window.requestAnimationFrame(animate);
      };
      animate();
    }

    let support;
    function calcSupport() {
      const window = getWindow();
      const document = getDocument();
      return {
        smoothScroll: document.documentElement && 'scrollBehavior' in document.documentElement.style,
        touch: !!('ontouchstart' in window || window.DocumentTouch && document instanceof window.DocumentTouch),
        passiveListener: function checkPassiveListener() {
          let supportsPassive = false;
          try {
            const opts = Object.defineProperty({}, 'passive', {
              get() {
                supportsPassive = true;
              }
            });
            window.addEventListener('testPassiveListener', null, opts);
          } catch (e) {}
          return supportsPassive;
        }(),
        gestures: function checkGestures() {
          return 'ongesturestart' in window;
        }()
      };
    }
    function getSupport() {
      if (!support) {
        support = calcSupport();
      }
      return support;
    }

    let deviceCached;
    function calcDevice({
      userAgent
    } = {}) {
      const support = getSupport();
      const window = getWindow();
      const platform = window.navigator.platform;
      const ua = userAgent || window.navigator.userAgent;
      const device = {
        ios: false,
        android: false
      };
      const screenWidth = window.screen.width;
      const screenHeight = window.screen.height;
      const android = ua.match(/(Android);?[\s\/]+([\d.]+)?/);
      let ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
      const ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
      const iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
      const windows = platform === 'Win32';
      let macos = platform === 'MacIntel';
      const iPadScreens = ['1024x1366', '1366x1024', '834x1194', '1194x834', '834x1112', '1112x834', '768x1024', '1024x768', '820x1180', '1180x820', '810x1080', '1080x810'];
      if (!ipad && macos && support.touch && iPadScreens.indexOf(`${screenWidth}x${screenHeight}`) >= 0) {
        ipad = ua.match(/(Version)\/([\d.]+)/);
        if (!ipad) ipad = [0, 1, '13_0_0'];
        macos = false;
      }
      if (android && !windows) {
        device.os = 'android';
        device.android = true;
      }
      if (ipad || iphone || ipod) {
        device.os = 'ios';
        device.ios = true;
      }
      return device;
    }
    function getDevice(overrides = {}) {
      if (!deviceCached) {
        deviceCached = calcDevice(overrides);
      }
      return deviceCached;
    }

    let browser;
    function calcBrowser() {
      const window = getWindow();
      function isSafari() {
        const ua = window.navigator.userAgent.toLowerCase();
        return ua.indexOf('safari') >= 0 && ua.indexOf('chrome') < 0 && ua.indexOf('android') < 0;
      }
      return {
        isSafari: isSafari(),
        isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window.navigator.userAgent)
      };
    }
    function getBrowser() {
      if (!browser) {
        browser = calcBrowser();
      }
      return browser;
    }

    function Resize({
      swiper,
      on,
      emit
    }) {
      const window = getWindow();
      let observer = null;
      let animationFrame = null;
      const resizeHandler = () => {
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        emit('beforeResize');
        emit('resize');
      };
      const createObserver = () => {
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        observer = new ResizeObserver(entries => {
          animationFrame = window.requestAnimationFrame(() => {
            const {
              width,
              height
            } = swiper;
            let newWidth = width;
            let newHeight = height;
            entries.forEach(({
              contentBoxSize,
              contentRect,
              target
            }) => {
              if (target && target !== swiper.el) return;
              newWidth = contentRect ? contentRect.width : (contentBoxSize[0] || contentBoxSize).inlineSize;
              newHeight = contentRect ? contentRect.height : (contentBoxSize[0] || contentBoxSize).blockSize;
            });
            if (newWidth !== width || newHeight !== height) {
              resizeHandler();
            }
          });
        });
        observer.observe(swiper.el);
      };
      const removeObserver = () => {
        if (animationFrame) {
          window.cancelAnimationFrame(animationFrame);
        }
        if (observer && observer.unobserve && swiper.el) {
          observer.unobserve(swiper.el);
          observer = null;
        }
      };
      const orientationChangeHandler = () => {
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        emit('orientationchange');
      };
      on('init', () => {
        if (swiper.params.resizeObserver && typeof window.ResizeObserver !== 'undefined') {
          createObserver();
          return;
        }
        window.addEventListener('resize', resizeHandler);
        window.addEventListener('orientationchange', orientationChangeHandler);
      });
      on('destroy', () => {
        removeObserver();
        window.removeEventListener('resize', resizeHandler);
        window.removeEventListener('orientationchange', orientationChangeHandler);
      });
    }

    function Observer({
      swiper,
      extendParams,
      on,
      emit
    }) {
      const observers = [];
      const window = getWindow();
      const attach = (target, options = {}) => {
        const ObserverFunc = window.MutationObserver || window.WebkitMutationObserver;
        const observer = new ObserverFunc(mutations => {
          if (mutations.length === 1) {
            emit('observerUpdate', mutations[0]);
            return;
          }
          const observerUpdate = function observerUpdate() {
            emit('observerUpdate', mutations[0]);
          };
          if (window.requestAnimationFrame) {
            window.requestAnimationFrame(observerUpdate);
          } else {
            window.setTimeout(observerUpdate, 0);
          }
        });
        observer.observe(target, {
          attributes: typeof options.attributes === 'undefined' ? true : options.attributes,
          childList: typeof options.childList === 'undefined' ? true : options.childList,
          characterData: typeof options.characterData === 'undefined' ? true : options.characterData
        });
        observers.push(observer);
      };
      const init = () => {
        if (!swiper.params.observer) return;
        if (swiper.params.observeParents) {
          const containerParents = swiper.$el.parents();
          for (let i = 0; i < containerParents.length; i += 1) {
            attach(containerParents[i]);
          }
        }
        attach(swiper.$el[0], {
          childList: swiper.params.observeSlideChildren
        });
        attach(swiper.$wrapperEl[0], {
          attributes: false
        });
      };
      const destroy = () => {
        observers.forEach(observer => {
          observer.disconnect();
        });
        observers.splice(0, observers.length);
      };
      extendParams({
        observer: false,
        observeParents: false,
        observeSlideChildren: false
      });
      on('init', init);
      on('destroy', destroy);
    }

    var eventsEmitter = {
      on(events, handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== 'function') return self;
        const method = priority ? 'unshift' : 'push';
        events.split(' ').forEach(event => {
          if (!self.eventsListeners[event]) self.eventsListeners[event] = [];
          self.eventsListeners[event][method](handler);
        });
        return self;
      },
      once(events, handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== 'function') return self;
        function onceHandler(...args) {
          self.off(events, onceHandler);
          if (onceHandler.__emitterProxy) {
            delete onceHandler.__emitterProxy;
          }
          handler.apply(self, args);
        }
        onceHandler.__emitterProxy = handler;
        return self.on(events, onceHandler, priority);
      },
      onAny(handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== 'function') return self;
        const method = priority ? 'unshift' : 'push';
        if (self.eventsAnyListeners.indexOf(handler) < 0) {
          self.eventsAnyListeners[method](handler);
        }
        return self;
      },
      offAny(handler) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsAnyListeners) return self;
        const index = self.eventsAnyListeners.indexOf(handler);
        if (index >= 0) {
          self.eventsAnyListeners.splice(index, 1);
        }
        return self;
      },
      off(events, handler) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsListeners) return self;
        events.split(' ').forEach(event => {
          if (typeof handler === 'undefined') {
            self.eventsListeners[event] = [];
          } else if (self.eventsListeners[event]) {
            self.eventsListeners[event].forEach((eventHandler, index) => {
              if (eventHandler === handler || eventHandler.__emitterProxy && eventHandler.__emitterProxy === handler) {
                self.eventsListeners[event].splice(index, 1);
              }
            });
          }
        });
        return self;
      },
      emit(...args) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsListeners) return self;
        let events;
        let data;
        let context;
        if (typeof args[0] === 'string' || Array.isArray(args[0])) {
          events = args[0];
          data = args.slice(1, args.length);
          context = self;
        } else {
          events = args[0].events;
          data = args[0].data;
          context = args[0].context || self;
        }
        data.unshift(context);
        const eventsArray = Array.isArray(events) ? events : events.split(' ');
        eventsArray.forEach(event => {
          if (self.eventsAnyListeners && self.eventsAnyListeners.length) {
            self.eventsAnyListeners.forEach(eventHandler => {
              eventHandler.apply(context, [event, ...data]);
            });
          }
          if (self.eventsListeners && self.eventsListeners[event]) {
            self.eventsListeners[event].forEach(eventHandler => {
              eventHandler.apply(context, data);
            });
          }
        });
        return self;
      }
    };

    function updateSize() {
      const swiper = this;
      let width;
      let height;
      const $el = swiper.$el;
      if (typeof swiper.params.width !== 'undefined' && swiper.params.width !== null) {
        width = swiper.params.width;
      } else {
        width = $el[0].clientWidth;
      }
      if (typeof swiper.params.height !== 'undefined' && swiper.params.height !== null) {
        height = swiper.params.height;
      } else {
        height = $el[0].clientHeight;
      }
      if (width === 0 && swiper.isHorizontal() || height === 0 && swiper.isVertical()) {
        return;
      }
      width = width - parseInt($el.css('padding-left') || 0, 10) - parseInt($el.css('padding-right') || 0, 10);
      height = height - parseInt($el.css('padding-top') || 0, 10) - parseInt($el.css('padding-bottom') || 0, 10);
      if (Number.isNaN(width)) width = 0;
      if (Number.isNaN(height)) height = 0;
      Object.assign(swiper, {
        width,
        height,
        size: swiper.isHorizontal() ? width : height
      });
    }

    function updateSlides() {
      const swiper = this;
      function getDirectionLabel(property) {
        if (swiper.isHorizontal()) {
          return property;
        }
        return {
          'width': 'height',
          'margin-top': 'margin-left',
          'margin-bottom ': 'margin-right',
          'margin-left': 'margin-top',
          'margin-right': 'margin-bottom',
          'padding-left': 'padding-top',
          'padding-right': 'padding-bottom',
          'marginRight': 'marginBottom'
        }[property];
      }
      function getDirectionPropertyValue(node, label) {
        return parseFloat(node.getPropertyValue(getDirectionLabel(label)) || 0);
      }
      const params = swiper.params;
      const {
        $wrapperEl,
        size: swiperSize,
        rtlTranslate: rtl,
        wrongRTL
      } = swiper;
      const isVirtual = swiper.virtual && params.virtual.enabled;
      const previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
      const slides = $wrapperEl.children(`.${swiper.params.slideClass}`);
      const slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
      let snapGrid = [];
      const slidesGrid = [];
      const slidesSizesGrid = [];
      let offsetBefore = params.slidesOffsetBefore;
      if (typeof offsetBefore === 'function') {
        offsetBefore = params.slidesOffsetBefore.call(swiper);
      }
      let offsetAfter = params.slidesOffsetAfter;
      if (typeof offsetAfter === 'function') {
        offsetAfter = params.slidesOffsetAfter.call(swiper);
      }
      const previousSnapGridLength = swiper.snapGrid.length;
      const previousSlidesGridLength = swiper.slidesGrid.length;
      let spaceBetween = params.spaceBetween;
      let slidePosition = -offsetBefore;
      let prevSlideSize = 0;
      let index = 0;
      if (typeof swiperSize === 'undefined') {
        return;
      }
      if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) {
        spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiperSize;
      }
      swiper.virtualSize = -spaceBetween;
      if (rtl) slides.css({
        marginLeft: '',
        marginBottom: '',
        marginTop: ''
      });else slides.css({
        marginRight: '',
        marginBottom: '',
        marginTop: ''
      });
      if (params.centeredSlides && params.cssMode) {
        setCSSProperty(swiper.wrapperEl, '--swiper-centered-offset-before', '');
        setCSSProperty(swiper.wrapperEl, '--swiper-centered-offset-after', '');
      }
      const gridEnabled = params.grid && params.grid.rows > 1 && swiper.grid;
      if (gridEnabled) {
        swiper.grid.initSlides(slidesLength);
      }
      let slideSize;
      const shouldResetSlideSize = params.slidesPerView === 'auto' && params.breakpoints && Object.keys(params.breakpoints).filter(key => {
        return typeof params.breakpoints[key].slidesPerView !== 'undefined';
      }).length > 0;
      for (let i = 0; i < slidesLength; i += 1) {
        slideSize = 0;
        const slide = slides.eq(i);
        if (gridEnabled) {
          swiper.grid.updateSlide(i, slide, slidesLength, getDirectionLabel);
        }
        if (slide.css('display') === 'none') continue;
        if (params.slidesPerView === 'auto') {
          if (shouldResetSlideSize) {
            slides[i].style[getDirectionLabel('width')] = ``;
          }
          const slideStyles = getComputedStyle(slide[0]);
          const currentTransform = slide[0].style.transform;
          const currentWebKitTransform = slide[0].style.webkitTransform;
          if (currentTransform) {
            slide[0].style.transform = 'none';
          }
          if (currentWebKitTransform) {
            slide[0].style.webkitTransform = 'none';
          }
          if (params.roundLengths) {
            slideSize = swiper.isHorizontal() ? slide.outerWidth(true) : slide.outerHeight(true);
          } else {
            const width = getDirectionPropertyValue(slideStyles, 'width');
            const paddingLeft = getDirectionPropertyValue(slideStyles, 'padding-left');
            const paddingRight = getDirectionPropertyValue(slideStyles, 'padding-right');
            const marginLeft = getDirectionPropertyValue(slideStyles, 'margin-left');
            const marginRight = getDirectionPropertyValue(slideStyles, 'margin-right');
            const boxSizing = slideStyles.getPropertyValue('box-sizing');
            if (boxSizing && boxSizing === 'border-box') {
              slideSize = width + marginLeft + marginRight;
            } else {
              const {
                clientWidth,
                offsetWidth
              } = slide[0];
              slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight + (offsetWidth - clientWidth);
            }
          }
          if (currentTransform) {
            slide[0].style.transform = currentTransform;
          }
          if (currentWebKitTransform) {
            slide[0].style.webkitTransform = currentWebKitTransform;
          }
          if (params.roundLengths) slideSize = Math.floor(slideSize);
        } else {
          slideSize = (swiperSize - (params.slidesPerView - 1) * spaceBetween) / params.slidesPerView;
          if (params.roundLengths) slideSize = Math.floor(slideSize);
          if (slides[i]) {
            slides[i].style[getDirectionLabel('width')] = `${slideSize}px`;
          }
        }
        if (slides[i]) {
          slides[i].swiperSlideSize = slideSize;
        }
        slidesSizesGrid.push(slideSize);
        if (params.centeredSlides) {
          slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
          if (prevSlideSize === 0 && i !== 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
          if (i === 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
          if (Math.abs(slidePosition) < 1 / 1000) slidePosition = 0;
          if (params.roundLengths) slidePosition = Math.floor(slidePosition);
          if (index % params.slidesPerGroup === 0) snapGrid.push(slidePosition);
          slidesGrid.push(slidePosition);
        } else {
          if (params.roundLengths) slidePosition = Math.floor(slidePosition);
          if ((index - Math.min(swiper.params.slidesPerGroupSkip, index)) % swiper.params.slidesPerGroup === 0) snapGrid.push(slidePosition);
          slidesGrid.push(slidePosition);
          slidePosition = slidePosition + slideSize + spaceBetween;
        }
        swiper.virtualSize += slideSize + spaceBetween;
        prevSlideSize = slideSize;
        index += 1;
      }
      swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
      if (rtl && wrongRTL && (params.effect === 'slide' || params.effect === 'coverflow')) {
        $wrapperEl.css({
          width: `${swiper.virtualSize + params.spaceBetween}px`
        });
      }
      if (params.setWrapperSize) {
        $wrapperEl.css({
          [getDirectionLabel('width')]: `${swiper.virtualSize + params.spaceBetween}px`
        });
      }
      if (gridEnabled) {
        swiper.grid.updateWrapperSize(slideSize, snapGrid, getDirectionLabel);
      }
      if (!params.centeredSlides) {
        const newSlidesGrid = [];
        for (let i = 0; i < snapGrid.length; i += 1) {
          let slidesGridItem = snapGrid[i];
          if (params.roundLengths) slidesGridItem = Math.floor(slidesGridItem);
          if (snapGrid[i] <= swiper.virtualSize - swiperSize) {
            newSlidesGrid.push(slidesGridItem);
          }
        }
        snapGrid = newSlidesGrid;
        if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) {
          snapGrid.push(swiper.virtualSize - swiperSize);
        }
      }
      if (snapGrid.length === 0) snapGrid = [0];
      if (params.spaceBetween !== 0) {
        const key = swiper.isHorizontal() && rtl ? 'marginLeft' : getDirectionLabel('marginRight');
        slides.filter((_, slideIndex) => {
          if (!params.cssMode) return true;
          if (slideIndex === slides.length - 1) {
            return false;
          }
          return true;
        }).css({
          [key]: `${spaceBetween}px`
        });
      }
      if (params.centeredSlides && params.centeredSlidesBounds) {
        let allSlidesSize = 0;
        slidesSizesGrid.forEach(slideSizeValue => {
          allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
        });
        allSlidesSize -= params.spaceBetween;
        const maxSnap = allSlidesSize - swiperSize;
        snapGrid = snapGrid.map(snap => {
          if (snap < 0) return -offsetBefore;
          if (snap > maxSnap) return maxSnap + offsetAfter;
          return snap;
        });
      }
      if (params.centerInsufficientSlides) {
        let allSlidesSize = 0;
        slidesSizesGrid.forEach(slideSizeValue => {
          allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
        });
        allSlidesSize -= params.spaceBetween;
        if (allSlidesSize < swiperSize) {
          const allSlidesOffset = (swiperSize - allSlidesSize) / 2;
          snapGrid.forEach((snap, snapIndex) => {
            snapGrid[snapIndex] = snap - allSlidesOffset;
          });
          slidesGrid.forEach((snap, snapIndex) => {
            slidesGrid[snapIndex] = snap + allSlidesOffset;
          });
        }
      }
      Object.assign(swiper, {
        slides,
        snapGrid,
        slidesGrid,
        slidesSizesGrid
      });
      if (params.centeredSlides && params.cssMode && !params.centeredSlidesBounds) {
        setCSSProperty(swiper.wrapperEl, '--swiper-centered-offset-before', `${-snapGrid[0]}px`);
        setCSSProperty(swiper.wrapperEl, '--swiper-centered-offset-after', `${swiper.size / 2 - slidesSizesGrid[slidesSizesGrid.length - 1] / 2}px`);
        const addToSnapGrid = -swiper.snapGrid[0];
        const addToSlidesGrid = -swiper.slidesGrid[0];
        swiper.snapGrid = swiper.snapGrid.map(v => v + addToSnapGrid);
        swiper.slidesGrid = swiper.slidesGrid.map(v => v + addToSlidesGrid);
      }
      if (slidesLength !== previousSlidesLength) {
        swiper.emit('slidesLengthChange');
      }
      if (snapGrid.length !== previousSnapGridLength) {
        if (swiper.params.watchOverflow) swiper.checkOverflow();
        swiper.emit('snapGridLengthChange');
      }
      if (slidesGrid.length !== previousSlidesGridLength) {
        swiper.emit('slidesGridLengthChange');
      }
      if (params.watchSlidesProgress) {
        swiper.updateSlidesOffset();
      }
      if (!isVirtual && !params.cssMode && (params.effect === 'slide' || params.effect === 'fade')) {
        const backFaceHiddenClass = `${params.containerModifierClass}backface-hidden`;
        const hasClassBackfaceClassAdded = swiper.$el.hasClass(backFaceHiddenClass);
        if (slidesLength <= params.maxBackfaceHiddenSlides) {
          if (!hasClassBackfaceClassAdded) swiper.$el.addClass(backFaceHiddenClass);
        } else if (hasClassBackfaceClassAdded) {
          swiper.$el.removeClass(backFaceHiddenClass);
        }
      }
    }

    function updateAutoHeight(speed) {
      const swiper = this;
      const activeSlides = [];
      const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
      let newHeight = 0;
      let i;
      if (typeof speed === 'number') {
        swiper.setTransition(speed);
      } else if (speed === true) {
        swiper.setTransition(swiper.params.speed);
      }
      const getSlideByIndex = index => {
        if (isVirtual) {
          return swiper.slides.filter(el => parseInt(el.getAttribute('data-swiper-slide-index'), 10) === index)[0];
        }
        return swiper.slides.eq(index)[0];
      };
      if (swiper.params.slidesPerView !== 'auto' && swiper.params.slidesPerView > 1) {
        if (swiper.params.centeredSlides) {
          (swiper.visibleSlides || $([])).each(slide => {
            activeSlides.push(slide);
          });
        } else {
          for (i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1) {
            const index = swiper.activeIndex + i;
            if (index > swiper.slides.length && !isVirtual) break;
            activeSlides.push(getSlideByIndex(index));
          }
        }
      } else {
        activeSlides.push(getSlideByIndex(swiper.activeIndex));
      }
      for (i = 0; i < activeSlides.length; i += 1) {
        if (typeof activeSlides[i] !== 'undefined') {
          const height = activeSlides[i].offsetHeight;
          newHeight = height > newHeight ? height : newHeight;
        }
      }
      if (newHeight || newHeight === 0) swiper.$wrapperEl.css('height', `${newHeight}px`);
    }

    function updateSlidesOffset() {
      const swiper = this;
      const slides = swiper.slides;
      for (let i = 0; i < slides.length; i += 1) {
        slides[i].swiperSlideOffset = swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop;
      }
    }

    function updateSlidesProgress(translate = this && this.translate || 0) {
      const swiper = this;
      const params = swiper.params;
      const {
        slides,
        rtlTranslate: rtl,
        snapGrid
      } = swiper;
      if (slides.length === 0) return;
      if (typeof slides[0].swiperSlideOffset === 'undefined') swiper.updateSlidesOffset();
      let offsetCenter = -translate;
      if (rtl) offsetCenter = translate;
      slides.removeClass(params.slideVisibleClass);
      swiper.visibleSlidesIndexes = [];
      swiper.visibleSlides = [];
      for (let i = 0; i < slides.length; i += 1) {
        const slide = slides[i];
        let slideOffset = slide.swiperSlideOffset;
        if (params.cssMode && params.centeredSlides) {
          slideOffset -= slides[0].swiperSlideOffset;
        }
        const slideProgress = (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + params.spaceBetween);
        const originalSlideProgress = (offsetCenter - snapGrid[0] + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + params.spaceBetween);
        const slideBefore = -(offsetCenter - slideOffset);
        const slideAfter = slideBefore + swiper.slidesSizesGrid[i];
        const isVisible = slideBefore >= 0 && slideBefore < swiper.size - 1 || slideAfter > 1 && slideAfter <= swiper.size || slideBefore <= 0 && slideAfter >= swiper.size;
        if (isVisible) {
          swiper.visibleSlides.push(slide);
          swiper.visibleSlidesIndexes.push(i);
          slides.eq(i).addClass(params.slideVisibleClass);
        }
        slide.progress = rtl ? -slideProgress : slideProgress;
        slide.originalProgress = rtl ? -originalSlideProgress : originalSlideProgress;
      }
      swiper.visibleSlides = $(swiper.visibleSlides);
    }

    function updateProgress(translate) {
      const swiper = this;
      if (typeof translate === 'undefined') {
        const multiplier = swiper.rtlTranslate ? -1 : 1;
        translate = swiper && swiper.translate && swiper.translate * multiplier || 0;
      }
      const params = swiper.params;
      const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
      let {
        progress,
        isBeginning,
        isEnd
      } = swiper;
      const wasBeginning = isBeginning;
      const wasEnd = isEnd;
      if (translatesDiff === 0) {
        progress = 0;
        isBeginning = true;
        isEnd = true;
      } else {
        progress = (translate - swiper.minTranslate()) / translatesDiff;
        isBeginning = progress <= 0;
        isEnd = progress >= 1;
      }
      Object.assign(swiper, {
        progress,
        isBeginning,
        isEnd
      });
      if (params.watchSlidesProgress || params.centeredSlides && params.autoHeight) swiper.updateSlidesProgress(translate);
      if (isBeginning && !wasBeginning) {
        swiper.emit('reachBeginning toEdge');
      }
      if (isEnd && !wasEnd) {
        swiper.emit('reachEnd toEdge');
      }
      if (wasBeginning && !isBeginning || wasEnd && !isEnd) {
        swiper.emit('fromEdge');
      }
      swiper.emit('progress', progress);
    }

    function updateSlidesClasses() {
      const swiper = this;
      const {
        slides,
        params,
        $wrapperEl,
        activeIndex,
        realIndex
      } = swiper;
      const isVirtual = swiper.virtual && params.virtual.enabled;
      slides.removeClass(`${params.slideActiveClass} ${params.slideNextClass} ${params.slidePrevClass} ${params.slideDuplicateActiveClass} ${params.slideDuplicateNextClass} ${params.slideDuplicatePrevClass}`);
      let activeSlide;
      if (isVirtual) {
        activeSlide = swiper.$wrapperEl.find(`.${params.slideClass}[data-swiper-slide-index="${activeIndex}"]`);
      } else {
        activeSlide = slides.eq(activeIndex);
      }
      activeSlide.addClass(params.slideActiveClass);
      if (params.loop) {
        if (activeSlide.hasClass(params.slideDuplicateClass)) {
          $wrapperEl.children(`.${params.slideClass}:not(.${params.slideDuplicateClass})[data-swiper-slide-index="${realIndex}"]`).addClass(params.slideDuplicateActiveClass);
        } else {
          $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass}[data-swiper-slide-index="${realIndex}"]`).addClass(params.slideDuplicateActiveClass);
        }
      }
      let nextSlide = activeSlide.nextAll(`.${params.slideClass}`).eq(0).addClass(params.slideNextClass);
      if (params.loop && nextSlide.length === 0) {
        nextSlide = slides.eq(0);
        nextSlide.addClass(params.slideNextClass);
      }
      let prevSlide = activeSlide.prevAll(`.${params.slideClass}`).eq(0).addClass(params.slidePrevClass);
      if (params.loop && prevSlide.length === 0) {
        prevSlide = slides.eq(-1);
        prevSlide.addClass(params.slidePrevClass);
      }
      if (params.loop) {
        if (nextSlide.hasClass(params.slideDuplicateClass)) {
          $wrapperEl.children(`.${params.slideClass}:not(.${params.slideDuplicateClass})[data-swiper-slide-index="${nextSlide.attr('data-swiper-slide-index')}"]`).addClass(params.slideDuplicateNextClass);
        } else {
          $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass}[data-swiper-slide-index="${nextSlide.attr('data-swiper-slide-index')}"]`).addClass(params.slideDuplicateNextClass);
        }
        if (prevSlide.hasClass(params.slideDuplicateClass)) {
          $wrapperEl.children(`.${params.slideClass}:not(.${params.slideDuplicateClass})[data-swiper-slide-index="${prevSlide.attr('data-swiper-slide-index')}"]`).addClass(params.slideDuplicatePrevClass);
        } else {
          $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass}[data-swiper-slide-index="${prevSlide.attr('data-swiper-slide-index')}"]`).addClass(params.slideDuplicatePrevClass);
        }
      }
      swiper.emitSlidesClasses();
    }

    function updateActiveIndex(newActiveIndex) {
      const swiper = this;
      const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
      const {
        slidesGrid,
        snapGrid,
        params,
        activeIndex: previousIndex,
        realIndex: previousRealIndex,
        snapIndex: previousSnapIndex
      } = swiper;
      let activeIndex = newActiveIndex;
      let snapIndex;
      if (typeof activeIndex === 'undefined') {
        for (let i = 0; i < slidesGrid.length; i += 1) {
          if (typeof slidesGrid[i + 1] !== 'undefined') {
            if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - (slidesGrid[i + 1] - slidesGrid[i]) / 2) {
              activeIndex = i;
            } else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) {
              activeIndex = i + 1;
            }
          } else if (translate >= slidesGrid[i]) {
            activeIndex = i;
          }
        }
        if (params.normalizeSlideIndex) {
          if (activeIndex < 0 || typeof activeIndex === 'undefined') activeIndex = 0;
        }
      }
      if (snapGrid.indexOf(translate) >= 0) {
        snapIndex = snapGrid.indexOf(translate);
      } else {
        const skip = Math.min(params.slidesPerGroupSkip, activeIndex);
        snapIndex = skip + Math.floor((activeIndex - skip) / params.slidesPerGroup);
      }
      if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
      if (activeIndex === previousIndex) {
        if (snapIndex !== previousSnapIndex) {
          swiper.snapIndex = snapIndex;
          swiper.emit('snapIndexChange');
        }
        return;
      }
      const realIndex = parseInt(swiper.slides.eq(activeIndex).attr('data-swiper-slide-index') || activeIndex, 10);
      Object.assign(swiper, {
        snapIndex,
        realIndex,
        previousIndex,
        activeIndex
      });
      swiper.emit('activeIndexChange');
      swiper.emit('snapIndexChange');
      if (previousRealIndex !== realIndex) {
        swiper.emit('realIndexChange');
      }
      if (swiper.initialized || swiper.params.runCallbacksOnInit) {
        swiper.emit('slideChange');
      }
    }

    function updateClickedSlide(e) {
      const swiper = this;
      const params = swiper.params;
      const slide = $(e).closest(`.${params.slideClass}`)[0];
      let slideFound = false;
      let slideIndex;
      if (slide) {
        for (let i = 0; i < swiper.slides.length; i += 1) {
          if (swiper.slides[i] === slide) {
            slideFound = true;
            slideIndex = i;
            break;
          }
        }
      }
      if (slide && slideFound) {
        swiper.clickedSlide = slide;
        if (swiper.virtual && swiper.params.virtual.enabled) {
          swiper.clickedIndex = parseInt($(slide).attr('data-swiper-slide-index'), 10);
        } else {
          swiper.clickedIndex = slideIndex;
        }
      } else {
        swiper.clickedSlide = undefined;
        swiper.clickedIndex = undefined;
        return;
      }
      if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) {
        swiper.slideToClickedSlide();
      }
    }

    var update = {
      updateSize,
      updateSlides,
      updateAutoHeight,
      updateSlidesOffset,
      updateSlidesProgress,
      updateProgress,
      updateSlidesClasses,
      updateActiveIndex,
      updateClickedSlide
    };

    function getSwiperTranslate(axis = this.isHorizontal() ? 'x' : 'y') {
      const swiper = this;
      const {
        params,
        rtlTranslate: rtl,
        translate,
        $wrapperEl
      } = swiper;
      if (params.virtualTranslate) {
        return rtl ? -translate : translate;
      }
      if (params.cssMode) {
        return translate;
      }
      let currentTranslate = getTranslate($wrapperEl[0], axis);
      if (rtl) currentTranslate = -currentTranslate;
      return currentTranslate || 0;
    }

    function setTranslate(translate, byController) {
      const swiper = this;
      const {
        rtlTranslate: rtl,
        params,
        $wrapperEl,
        wrapperEl,
        progress
      } = swiper;
      let x = 0;
      let y = 0;
      const z = 0;
      if (swiper.isHorizontal()) {
        x = rtl ? -translate : translate;
      } else {
        y = translate;
      }
      if (params.roundLengths) {
        x = Math.floor(x);
        y = Math.floor(y);
      }
      if (params.cssMode) {
        wrapperEl[swiper.isHorizontal() ? 'scrollLeft' : 'scrollTop'] = swiper.isHorizontal() ? -x : -y;
      } else if (!params.virtualTranslate) {
        $wrapperEl.transform(`translate3d(${x}px, ${y}px, ${z}px)`);
      }
      swiper.previousTranslate = swiper.translate;
      swiper.translate = swiper.isHorizontal() ? x : y;
      let newProgress;
      const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
      if (translatesDiff === 0) {
        newProgress = 0;
      } else {
        newProgress = (translate - swiper.minTranslate()) / translatesDiff;
      }
      if (newProgress !== progress) {
        swiper.updateProgress(translate);
      }
      swiper.emit('setTranslate', swiper.translate, byController);
    }

    function minTranslate() {
      return -this.snapGrid[0];
    }

    function maxTranslate() {
      return -this.snapGrid[this.snapGrid.length - 1];
    }

    function translateTo(translate = 0, speed = this.params.speed, runCallbacks = true, translateBounds = true, internal) {
      const swiper = this;
      const {
        params,
        wrapperEl
      } = swiper;
      if (swiper.animating && params.preventInteractionOnTransition) {
        return false;
      }
      const minTranslate = swiper.minTranslate();
      const maxTranslate = swiper.maxTranslate();
      let newTranslate;
      if (translateBounds && translate > minTranslate) newTranslate = minTranslate;else if (translateBounds && translate < maxTranslate) newTranslate = maxTranslate;else newTranslate = translate;
      swiper.updateProgress(newTranslate);
      if (params.cssMode) {
        const isH = swiper.isHorizontal();
        if (speed === 0) {
          wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = -newTranslate;
        } else {
          if (!swiper.support.smoothScroll) {
            animateCSSModeScroll({
              swiper,
              targetPosition: -newTranslate,
              side: isH ? 'left' : 'top'
            });
            return true;
          }
          wrapperEl.scrollTo({
            [isH ? 'left' : 'top']: -newTranslate,
            behavior: 'smooth'
          });
        }
        return true;
      }
      if (speed === 0) {
        swiper.setTransition(0);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
          swiper.emit('beforeTransitionStart', speed, internal);
          swiper.emit('transitionEnd');
        }
      } else {
        swiper.setTransition(speed);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
          swiper.emit('beforeTransitionStart', speed, internal);
          swiper.emit('transitionStart');
        }
        if (!swiper.animating) {
          swiper.animating = true;
          if (!swiper.onTranslateToWrapperTransitionEnd) {
            swiper.onTranslateToWrapperTransitionEnd = function transitionEnd(e) {
              if (!swiper || swiper.destroyed) return;
              if (e.target !== this) return;
              swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
              swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.onTranslateToWrapperTransitionEnd);
              swiper.onTranslateToWrapperTransitionEnd = null;
              delete swiper.onTranslateToWrapperTransitionEnd;
              if (runCallbacks) {
                swiper.emit('transitionEnd');
              }
            };
          }
          swiper.$wrapperEl[0].addEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
          swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.onTranslateToWrapperTransitionEnd);
        }
      }
      return true;
    }

    var translate = {
      getTranslate: getSwiperTranslate,
      setTranslate,
      minTranslate,
      maxTranslate,
      translateTo
    };

    function setTransition(duration, byController) {
      const swiper = this;
      if (!swiper.params.cssMode) {
        swiper.$wrapperEl.transition(duration);
      }
      swiper.emit('setTransition', duration, byController);
    }

    function transitionEmit({
      swiper,
      runCallbacks,
      direction,
      step
    }) {
      const {
        activeIndex,
        previousIndex
      } = swiper;
      let dir = direction;
      if (!dir) {
        if (activeIndex > previousIndex) dir = 'next';else if (activeIndex < previousIndex) dir = 'prev';else dir = 'reset';
      }
      swiper.emit(`transition${step}`);
      if (runCallbacks && activeIndex !== previousIndex) {
        if (dir === 'reset') {
          swiper.emit(`slideResetTransition${step}`);
          return;
        }
        swiper.emit(`slideChangeTransition${step}`);
        if (dir === 'next') {
          swiper.emit(`slideNextTransition${step}`);
        } else {
          swiper.emit(`slidePrevTransition${step}`);
        }
      }
    }

    function transitionStart(runCallbacks = true, direction) {
      const swiper = this;
      const {
        params
      } = swiper;
      if (params.cssMode) return;
      if (params.autoHeight) {
        swiper.updateAutoHeight();
      }
      transitionEmit({
        swiper,
        runCallbacks,
        direction,
        step: 'Start'
      });
    }

    function transitionEnd(runCallbacks = true, direction) {
      const swiper = this;
      const {
        params
      } = swiper;
      swiper.animating = false;
      if (params.cssMode) return;
      swiper.setTransition(0);
      transitionEmit({
        swiper,
        runCallbacks,
        direction,
        step: 'End'
      });
    }

    var transition = {
      setTransition,
      transitionStart,
      transitionEnd
    };

    function slideTo(index = 0, speed = this.params.speed, runCallbacks = true, internal, initial) {
      if (typeof index !== 'number' && typeof index !== 'string') {
        throw new Error(`The 'index' argument cannot have type other than 'number' or 'string'. [${typeof index}] given.`);
      }
      if (typeof index === 'string') {
        const indexAsNumber = parseInt(index, 10);
        const isValidNumber = isFinite(indexAsNumber);
        if (!isValidNumber) {
          throw new Error(`The passed-in 'index' (string) couldn't be converted to 'number'. [${index}] given.`);
        }
        index = indexAsNumber;
      }
      const swiper = this;
      let slideIndex = index;
      if (slideIndex < 0) slideIndex = 0;
      const {
        params,
        snapGrid,
        slidesGrid,
        previousIndex,
        activeIndex,
        rtlTranslate: rtl,
        wrapperEl,
        enabled
      } = swiper;
      if (swiper.animating && params.preventInteractionOnTransition || !enabled && !internal && !initial) {
        return false;
      }
      const skip = Math.min(swiper.params.slidesPerGroupSkip, slideIndex);
      let snapIndex = skip + Math.floor((slideIndex - skip) / swiper.params.slidesPerGroup);
      if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
      const translate = -snapGrid[snapIndex];
      if (params.normalizeSlideIndex) {
        for (let i = 0; i < slidesGrid.length; i += 1) {
          const normalizedTranslate = -Math.floor(translate * 100);
          const normalizedGrid = Math.floor(slidesGrid[i] * 100);
          const normalizedGridNext = Math.floor(slidesGrid[i + 1] * 100);
          if (typeof slidesGrid[i + 1] !== 'undefined') {
            if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext - (normalizedGridNext - normalizedGrid) / 2) {
              slideIndex = i;
            } else if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext) {
              slideIndex = i + 1;
            }
          } else if (normalizedTranslate >= normalizedGrid) {
            slideIndex = i;
          }
        }
      }
      if (swiper.initialized && slideIndex !== activeIndex) {
        if (!swiper.allowSlideNext && translate < swiper.translate && translate < swiper.minTranslate()) {
          return false;
        }
        if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
          if ((activeIndex || 0) !== slideIndex) return false;
        }
      }
      if (slideIndex !== (previousIndex || 0) && runCallbacks) {
        swiper.emit('beforeSlideChangeStart');
      }
      swiper.updateProgress(translate);
      let direction;
      if (slideIndex > activeIndex) direction = 'next';else if (slideIndex < activeIndex) direction = 'prev';else direction = 'reset';
      if (rtl && -translate === swiper.translate || !rtl && translate === swiper.translate) {
        swiper.updateActiveIndex(slideIndex);
        if (params.autoHeight) {
          swiper.updateAutoHeight();
        }
        swiper.updateSlidesClasses();
        if (params.effect !== 'slide') {
          swiper.setTranslate(translate);
        }
        if (direction !== 'reset') {
          swiper.transitionStart(runCallbacks, direction);
          swiper.transitionEnd(runCallbacks, direction);
        }
        return false;
      }
      if (params.cssMode) {
        const isH = swiper.isHorizontal();
        const t = rtl ? translate : -translate;
        if (speed === 0) {
          const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
          if (isVirtual) {
            swiper.wrapperEl.style.scrollSnapType = 'none';
            swiper._immediateVirtual = true;
          }
          wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;
          if (isVirtual) {
            requestAnimationFrame(() => {
              swiper.wrapperEl.style.scrollSnapType = '';
              swiper._swiperImmediateVirtual = false;
            });
          }
        } else {
          if (!swiper.support.smoothScroll) {
            animateCSSModeScroll({
              swiper,
              targetPosition: t,
              side: isH ? 'left' : 'top'
            });
            return true;
          }
          wrapperEl.scrollTo({
            [isH ? 'left' : 'top']: t,
            behavior: 'smooth'
          });
        }
        return true;
      }
      swiper.setTransition(speed);
      swiper.setTranslate(translate);
      swiper.updateActiveIndex(slideIndex);
      swiper.updateSlidesClasses();
      swiper.emit('beforeTransitionStart', speed, internal);
      swiper.transitionStart(runCallbacks, direction);
      if (speed === 0) {
        swiper.transitionEnd(runCallbacks, direction);
      } else if (!swiper.animating) {
        swiper.animating = true;
        if (!swiper.onSlideToWrapperTransitionEnd) {
          swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
            if (!swiper || swiper.destroyed) return;
            if (e.target !== this) return;
            swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
            swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
            swiper.onSlideToWrapperTransitionEnd = null;
            delete swiper.onSlideToWrapperTransitionEnd;
            swiper.transitionEnd(runCallbacks, direction);
          };
        }
        swiper.$wrapperEl[0].addEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
        swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
      }
      return true;
    }

    function slideToLoop(index = 0, speed = this.params.speed, runCallbacks = true, internal) {
      if (typeof index === 'string') {
        const indexAsNumber = parseInt(index, 10);
        const isValidNumber = isFinite(indexAsNumber);
        if (!isValidNumber) {
          throw new Error(`The passed-in 'index' (string) couldn't be converted to 'number'. [${index}] given.`);
        }
        index = indexAsNumber;
      }
      const swiper = this;
      let newIndex = index;
      if (swiper.params.loop) {
        newIndex += swiper.loopedSlides;
      }
      return swiper.slideTo(newIndex, speed, runCallbacks, internal);
    }

    function slideNext(speed = this.params.speed, runCallbacks = true, internal) {
      const swiper = this;
      const {
        animating,
        enabled,
        params
      } = swiper;
      if (!enabled) return swiper;
      let perGroup = params.slidesPerGroup;
      if (params.slidesPerView === 'auto' && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
        perGroup = Math.max(swiper.slidesPerViewDynamic('current', true), 1);
      }
      const increment = swiper.activeIndex < params.slidesPerGroupSkip ? 1 : perGroup;
      if (params.loop) {
        if (animating && params.loopPreventsSlide) return false;
        swiper.loopFix();
        swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
      }
      if (params.rewind && swiper.isEnd) {
        return swiper.slideTo(0, speed, runCallbacks, internal);
      }
      return swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
    }

    function slidePrev(speed = this.params.speed, runCallbacks = true, internal) {
      const swiper = this;
      const {
        params,
        animating,
        snapGrid,
        slidesGrid,
        rtlTranslate,
        enabled
      } = swiper;
      if (!enabled) return swiper;
      if (params.loop) {
        if (animating && params.loopPreventsSlide) return false;
        swiper.loopFix();
        swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
      }
      const translate = rtlTranslate ? swiper.translate : -swiper.translate;
      function normalize(val) {
        if (val < 0) return -Math.floor(Math.abs(val));
        return Math.floor(val);
      }
      const normalizedTranslate = normalize(translate);
      const normalizedSnapGrid = snapGrid.map(val => normalize(val));
      let prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];
      if (typeof prevSnap === 'undefined' && params.cssMode) {
        let prevSnapIndex;
        snapGrid.forEach((snap, snapIndex) => {
          if (normalizedTranslate >= snap) {
            prevSnapIndex = snapIndex;
          }
        });
        if (typeof prevSnapIndex !== 'undefined') {
          prevSnap = snapGrid[prevSnapIndex > 0 ? prevSnapIndex - 1 : prevSnapIndex];
        }
      }
      let prevIndex = 0;
      if (typeof prevSnap !== 'undefined') {
        prevIndex = slidesGrid.indexOf(prevSnap);
        if (prevIndex < 0) prevIndex = swiper.activeIndex - 1;
        if (params.slidesPerView === 'auto' && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
          prevIndex = prevIndex - swiper.slidesPerViewDynamic('previous', true) + 1;
          prevIndex = Math.max(prevIndex, 0);
        }
      }
      if (params.rewind && swiper.isBeginning) {
        const lastIndex = swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
        return swiper.slideTo(lastIndex, speed, runCallbacks, internal);
      }
      return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
    }

    function slideReset(speed = this.params.speed, runCallbacks = true, internal) {
      const swiper = this;
      return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
    }

    function slideToClosest(speed = this.params.speed, runCallbacks = true, internal, threshold = 0.5) {
      const swiper = this;
      let index = swiper.activeIndex;
      const skip = Math.min(swiper.params.slidesPerGroupSkip, index);
      const snapIndex = skip + Math.floor((index - skip) / swiper.params.slidesPerGroup);
      const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
      if (translate >= swiper.snapGrid[snapIndex]) {
        const currentSnap = swiper.snapGrid[snapIndex];
        const nextSnap = swiper.snapGrid[snapIndex + 1];
        if (translate - currentSnap > (nextSnap - currentSnap) * threshold) {
          index += swiper.params.slidesPerGroup;
        }
      } else {
        const prevSnap = swiper.snapGrid[snapIndex - 1];
        const currentSnap = swiper.snapGrid[snapIndex];
        if (translate - prevSnap <= (currentSnap - prevSnap) * threshold) {
          index -= swiper.params.slidesPerGroup;
        }
      }
      index = Math.max(index, 0);
      index = Math.min(index, swiper.slidesGrid.length - 1);
      return swiper.slideTo(index, speed, runCallbacks, internal);
    }

    function slideToClickedSlide() {
      const swiper = this;
      const {
        params,
        $wrapperEl
      } = swiper;
      const slidesPerView = params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : params.slidesPerView;
      let slideToIndex = swiper.clickedIndex;
      let realIndex;
      if (params.loop) {
        if (swiper.animating) return;
        realIndex = parseInt($(swiper.clickedSlide).attr('data-swiper-slide-index'), 10);
        if (params.centeredSlides) {
          if (slideToIndex < swiper.loopedSlides - slidesPerView / 2 || slideToIndex > swiper.slides.length - swiper.loopedSlides + slidesPerView / 2) {
            swiper.loopFix();
            slideToIndex = $wrapperEl.children(`.${params.slideClass}[data-swiper-slide-index="${realIndex}"]:not(.${params.slideDuplicateClass})`).eq(0).index();
            nextTick(() => {
              swiper.slideTo(slideToIndex);
            });
          } else {
            swiper.slideTo(slideToIndex);
          }
        } else if (slideToIndex > swiper.slides.length - slidesPerView) {
          swiper.loopFix();
          slideToIndex = $wrapperEl.children(`.${params.slideClass}[data-swiper-slide-index="${realIndex}"]:not(.${params.slideDuplicateClass})`).eq(0).index();
          nextTick(() => {
            swiper.slideTo(slideToIndex);
          });
        } else {
          swiper.slideTo(slideToIndex);
        }
      } else {
        swiper.slideTo(slideToIndex);
      }
    }

    var slide = {
      slideTo,
      slideToLoop,
      slideNext,
      slidePrev,
      slideReset,
      slideToClosest,
      slideToClickedSlide
    };

    function loopCreate() {
      const swiper = this;
      const document = getDocument();
      const {
        params,
        $wrapperEl
      } = swiper;
      const $selector = $wrapperEl.children().length > 0 ? $($wrapperEl.children()[0].parentNode) : $wrapperEl;
      $selector.children(`.${params.slideClass}.${params.slideDuplicateClass}`).remove();
      let slides = $selector.children(`.${params.slideClass}`);
      if (params.loopFillGroupWithBlank) {
        const blankSlidesNum = params.slidesPerGroup - slides.length % params.slidesPerGroup;
        if (blankSlidesNum !== params.slidesPerGroup) {
          for (let i = 0; i < blankSlidesNum; i += 1) {
            const blankNode = $(document.createElement('div')).addClass(`${params.slideClass} ${params.slideBlankClass}`);
            $selector.append(blankNode);
          }
          slides = $selector.children(`.${params.slideClass}`);
        }
      }
      if (params.slidesPerView === 'auto' && !params.loopedSlides) params.loopedSlides = slides.length;
      swiper.loopedSlides = Math.ceil(parseFloat(params.loopedSlides || params.slidesPerView, 10));
      swiper.loopedSlides += params.loopAdditionalSlides;
      if (swiper.loopedSlides > slides.length && swiper.params.loopedSlidesLimit) {
        swiper.loopedSlides = slides.length;
      }
      const prependSlides = [];
      const appendSlides = [];
      slides.each((el, index) => {
        const slide = $(el);
        slide.attr('data-swiper-slide-index', index);
      });
      for (let i = 0; i < swiper.loopedSlides; i += 1) {
        const index = i - Math.floor(i / slides.length) * slides.length;
        appendSlides.push(slides.eq(index)[0]);
        prependSlides.unshift(slides.eq(slides.length - index - 1)[0]);
      }
      for (let i = 0; i < appendSlides.length; i += 1) {
        $selector.append($(appendSlides[i].cloneNode(true)).addClass(params.slideDuplicateClass));
      }
      for (let i = prependSlides.length - 1; i >= 0; i -= 1) {
        $selector.prepend($(prependSlides[i].cloneNode(true)).addClass(params.slideDuplicateClass));
      }
    }

    function loopFix() {
      const swiper = this;
      swiper.emit('beforeLoopFix');
      const {
        activeIndex,
        slides,
        loopedSlides,
        allowSlidePrev,
        allowSlideNext,
        snapGrid,
        rtlTranslate: rtl
      } = swiper;
      let newIndex;
      swiper.allowSlidePrev = true;
      swiper.allowSlideNext = true;
      const snapTranslate = -snapGrid[activeIndex];
      const diff = snapTranslate - swiper.getTranslate();
      if (activeIndex < loopedSlides) {
        newIndex = slides.length - loopedSlides * 3 + activeIndex;
        newIndex += loopedSlides;
        const slideChanged = swiper.slideTo(newIndex, 0, false, true);
        if (slideChanged && diff !== 0) {
          swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
        }
      } else if (activeIndex >= slides.length - loopedSlides) {
        newIndex = -slides.length + activeIndex + loopedSlides;
        newIndex += loopedSlides;
        const slideChanged = swiper.slideTo(newIndex, 0, false, true);
        if (slideChanged && diff !== 0) {
          swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
        }
      }
      swiper.allowSlidePrev = allowSlidePrev;
      swiper.allowSlideNext = allowSlideNext;
      swiper.emit('loopFix');
    }

    function loopDestroy() {
      const swiper = this;
      const {
        $wrapperEl,
        params,
        slides
      } = swiper;
      $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass},.${params.slideClass}.${params.slideBlankClass}`).remove();
      slides.removeAttr('data-swiper-slide-index');
    }

    var loop = {
      loopCreate,
      loopFix,
      loopDestroy
    };

    function setGrabCursor(moving) {
      const swiper = this;
      if (swiper.support.touch || !swiper.params.simulateTouch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
      const el = swiper.params.touchEventsTarget === 'container' ? swiper.el : swiper.wrapperEl;
      el.style.cursor = 'move';
      el.style.cursor = moving ? 'grabbing' : 'grab';
    }

    function unsetGrabCursor() {
      const swiper = this;
      if (swiper.support.touch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) {
        return;
      }
      swiper[swiper.params.touchEventsTarget === 'container' ? 'el' : 'wrapperEl'].style.cursor = '';
    }

    var grabCursor = {
      setGrabCursor,
      unsetGrabCursor
    };

    function closestElement(selector, base = this) {
      function __closestFrom(el) {
        if (!el || el === getDocument() || el === getWindow()) return null;
        if (el.assignedSlot) el = el.assignedSlot;
        const found = el.closest(selector);
        if (!found && !el.getRootNode) {
          return null;
        }
        return found || __closestFrom(el.getRootNode().host);
      }
      return __closestFrom(base);
    }
    function onTouchStart(event) {
      const swiper = this;
      const document = getDocument();
      const window = getWindow();
      const data = swiper.touchEventsData;
      const {
        params,
        touches,
        enabled
      } = swiper;
      if (!enabled) return;
      if (swiper.animating && params.preventInteractionOnTransition) {
        return;
      }
      if (!swiper.animating && params.cssMode && params.loop) {
        swiper.loopFix();
      }
      let e = event;
      if (e.originalEvent) e = e.originalEvent;
      let $targetEl = $(e.target);
      if (params.touchEventsTarget === 'wrapper') {
        if (!$targetEl.closest(swiper.wrapperEl).length) return;
      }
      data.isTouchEvent = e.type === 'touchstart';
      if (!data.isTouchEvent && 'which' in e && e.which === 3) return;
      if (!data.isTouchEvent && 'button' in e && e.button > 0) return;
      if (data.isTouched && data.isMoved) return;
      const swipingClassHasValue = !!params.noSwipingClass && params.noSwipingClass !== '';
      const eventPath = event.composedPath ? event.composedPath() : event.path;
      if (swipingClassHasValue && e.target && e.target.shadowRoot && eventPath) {
        $targetEl = $(eventPath[0]);
      }
      const noSwipingSelector = params.noSwipingSelector ? params.noSwipingSelector : `.${params.noSwipingClass}`;
      const isTargetShadow = !!(e.target && e.target.shadowRoot);
      if (params.noSwiping && (isTargetShadow ? closestElement(noSwipingSelector, $targetEl[0]) : $targetEl.closest(noSwipingSelector)[0])) {
        swiper.allowClick = true;
        return;
      }
      if (params.swipeHandler) {
        if (!$targetEl.closest(params.swipeHandler)[0]) return;
      }
      touches.currentX = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
      touches.currentY = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
      const startX = touches.currentX;
      const startY = touches.currentY;
      const edgeSwipeDetection = params.edgeSwipeDetection || params.iOSEdgeSwipeDetection;
      const edgeSwipeThreshold = params.edgeSwipeThreshold || params.iOSEdgeSwipeThreshold;
      if (edgeSwipeDetection && (startX <= edgeSwipeThreshold || startX >= window.innerWidth - edgeSwipeThreshold)) {
        if (edgeSwipeDetection === 'prevent') {
          event.preventDefault();
        } else {
          return;
        }
      }
      Object.assign(data, {
        isTouched: true,
        isMoved: false,
        allowTouchCallbacks: true,
        isScrolling: undefined,
        startMoving: undefined
      });
      touches.startX = startX;
      touches.startY = startY;
      data.touchStartTime = now();
      swiper.allowClick = true;
      swiper.updateSize();
      swiper.swipeDirection = undefined;
      if (params.threshold > 0) data.allowThresholdMove = false;
      if (e.type !== 'touchstart') {
        let preventDefault = true;
        if ($targetEl.is(data.focusableElements)) {
          preventDefault = false;
          if ($targetEl[0].nodeName === 'SELECT') {
            data.isTouched = false;
          }
        }
        if (document.activeElement && $(document.activeElement).is(data.focusableElements) && document.activeElement !== $targetEl[0]) {
          document.activeElement.blur();
        }
        const shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;
        if ((params.touchStartForcePreventDefault || shouldPreventDefault) && !$targetEl[0].isContentEditable) {
          e.preventDefault();
        }
      }
      if (swiper.params.freeMode && swiper.params.freeMode.enabled && swiper.freeMode && swiper.animating && !params.cssMode) {
        swiper.freeMode.onTouchStart();
      }
      swiper.emit('touchStart', e);
    }

    function onTouchMove(event) {
      const document = getDocument();
      const swiper = this;
      const data = swiper.touchEventsData;
      const {
        params,
        touches,
        rtlTranslate: rtl,
        enabled
      } = swiper;
      if (!enabled) return;
      let e = event;
      if (e.originalEvent) e = e.originalEvent;
      if (!data.isTouched) {
        if (data.startMoving && data.isScrolling) {
          swiper.emit('touchMoveOpposite', e);
        }
        return;
      }
      if (data.isTouchEvent && e.type !== 'touchmove') return;
      const targetTouch = e.type === 'touchmove' && e.targetTouches && (e.targetTouches[0] || e.changedTouches[0]);
      const pageX = e.type === 'touchmove' ? targetTouch.pageX : e.pageX;
      const pageY = e.type === 'touchmove' ? targetTouch.pageY : e.pageY;
      if (e.preventedByNestedSwiper) {
        touches.startX = pageX;
        touches.startY = pageY;
        return;
      }
      if (!swiper.allowTouchMove) {
        if (!$(e.target).is(data.focusableElements)) {
          swiper.allowClick = false;
        }
        if (data.isTouched) {
          Object.assign(touches, {
            startX: pageX,
            startY: pageY,
            currentX: pageX,
            currentY: pageY
          });
          data.touchStartTime = now();
        }
        return;
      }
      if (data.isTouchEvent && params.touchReleaseOnEdges && !params.loop) {
        if (swiper.isVertical()) {
          if (pageY < touches.startY && swiper.translate <= swiper.maxTranslate() || pageY > touches.startY && swiper.translate >= swiper.minTranslate()) {
            data.isTouched = false;
            data.isMoved = false;
            return;
          }
        } else if (pageX < touches.startX && swiper.translate <= swiper.maxTranslate() || pageX > touches.startX && swiper.translate >= swiper.minTranslate()) {
          return;
        }
      }
      if (data.isTouchEvent && document.activeElement) {
        if (e.target === document.activeElement && $(e.target).is(data.focusableElements)) {
          data.isMoved = true;
          swiper.allowClick = false;
          return;
        }
      }
      if (data.allowTouchCallbacks) {
        swiper.emit('touchMove', e);
      }
      if (e.targetTouches && e.targetTouches.length > 1) return;
      touches.currentX = pageX;
      touches.currentY = pageY;
      const diffX = touches.currentX - touches.startX;
      const diffY = touches.currentY - touches.startY;
      if (swiper.params.threshold && Math.sqrt(diffX ** 2 + diffY ** 2) < swiper.params.threshold) return;
      if (typeof data.isScrolling === 'undefined') {
        let touchAngle;
        if (swiper.isHorizontal() && touches.currentY === touches.startY || swiper.isVertical() && touches.currentX === touches.startX) {
          data.isScrolling = false;
        } else {
          if (diffX * diffX + diffY * diffY >= 25) {
            touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;
            data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : 90 - touchAngle > params.touchAngle;
          }
        }
      }
      if (data.isScrolling) {
        swiper.emit('touchMoveOpposite', e);
      }
      if (typeof data.startMoving === 'undefined') {
        if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) {
          data.startMoving = true;
        }
      }
      if (data.isScrolling) {
        data.isTouched = false;
        return;
      }
      if (!data.startMoving) {
        return;
      }
      swiper.allowClick = false;
      if (!params.cssMode && e.cancelable) {
        e.preventDefault();
      }
      if (params.touchMoveStopPropagation && !params.nested) {
        e.stopPropagation();
      }
      if (!data.isMoved) {
        if (params.loop && !params.cssMode) {
          swiper.loopFix();
        }
        data.startTranslate = swiper.getTranslate();
        swiper.setTransition(0);
        if (swiper.animating) {
          swiper.$wrapperEl.trigger('webkitTransitionEnd transitionend');
        }
        data.allowMomentumBounce = false;
        if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
          swiper.setGrabCursor(true);
        }
        swiper.emit('sliderFirstMove', e);
      }
      swiper.emit('sliderMove', e);
      data.isMoved = true;
      let diff = swiper.isHorizontal() ? diffX : diffY;
      touches.diff = diff;
      diff *= params.touchRatio;
      if (rtl) diff = -diff;
      swiper.swipeDirection = diff > 0 ? 'prev' : 'next';
      data.currentTranslate = diff + data.startTranslate;
      let disableParentSwiper = true;
      let resistanceRatio = params.resistanceRatio;
      if (params.touchReleaseOnEdges) {
        resistanceRatio = 0;
      }
      if (diff > 0 && data.currentTranslate > swiper.minTranslate()) {
        disableParentSwiper = false;
        if (params.resistance) data.currentTranslate = swiper.minTranslate() - 1 + (-swiper.minTranslate() + data.startTranslate + diff) ** resistanceRatio;
      } else if (diff < 0 && data.currentTranslate < swiper.maxTranslate()) {
        disableParentSwiper = false;
        if (params.resistance) data.currentTranslate = swiper.maxTranslate() + 1 - (swiper.maxTranslate() - data.startTranslate - diff) ** resistanceRatio;
      }
      if (disableParentSwiper) {
        e.preventedByNestedSwiper = true;
      }
      if (!swiper.allowSlideNext && swiper.swipeDirection === 'next' && data.currentTranslate < data.startTranslate) {
        data.currentTranslate = data.startTranslate;
      }
      if (!swiper.allowSlidePrev && swiper.swipeDirection === 'prev' && data.currentTranslate > data.startTranslate) {
        data.currentTranslate = data.startTranslate;
      }
      if (!swiper.allowSlidePrev && !swiper.allowSlideNext) {
        data.currentTranslate = data.startTranslate;
      }
      if (params.threshold > 0) {
        if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
          if (!data.allowThresholdMove) {
            data.allowThresholdMove = true;
            touches.startX = touches.currentX;
            touches.startY = touches.currentY;
            data.currentTranslate = data.startTranslate;
            touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
            return;
          }
        } else {
          data.currentTranslate = data.startTranslate;
          return;
        }
      }
      if (!params.followFinger || params.cssMode) return;
      if (params.freeMode && params.freeMode.enabled && swiper.freeMode || params.watchSlidesProgress) {
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
      }
      if (swiper.params.freeMode && params.freeMode.enabled && swiper.freeMode) {
        swiper.freeMode.onTouchMove();
      }
      swiper.updateProgress(data.currentTranslate);
      swiper.setTranslate(data.currentTranslate);
    }

    function onTouchEnd(event) {
      const swiper = this;
      const data = swiper.touchEventsData;
      const {
        params,
        touches,
        rtlTranslate: rtl,
        slidesGrid,
        enabled
      } = swiper;
      if (!enabled) return;
      let e = event;
      if (e.originalEvent) e = e.originalEvent;
      if (data.allowTouchCallbacks) {
        swiper.emit('touchEnd', e);
      }
      data.allowTouchCallbacks = false;
      if (!data.isTouched) {
        if (data.isMoved && params.grabCursor) {
          swiper.setGrabCursor(false);
        }
        data.isMoved = false;
        data.startMoving = false;
        return;
      }
      if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
        swiper.setGrabCursor(false);
      }
      const touchEndTime = now();
      const timeDiff = touchEndTime - data.touchStartTime;
      if (swiper.allowClick) {
        const pathTree = e.path || e.composedPath && e.composedPath();
        swiper.updateClickedSlide(pathTree && pathTree[0] || e.target);
        swiper.emit('tap click', e);
        if (timeDiff < 300 && touchEndTime - data.lastClickTime < 300) {
          swiper.emit('doubleTap doubleClick', e);
        }
      }
      data.lastClickTime = now();
      nextTick(() => {
        if (!swiper.destroyed) swiper.allowClick = true;
      });
      if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 || data.currentTranslate === data.startTranslate) {
        data.isTouched = false;
        data.isMoved = false;
        data.startMoving = false;
        return;
      }
      data.isTouched = false;
      data.isMoved = false;
      data.startMoving = false;
      let currentPos;
      if (params.followFinger) {
        currentPos = rtl ? swiper.translate : -swiper.translate;
      } else {
        currentPos = -data.currentTranslate;
      }
      if (params.cssMode) {
        return;
      }
      if (swiper.params.freeMode && params.freeMode.enabled) {
        swiper.freeMode.onTouchEnd({
          currentPos
        });
        return;
      }
      let stopIndex = 0;
      let groupSize = swiper.slidesSizesGrid[0];
      for (let i = 0; i < slidesGrid.length; i += i < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup) {
        const increment = i < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
        if (typeof slidesGrid[i + increment] !== 'undefined') {
          if (currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + increment]) {
            stopIndex = i;
            groupSize = slidesGrid[i + increment] - slidesGrid[i];
          }
        } else if (currentPos >= slidesGrid[i]) {
          stopIndex = i;
          groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
        }
      }
      let rewindFirstIndex = null;
      let rewindLastIndex = null;
      if (params.rewind) {
        if (swiper.isBeginning) {
          rewindLastIndex = swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
        } else if (swiper.isEnd) {
          rewindFirstIndex = 0;
        }
      }
      const ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
      const increment = stopIndex < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
      if (timeDiff > params.longSwipesMs) {
        if (!params.longSwipes) {
          swiper.slideTo(swiper.activeIndex);
          return;
        }
        if (swiper.swipeDirection === 'next') {
          if (ratio >= params.longSwipesRatio) swiper.slideTo(params.rewind && swiper.isEnd ? rewindFirstIndex : stopIndex + increment);else swiper.slideTo(stopIndex);
        }
        if (swiper.swipeDirection === 'prev') {
          if (ratio > 1 - params.longSwipesRatio) {
            swiper.slideTo(stopIndex + increment);
          } else if (rewindLastIndex !== null && ratio < 0 && Math.abs(ratio) > params.longSwipesRatio) {
            swiper.slideTo(rewindLastIndex);
          } else {
            swiper.slideTo(stopIndex);
          }
        }
      } else {
        if (!params.shortSwipes) {
          swiper.slideTo(swiper.activeIndex);
          return;
        }
        const isNavButtonTarget = swiper.navigation && (e.target === swiper.navigation.nextEl || e.target === swiper.navigation.prevEl);
        if (!isNavButtonTarget) {
          if (swiper.swipeDirection === 'next') {
            swiper.slideTo(rewindFirstIndex !== null ? rewindFirstIndex : stopIndex + increment);
          }
          if (swiper.swipeDirection === 'prev') {
            swiper.slideTo(rewindLastIndex !== null ? rewindLastIndex : stopIndex);
          }
        } else if (e.target === swiper.navigation.nextEl) {
          swiper.slideTo(stopIndex + increment);
        } else {
          swiper.slideTo(stopIndex);
        }
      }
    }

    function onResize() {
      const swiper = this;
      const {
        params,
        el
      } = swiper;
      if (el && el.offsetWidth === 0) return;
      if (params.breakpoints) {
        swiper.setBreakpoint();
      }
      const {
        allowSlideNext,
        allowSlidePrev,
        snapGrid
      } = swiper;
      swiper.allowSlideNext = true;
      swiper.allowSlidePrev = true;
      swiper.updateSize();
      swiper.updateSlides();
      swiper.updateSlidesClasses();
      if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !swiper.isBeginning && !swiper.params.centeredSlides) {
        swiper.slideTo(swiper.slides.length - 1, 0, false, true);
      } else {
        swiper.slideTo(swiper.activeIndex, 0, false, true);
      }
      if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
        swiper.autoplay.run();
      }
      swiper.allowSlidePrev = allowSlidePrev;
      swiper.allowSlideNext = allowSlideNext;
      if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) {
        swiper.checkOverflow();
      }
    }

    function onClick(e) {
      const swiper = this;
      if (!swiper.enabled) return;
      if (!swiper.allowClick) {
        if (swiper.params.preventClicks) e.preventDefault();
        if (swiper.params.preventClicksPropagation && swiper.animating) {
          e.stopPropagation();
          e.stopImmediatePropagation();
        }
      }
    }

    function onScroll() {
      const swiper = this;
      const {
        wrapperEl,
        rtlTranslate,
        enabled
      } = swiper;
      if (!enabled) return;
      swiper.previousTranslate = swiper.translate;
      if (swiper.isHorizontal()) {
        swiper.translate = -wrapperEl.scrollLeft;
      } else {
        swiper.translate = -wrapperEl.scrollTop;
      }
      if (swiper.translate === 0) swiper.translate = 0;
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
      let newProgress;
      const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
      if (translatesDiff === 0) {
        newProgress = 0;
      } else {
        newProgress = (swiper.translate - swiper.minTranslate()) / translatesDiff;
      }
      if (newProgress !== swiper.progress) {
        swiper.updateProgress(rtlTranslate ? -swiper.translate : swiper.translate);
      }
      swiper.emit('setTranslate', swiper.translate, false);
    }

    let dummyEventAttached = false;
    function dummyEventListener() {}
    const events$6 = (swiper, method) => {
      const document = getDocument();
      const {
        params,
        touchEvents,
        el,
        wrapperEl,
        device,
        support
      } = swiper;
      const capture = !!params.nested;
      const domMethod = method === 'on' ? 'addEventListener' : 'removeEventListener';
      const swiperMethod = method;
      if (!support.touch) {
        el[domMethod](touchEvents.start, swiper.onTouchStart, false);
        document[domMethod](touchEvents.move, swiper.onTouchMove, capture);
        document[domMethod](touchEvents.end, swiper.onTouchEnd, false);
      } else {
        const passiveListener = touchEvents.start === 'touchstart' && support.passiveListener && params.passiveListeners ? {
          passive: true,
          capture: false
        } : false;
        el[domMethod](touchEvents.start, swiper.onTouchStart, passiveListener);
        el[domMethod](touchEvents.move, swiper.onTouchMove, support.passiveListener ? {
          passive: false,
          capture
        } : capture);
        el[domMethod](touchEvents.end, swiper.onTouchEnd, passiveListener);
        if (touchEvents.cancel) {
          el[domMethod](touchEvents.cancel, swiper.onTouchEnd, passiveListener);
        }
      }
      if (params.preventClicks || params.preventClicksPropagation) {
        el[domMethod]('click', swiper.onClick, true);
      }
      if (params.cssMode) {
        wrapperEl[domMethod]('scroll', swiper.onScroll);
      }
      if (params.updateOnWindowResize) {
        swiper[swiperMethod](device.ios || device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate', onResize, true);
      } else {
        swiper[swiperMethod]('observerUpdate', onResize, true);
      }
    };
    function attachEvents() {
      const swiper = this;
      const document = getDocument();
      const {
        params,
        support
      } = swiper;
      swiper.onTouchStart = onTouchStart.bind(swiper);
      swiper.onTouchMove = onTouchMove.bind(swiper);
      swiper.onTouchEnd = onTouchEnd.bind(swiper);
      if (params.cssMode) {
        swiper.onScroll = onScroll.bind(swiper);
      }
      swiper.onClick = onClick.bind(swiper);
      if (support.touch && !dummyEventAttached) {
        document.addEventListener('touchstart', dummyEventListener);
        dummyEventAttached = true;
      }
      events$6(swiper, 'on');
    }
    function detachEvents() {
      const swiper = this;
      events$6(swiper, 'off');
    }
    var events$7 = {
      attachEvents,
      detachEvents
    };

    const isGridEnabled = (swiper, params) => {
      return swiper.grid && params.grid && params.grid.rows > 1;
    };
    function setBreakpoint() {
      const swiper = this;
      const {
        activeIndex,
        initialized,
        loopedSlides = 0,
        params,
        $el
      } = swiper;
      const breakpoints = params.breakpoints;
      if (!breakpoints || breakpoints && Object.keys(breakpoints).length === 0) return;
      const breakpoint = swiper.getBreakpoint(breakpoints, swiper.params.breakpointsBase, swiper.el);
      if (!breakpoint || swiper.currentBreakpoint === breakpoint) return;
      const breakpointOnlyParams = breakpoint in breakpoints ? breakpoints[breakpoint] : undefined;
      const breakpointParams = breakpointOnlyParams || swiper.originalParams;
      const wasMultiRow = isGridEnabled(swiper, params);
      const isMultiRow = isGridEnabled(swiper, breakpointParams);
      const wasEnabled = params.enabled;
      if (wasMultiRow && !isMultiRow) {
        $el.removeClass(`${params.containerModifierClass}grid ${params.containerModifierClass}grid-column`);
        swiper.emitContainerClasses();
      } else if (!wasMultiRow && isMultiRow) {
        $el.addClass(`${params.containerModifierClass}grid`);
        if (breakpointParams.grid.fill && breakpointParams.grid.fill === 'column' || !breakpointParams.grid.fill && params.grid.fill === 'column') {
          $el.addClass(`${params.containerModifierClass}grid-column`);
        }
        swiper.emitContainerClasses();
      }
      ['navigation', 'pagination', 'scrollbar'].forEach(prop => {
        const wasModuleEnabled = params[prop] && params[prop].enabled;
        const isModuleEnabled = breakpointParams[prop] && breakpointParams[prop].enabled;
        if (wasModuleEnabled && !isModuleEnabled) {
          swiper[prop].disable();
        }
        if (!wasModuleEnabled && isModuleEnabled) {
          swiper[prop].enable();
        }
      });
      const directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
      const needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);
      if (directionChanged && initialized) {
        swiper.changeDirection();
      }
      extend(swiper.params, breakpointParams);
      const isEnabled = swiper.params.enabled;
      Object.assign(swiper, {
        allowTouchMove: swiper.params.allowTouchMove,
        allowSlideNext: swiper.params.allowSlideNext,
        allowSlidePrev: swiper.params.allowSlidePrev
      });
      if (wasEnabled && !isEnabled) {
        swiper.disable();
      } else if (!wasEnabled && isEnabled) {
        swiper.enable();
      }
      swiper.currentBreakpoint = breakpoint;
      swiper.emit('_beforeBreakpoint', breakpointParams);
      if (needsReLoop && initialized) {
        swiper.loopDestroy();
        swiper.loopCreate();
        swiper.updateSlides();
        swiper.slideTo(activeIndex - loopedSlides + swiper.loopedSlides, 0, false);
      }
      swiper.emit('breakpoint', breakpointParams);
    }

    function getBreakpoint(breakpoints, base = 'window', containerEl) {
      if (!breakpoints || base === 'container' && !containerEl) return undefined;
      let breakpoint = false;
      const window = getWindow();
      const currentHeight = base === 'window' ? window.innerHeight : containerEl.clientHeight;
      const points = Object.keys(breakpoints).map(point => {
        if (typeof point === 'string' && point.indexOf('@') === 0) {
          const minRatio = parseFloat(point.substr(1));
          const value = currentHeight * minRatio;
          return {
            value,
            point
          };
        }
        return {
          value: point,
          point
        };
      });
      points.sort((a, b) => parseInt(a.value, 10) - parseInt(b.value, 10));
      for (let i = 0; i < points.length; i += 1) {
        const {
          point,
          value
        } = points[i];
        if (base === 'window') {
          if (window.matchMedia(`(min-width: ${value}px)`).matches) {
            breakpoint = point;
          }
        } else if (value <= containerEl.clientWidth) {
          breakpoint = point;
        }
      }
      return breakpoint || 'max';
    }

    var breakpoints$2 = {
      setBreakpoint,
      getBreakpoint
    };

    function prepareClasses(entries, prefix) {
      const resultClasses = [];
      entries.forEach(item => {
        if (typeof item === 'object') {
          Object.keys(item).forEach(classNames => {
            if (item[classNames]) {
              resultClasses.push(prefix + classNames);
            }
          });
        } else if (typeof item === 'string') {
          resultClasses.push(prefix + item);
        }
      });
      return resultClasses;
    }
    function addClasses() {
      const swiper = this;
      const {
        classNames,
        params,
        rtl,
        $el,
        device,
        support
      } = swiper;
      const suffixes = prepareClasses(['initialized', params.direction, {
        'pointer-events': !support.touch
      }, {
        'free-mode': swiper.params.freeMode && params.freeMode.enabled
      }, {
        'autoheight': params.autoHeight
      }, {
        'rtl': rtl
      }, {
        'grid': params.grid && params.grid.rows > 1
      }, {
        'grid-column': params.grid && params.grid.rows > 1 && params.grid.fill === 'column'
      }, {
        'android': device.android
      }, {
        'ios': device.ios
      }, {
        'css-mode': params.cssMode
      }, {
        'centered': params.cssMode && params.centeredSlides
      }, {
        'watch-progress': params.watchSlidesProgress
      }], params.containerModifierClass);
      classNames.push(...suffixes);
      $el.addClass([...classNames].join(' '));
      swiper.emitContainerClasses();
    }

    function removeClasses() {
      const swiper = this;
      const {
        $el,
        classNames
      } = swiper;
      $el.removeClass(classNames.join(' '));
      swiper.emitContainerClasses();
    }

    var classes$5 = {
      addClasses,
      removeClasses
    };

    function loadImage(imageEl, src, srcset, sizes, checkForComplete, callback) {
      const window = getWindow();
      let image;
      function onReady() {
        if (callback) callback();
      }
      const isPicture = $(imageEl).parent('picture')[0];
      if (!isPicture && (!imageEl.complete || !checkForComplete)) {
        if (src) {
          image = new window.Image();
          image.onload = onReady;
          image.onerror = onReady;
          if (sizes) {
            image.sizes = sizes;
          }
          if (srcset) {
            image.srcset = srcset;
          }
          if (src) {
            image.src = src;
          }
        } else {
          onReady();
        }
      } else {
        onReady();
      }
    }

    function preloadImages() {
      const swiper = this;
      swiper.imagesToLoad = swiper.$el.find('img');
      function onReady() {
        if (typeof swiper === 'undefined' || swiper === null || !swiper || swiper.destroyed) return;
        if (swiper.imagesLoaded !== undefined) swiper.imagesLoaded += 1;
        if (swiper.imagesLoaded === swiper.imagesToLoad.length) {
          if (swiper.params.updateOnImagesReady) swiper.update();
          swiper.emit('imagesReady');
        }
      }
      for (let i = 0; i < swiper.imagesToLoad.length; i += 1) {
        const imageEl = swiper.imagesToLoad[i];
        swiper.loadImage(imageEl, imageEl.currentSrc || imageEl.getAttribute('src'), imageEl.srcset || imageEl.getAttribute('srcset'), imageEl.sizes || imageEl.getAttribute('sizes'), true, onReady);
      }
    }

    var images = {
      loadImage,
      preloadImages
    };

    function checkOverflow() {
      const swiper = this;
      const {
        isLocked: wasLocked,
        params
      } = swiper;
      const {
        slidesOffsetBefore
      } = params;
      if (slidesOffsetBefore) {
        const lastSlideIndex = swiper.slides.length - 1;
        const lastSlideRightEdge = swiper.slidesGrid[lastSlideIndex] + swiper.slidesSizesGrid[lastSlideIndex] + slidesOffsetBefore * 2;
        swiper.isLocked = swiper.size > lastSlideRightEdge;
      } else {
        swiper.isLocked = swiper.snapGrid.length === 1;
      }
      if (params.allowSlideNext === true) {
        swiper.allowSlideNext = !swiper.isLocked;
      }
      if (params.allowSlidePrev === true) {
        swiper.allowSlidePrev = !swiper.isLocked;
      }
      if (wasLocked && wasLocked !== swiper.isLocked) {
        swiper.isEnd = false;
      }
      if (wasLocked !== swiper.isLocked) {
        swiper.emit(swiper.isLocked ? 'lock' : 'unlock');
      }
    }
    var checkOverflow$1 = {
      checkOverflow
    };

    var defaults = {
      init: true,
      direction: 'horizontal',
      touchEventsTarget: 'wrapper',
      initialSlide: 0,
      speed: 300,
      cssMode: false,
      updateOnWindowResize: true,
      resizeObserver: true,
      nested: false,
      createElements: false,
      enabled: true,
      focusableElements: 'input, select, option, textarea, button, video, label',
      width: null,
      height: null,
      preventInteractionOnTransition: false,
      userAgent: null,
      url: null,
      edgeSwipeDetection: false,
      edgeSwipeThreshold: 20,
      autoHeight: false,
      setWrapperSize: false,
      virtualTranslate: false,
      effect: 'slide',
      breakpoints: undefined,
      breakpointsBase: 'window',
      spaceBetween: 0,
      slidesPerView: 1,
      slidesPerGroup: 1,
      slidesPerGroupSkip: 0,
      slidesPerGroupAuto: false,
      centeredSlides: false,
      centeredSlidesBounds: false,
      slidesOffsetBefore: 0,
      slidesOffsetAfter: 0,
      normalizeSlideIndex: true,
      centerInsufficientSlides: false,
      watchOverflow: true,
      roundLengths: false,
      touchRatio: 1,
      touchAngle: 45,
      simulateTouch: true,
      shortSwipes: true,
      longSwipes: true,
      longSwipesRatio: 0.5,
      longSwipesMs: 300,
      followFinger: true,
      allowTouchMove: true,
      threshold: 0,
      touchMoveStopPropagation: false,
      touchStartPreventDefault: true,
      touchStartForcePreventDefault: false,
      touchReleaseOnEdges: false,
      uniqueNavElements: true,
      resistance: true,
      resistanceRatio: 0.85,
      watchSlidesProgress: false,
      grabCursor: false,
      preventClicks: true,
      preventClicksPropagation: true,
      slideToClickedSlide: false,
      preloadImages: true,
      updateOnImagesReady: true,
      loop: false,
      loopAdditionalSlides: 0,
      loopedSlides: null,
      loopedSlidesLimit: true,
      loopFillGroupWithBlank: false,
      loopPreventsSlide: true,
      rewind: false,
      allowSlidePrev: true,
      allowSlideNext: true,
      swipeHandler: null,
      noSwiping: true,
      noSwipingClass: 'swiper-no-swiping',
      noSwipingSelector: null,
      passiveListeners: true,
      maxBackfaceHiddenSlides: 10,
      containerModifierClass: 'swiper-',
      slideClass: 'swiper-slide',
      slideBlankClass: 'swiper-slide-invisible-blank',
      slideActiveClass: 'swiper-slide-active',
      slideDuplicateActiveClass: 'swiper-slide-duplicate-active',
      slideVisibleClass: 'swiper-slide-visible',
      slideDuplicateClass: 'swiper-slide-duplicate',
      slideNextClass: 'swiper-slide-next',
      slideDuplicateNextClass: 'swiper-slide-duplicate-next',
      slidePrevClass: 'swiper-slide-prev',
      slideDuplicatePrevClass: 'swiper-slide-duplicate-prev',
      wrapperClass: 'swiper-wrapper',
      runCallbacksOnInit: true,
      _emitClasses: false
    };

    function moduleExtendParams(params, allModulesParams) {
      return function extendParams(obj = {}) {
        const moduleParamName = Object.keys(obj)[0];
        const moduleParams = obj[moduleParamName];
        if (typeof moduleParams !== 'object' || moduleParams === null) {
          extend(allModulesParams, obj);
          return;
        }
        if (['navigation', 'pagination', 'scrollbar'].indexOf(moduleParamName) >= 0 && params[moduleParamName] === true) {
          params[moduleParamName] = {
            auto: true
          };
        }
        if (!(moduleParamName in params && 'enabled' in moduleParams)) {
          extend(allModulesParams, obj);
          return;
        }
        if (params[moduleParamName] === true) {
          params[moduleParamName] = {
            enabled: true
          };
        }
        if (typeof params[moduleParamName] === 'object' && !('enabled' in params[moduleParamName])) {
          params[moduleParamName].enabled = true;
        }
        if (!params[moduleParamName]) params[moduleParamName] = {
          enabled: false
        };
        extend(allModulesParams, obj);
      };
    }

    const prototypes = {
      eventsEmitter,
      update,
      translate,
      transition,
      slide,
      loop,
      grabCursor,
      events: events$7,
      breakpoints: breakpoints$2,
      checkOverflow: checkOverflow$1,
      classes: classes$5,
      images
    };
    const extendedDefaults = {};
    class Swiper {
      constructor(...args) {
        let el;
        let params;
        if (args.length === 1 && args[0].constructor && Object.prototype.toString.call(args[0]).slice(8, -1) === 'Object') {
          params = args[0];
        } else {
          [el, params] = args;
        }
        if (!params) params = {};
        params = extend({}, params);
        if (el && !params.el) params.el = el;
        if (params.el && $(params.el).length > 1) {
          const swipers = [];
          $(params.el).each(containerEl => {
            const newParams = extend({}, params, {
              el: containerEl
            });
            swipers.push(new Swiper(newParams));
          });
          return swipers;
        }
        const swiper = this;
        swiper.__swiper__ = true;
        swiper.support = getSupport();
        swiper.device = getDevice({
          userAgent: params.userAgent
        });
        swiper.browser = getBrowser();
        swiper.eventsListeners = {};
        swiper.eventsAnyListeners = [];
        swiper.modules = [...swiper.__modules__];
        if (params.modules && Array.isArray(params.modules)) {
          swiper.modules.push(...params.modules);
        }
        const allModulesParams = {};
        swiper.modules.forEach(mod => {
          mod({
            swiper,
            extendParams: moduleExtendParams(params, allModulesParams),
            on: swiper.on.bind(swiper),
            once: swiper.once.bind(swiper),
            off: swiper.off.bind(swiper),
            emit: swiper.emit.bind(swiper)
          });
        });
        const swiperParams = extend({}, defaults, allModulesParams);
        swiper.params = extend({}, swiperParams, extendedDefaults, params);
        swiper.originalParams = extend({}, swiper.params);
        swiper.passedParams = extend({}, params);
        if (swiper.params && swiper.params.on) {
          Object.keys(swiper.params.on).forEach(eventName => {
            swiper.on(eventName, swiper.params.on[eventName]);
          });
        }
        if (swiper.params && swiper.params.onAny) {
          swiper.onAny(swiper.params.onAny);
        }
        swiper.$ = $;
        Object.assign(swiper, {
          enabled: swiper.params.enabled,
          el,
          classNames: [],
          slides: $(),
          slidesGrid: [],
          snapGrid: [],
          slidesSizesGrid: [],
          isHorizontal() {
            return swiper.params.direction === 'horizontal';
          },
          isVertical() {
            return swiper.params.direction === 'vertical';
          },
          activeIndex: 0,
          realIndex: 0,
          isBeginning: true,
          isEnd: false,
          translate: 0,
          previousTranslate: 0,
          progress: 0,
          velocity: 0,
          animating: false,
          allowSlideNext: swiper.params.allowSlideNext,
          allowSlidePrev: swiper.params.allowSlidePrev,
          touchEvents: function touchEvents() {
            const touch = ['touchstart', 'touchmove', 'touchend', 'touchcancel'];
            const desktop = ['pointerdown', 'pointermove', 'pointerup'];
            swiper.touchEventsTouch = {
              start: touch[0],
              move: touch[1],
              end: touch[2],
              cancel: touch[3]
            };
            swiper.touchEventsDesktop = {
              start: desktop[0],
              move: desktop[1],
              end: desktop[2]
            };
            return swiper.support.touch || !swiper.params.simulateTouch ? swiper.touchEventsTouch : swiper.touchEventsDesktop;
          }(),
          touchEventsData: {
            isTouched: undefined,
            isMoved: undefined,
            allowTouchCallbacks: undefined,
            touchStartTime: undefined,
            isScrolling: undefined,
            currentTranslate: undefined,
            startTranslate: undefined,
            allowThresholdMove: undefined,
            focusableElements: swiper.params.focusableElements,
            lastClickTime: now(),
            clickTimeout: undefined,
            velocities: [],
            allowMomentumBounce: undefined,
            isTouchEvent: undefined,
            startMoving: undefined
          },
          allowClick: true,
          allowTouchMove: swiper.params.allowTouchMove,
          touches: {
            startX: 0,
            startY: 0,
            currentX: 0,
            currentY: 0,
            diff: 0
          },
          imagesToLoad: [],
          imagesLoaded: 0
        });
        swiper.emit('_swiper');
        if (swiper.params.init) {
          swiper.init();
        }
        return swiper;
      }
      enable() {
        const swiper = this;
        if (swiper.enabled) return;
        swiper.enabled = true;
        if (swiper.params.grabCursor) {
          swiper.setGrabCursor();
        }
        swiper.emit('enable');
      }
      disable() {
        const swiper = this;
        if (!swiper.enabled) return;
        swiper.enabled = false;
        if (swiper.params.grabCursor) {
          swiper.unsetGrabCursor();
        }
        swiper.emit('disable');
      }
      setProgress(progress, speed) {
        const swiper = this;
        progress = Math.min(Math.max(progress, 0), 1);
        const min = swiper.minTranslate();
        const max = swiper.maxTranslate();
        const current = (max - min) * progress + min;
        swiper.translateTo(current, typeof speed === 'undefined' ? 0 : speed);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
      }
      emitContainerClasses() {
        const swiper = this;
        if (!swiper.params._emitClasses || !swiper.el) return;
        const cls = swiper.el.className.split(' ').filter(className => {
          return className.indexOf('swiper') === 0 || className.indexOf(swiper.params.containerModifierClass) === 0;
        });
        swiper.emit('_containerClasses', cls.join(' '));
      }
      getSlideClasses(slideEl) {
        const swiper = this;
        if (swiper.destroyed) return '';
        return slideEl.className.split(' ').filter(className => {
          return className.indexOf('swiper-slide') === 0 || className.indexOf(swiper.params.slideClass) === 0;
        }).join(' ');
      }
      emitSlidesClasses() {
        const swiper = this;
        if (!swiper.params._emitClasses || !swiper.el) return;
        const updates = [];
        swiper.slides.each(slideEl => {
          const classNames = swiper.getSlideClasses(slideEl);
          updates.push({
            slideEl,
            classNames
          });
          swiper.emit('_slideClass', slideEl, classNames);
        });
        swiper.emit('_slideClasses', updates);
      }
      slidesPerViewDynamic(view = 'current', exact = false) {
        const swiper = this;
        const {
          params,
          slides,
          slidesGrid,
          slidesSizesGrid,
          size: swiperSize,
          activeIndex
        } = swiper;
        let spv = 1;
        if (params.centeredSlides) {
          let slideSize = slides[activeIndex].swiperSlideSize;
          let breakLoop;
          for (let i = activeIndex + 1; i < slides.length; i += 1) {
            if (slides[i] && !breakLoop) {
              slideSize += slides[i].swiperSlideSize;
              spv += 1;
              if (slideSize > swiperSize) breakLoop = true;
            }
          }
          for (let i = activeIndex - 1; i >= 0; i -= 1) {
            if (slides[i] && !breakLoop) {
              slideSize += slides[i].swiperSlideSize;
              spv += 1;
              if (slideSize > swiperSize) breakLoop = true;
            }
          }
        } else {
          if (view === 'current') {
            for (let i = activeIndex + 1; i < slides.length; i += 1) {
              const slideInView = exact ? slidesGrid[i] + slidesSizesGrid[i] - slidesGrid[activeIndex] < swiperSize : slidesGrid[i] - slidesGrid[activeIndex] < swiperSize;
              if (slideInView) {
                spv += 1;
              }
            }
          } else {
            for (let i = activeIndex - 1; i >= 0; i -= 1) {
              const slideInView = slidesGrid[activeIndex] - slidesGrid[i] < swiperSize;
              if (slideInView) {
                spv += 1;
              }
            }
          }
        }
        return spv;
      }
      update() {
        const swiper = this;
        if (!swiper || swiper.destroyed) return;
        const {
          snapGrid,
          params
        } = swiper;
        if (params.breakpoints) {
          swiper.setBreakpoint();
        }
        swiper.updateSize();
        swiper.updateSlides();
        swiper.updateProgress();
        swiper.updateSlidesClasses();
        function setTranslate() {
          const translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
          const newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
          swiper.setTranslate(newTranslate);
          swiper.updateActiveIndex();
          swiper.updateSlidesClasses();
        }
        let translated;
        if (swiper.params.freeMode && swiper.params.freeMode.enabled) {
          setTranslate();
          if (swiper.params.autoHeight) {
            swiper.updateAutoHeight();
          }
        } else {
          if ((swiper.params.slidesPerView === 'auto' || swiper.params.slidesPerView > 1) && swiper.isEnd && !swiper.params.centeredSlides) {
            translated = swiper.slideTo(swiper.slides.length - 1, 0, false, true);
          } else {
            translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
          }
          if (!translated) {
            setTranslate();
          }
        }
        if (params.watchOverflow && snapGrid !== swiper.snapGrid) {
          swiper.checkOverflow();
        }
        swiper.emit('update');
      }
      changeDirection(newDirection, needUpdate = true) {
        const swiper = this;
        const currentDirection = swiper.params.direction;
        if (!newDirection) {
          newDirection = currentDirection === 'horizontal' ? 'vertical' : 'horizontal';
        }
        if (newDirection === currentDirection || newDirection !== 'horizontal' && newDirection !== 'vertical') {
          return swiper;
        }
        swiper.$el.removeClass(`${swiper.params.containerModifierClass}${currentDirection}`).addClass(`${swiper.params.containerModifierClass}${newDirection}`);
        swiper.emitContainerClasses();
        swiper.params.direction = newDirection;
        swiper.slides.each(slideEl => {
          if (newDirection === 'vertical') {
            slideEl.style.width = '';
          } else {
            slideEl.style.height = '';
          }
        });
        swiper.emit('changeDirection');
        if (needUpdate) swiper.update();
        return swiper;
      }
      changeLanguageDirection(direction) {
        const swiper = this;
        if (swiper.rtl && direction === 'rtl' || !swiper.rtl && direction === 'ltr') return;
        swiper.rtl = direction === 'rtl';
        swiper.rtlTranslate = swiper.params.direction === 'horizontal' && swiper.rtl;
        if (swiper.rtl) {
          swiper.$el.addClass(`${swiper.params.containerModifierClass}rtl`);
          swiper.el.dir = 'rtl';
        } else {
          swiper.$el.removeClass(`${swiper.params.containerModifierClass}rtl`);
          swiper.el.dir = 'ltr';
        }
        swiper.update();
      }
      mount(el) {
        const swiper = this;
        if (swiper.mounted) return true;
        const $el = $(el || swiper.params.el);
        el = $el[0];
        if (!el) {
          return false;
        }
        el.swiper = swiper;
        const getWrapperSelector = () => {
          return `.${(swiper.params.wrapperClass || '').trim().split(' ').join('.')}`;
        };
        const getWrapper = () => {
          if (el && el.shadowRoot && el.shadowRoot.querySelector) {
            const res = $(el.shadowRoot.querySelector(getWrapperSelector()));
            res.children = options => $el.children(options);
            return res;
          }
          if (!$el.children) {
            return $($el).children(getWrapperSelector());
          }
          return $el.children(getWrapperSelector());
        };
        let $wrapperEl = getWrapper();
        if ($wrapperEl.length === 0 && swiper.params.createElements) {
          const document = getDocument();
          const wrapper = document.createElement('div');
          $wrapperEl = $(wrapper);
          wrapper.className = swiper.params.wrapperClass;
          $el.append(wrapper);
          $el.children(`.${swiper.params.slideClass}`).each(slideEl => {
            $wrapperEl.append(slideEl);
          });
        }
        Object.assign(swiper, {
          $el,
          el,
          $wrapperEl,
          wrapperEl: $wrapperEl[0],
          mounted: true,
          rtl: el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl',
          rtlTranslate: swiper.params.direction === 'horizontal' && (el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl'),
          wrongRTL: $wrapperEl.css('display') === '-webkit-box'
        });
        return true;
      }
      init(el) {
        const swiper = this;
        if (swiper.initialized) return swiper;
        const mounted = swiper.mount(el);
        if (mounted === false) return swiper;
        swiper.emit('beforeInit');
        if (swiper.params.breakpoints) {
          swiper.setBreakpoint();
        }
        swiper.addClasses();
        if (swiper.params.loop) {
          swiper.loopCreate();
        }
        swiper.updateSize();
        swiper.updateSlides();
        if (swiper.params.watchOverflow) {
          swiper.checkOverflow();
        }
        if (swiper.params.grabCursor && swiper.enabled) {
          swiper.setGrabCursor();
        }
        if (swiper.params.preloadImages) {
          swiper.preloadImages();
        }
        if (swiper.params.loop) {
          swiper.slideTo(swiper.params.initialSlide + swiper.loopedSlides, 0, swiper.params.runCallbacksOnInit, false, true);
        } else {
          swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit, false, true);
        }
        swiper.attachEvents();
        swiper.initialized = true;
        swiper.emit('init');
        swiper.emit('afterInit');
        return swiper;
      }
      destroy(deleteInstance = true, cleanStyles = true) {
        const swiper = this;
        const {
          params,
          $el,
          $wrapperEl,
          slides
        } = swiper;
        if (typeof swiper.params === 'undefined' || swiper.destroyed) {
          return null;
        }
        swiper.emit('beforeDestroy');
        swiper.initialized = false;
        swiper.detachEvents();
        if (params.loop) {
          swiper.loopDestroy();
        }
        if (cleanStyles) {
          swiper.removeClasses();
          $el.removeAttr('style');
          $wrapperEl.removeAttr('style');
          if (slides && slides.length) {
            slides.removeClass([params.slideVisibleClass, params.slideActiveClass, params.slideNextClass, params.slidePrevClass].join(' ')).removeAttr('style').removeAttr('data-swiper-slide-index');
          }
        }
        swiper.emit('destroy');
        Object.keys(swiper.eventsListeners).forEach(eventName => {
          swiper.off(eventName);
        });
        if (deleteInstance !== false) {
          swiper.$el[0].swiper = null;
          deleteProps(swiper);
        }
        swiper.destroyed = true;
        return null;
      }
      static extendDefaults(newDefaults) {
        extend(extendedDefaults, newDefaults);
      }
      static get extendedDefaults() {
        return extendedDefaults;
      }
      static get defaults() {
        return defaults;
      }
      static installModule(mod) {
        if (!Swiper.prototype.__modules__) Swiper.prototype.__modules__ = [];
        const modules = Swiper.prototype.__modules__;
        if (typeof mod === 'function' && modules.indexOf(mod) < 0) {
          modules.push(mod);
        }
      }
      static use(module) {
        if (Array.isArray(module)) {
          module.forEach(m => Swiper.installModule(m));
          return Swiper;
        }
        Swiper.installModule(module);
        return Swiper;
      }
    }
    Object.keys(prototypes).forEach(prototypeGroup => {
      Object.keys(prototypes[prototypeGroup]).forEach(protoMethod => {
        Swiper.prototype[protoMethod] = prototypes[prototypeGroup][protoMethod];
      });
    });
    Swiper.use([Resize, Observer]);
    var Swiper$1 = Swiper;

    function Mousewheel({
      swiper,
      extendParams,
      on,
      emit
    }) {
      const window = getWindow();
      extendParams({
        mousewheel: {
          enabled: false,
          releaseOnEdges: false,
          invert: false,
          forceToAxis: false,
          sensitivity: 1,
          eventsTarget: 'container',
          thresholdDelta: null,
          thresholdTime: null
        }
      });
      swiper.mousewheel = {
        enabled: false
      };
      let timeout;
      let lastScrollTime = now();
      let lastEventBeforeSnap;
      const recentWheelEvents = [];
      function normalize(e) {
        const PIXEL_STEP = 10;
        const LINE_HEIGHT = 40;
        const PAGE_HEIGHT = 800;
        let sX = 0;
        let sY = 0;
        let pX = 0;
        let pY = 0;
        if ('detail' in e) {
          sY = e.detail;
        }
        if ('wheelDelta' in e) {
          sY = -e.wheelDelta / 120;
        }
        if ('wheelDeltaY' in e) {
          sY = -e.wheelDeltaY / 120;
        }
        if ('wheelDeltaX' in e) {
          sX = -e.wheelDeltaX / 120;
        }
        if ('axis' in e && e.axis === e.HORIZONTAL_AXIS) {
          sX = sY;
          sY = 0;
        }
        pX = sX * PIXEL_STEP;
        pY = sY * PIXEL_STEP;
        if ('deltaY' in e) {
          pY = e.deltaY;
        }
        if ('deltaX' in e) {
          pX = e.deltaX;
        }
        if (e.shiftKey && !pX) {
          pX = pY;
          pY = 0;
        }
        if ((pX || pY) && e.deltaMode) {
          if (e.deltaMode === 1) {
            pX *= LINE_HEIGHT;
            pY *= LINE_HEIGHT;
          } else {
            pX *= PAGE_HEIGHT;
            pY *= PAGE_HEIGHT;
          }
        }
        if (pX && !sX) {
          sX = pX < 1 ? -1 : 1;
        }
        if (pY && !sY) {
          sY = pY < 1 ? -1 : 1;
        }
        return {
          spinX: sX,
          spinY: sY,
          pixelX: pX,
          pixelY: pY
        };
      }
      function handleMouseEnter() {
        if (!swiper.enabled) return;
        swiper.mouseEntered = true;
      }
      function handleMouseLeave() {
        if (!swiper.enabled) return;
        swiper.mouseEntered = false;
      }
      function animateSlider(newEvent) {
        if (swiper.params.mousewheel.thresholdDelta && newEvent.delta < swiper.params.mousewheel.thresholdDelta) {
          return false;
        }
        if (swiper.params.mousewheel.thresholdTime && now() - lastScrollTime < swiper.params.mousewheel.thresholdTime) {
          return false;
        }
        if (newEvent.delta >= 6 && now() - lastScrollTime < 60) {
          return true;
        }
        if (newEvent.direction < 0) {
          if ((!swiper.isEnd || swiper.params.loop) && !swiper.animating) {
            swiper.slideNext();
            emit('scroll', newEvent.raw);
          }
        } else if ((!swiper.isBeginning || swiper.params.loop) && !swiper.animating) {
          swiper.slidePrev();
          emit('scroll', newEvent.raw);
        }
        lastScrollTime = new window.Date().getTime();
        return false;
      }
      function releaseScroll(newEvent) {
        const params = swiper.params.mousewheel;
        if (newEvent.direction < 0) {
          if (swiper.isEnd && !swiper.params.loop && params.releaseOnEdges) {
            return true;
          }
        } else if (swiper.isBeginning && !swiper.params.loop && params.releaseOnEdges) {
          return true;
        }
        return false;
      }
      function handle(event) {
        let e = event;
        let disableParentSwiper = true;
        if (!swiper.enabled) return;
        const params = swiper.params.mousewheel;
        if (swiper.params.cssMode) {
          e.preventDefault();
        }
        let target = swiper.$el;
        if (swiper.params.mousewheel.eventsTarget !== 'container') {
          target = $(swiper.params.mousewheel.eventsTarget);
        }
        if (!swiper.mouseEntered && !target[0].contains(e.target) && !params.releaseOnEdges) return true;
        if (e.originalEvent) e = e.originalEvent;
        let delta = 0;
        const rtlFactor = swiper.rtlTranslate ? -1 : 1;
        const data = normalize(e);
        if (params.forceToAxis) {
          if (swiper.isHorizontal()) {
            if (Math.abs(data.pixelX) > Math.abs(data.pixelY)) delta = -data.pixelX * rtlFactor;else return true;
          } else if (Math.abs(data.pixelY) > Math.abs(data.pixelX)) delta = -data.pixelY;else return true;
        } else {
          delta = Math.abs(data.pixelX) > Math.abs(data.pixelY) ? -data.pixelX * rtlFactor : -data.pixelY;
        }
        if (delta === 0) return true;
        if (params.invert) delta = -delta;
        let positions = swiper.getTranslate() + delta * params.sensitivity;
        if (positions >= swiper.minTranslate()) positions = swiper.minTranslate();
        if (positions <= swiper.maxTranslate()) positions = swiper.maxTranslate();
        disableParentSwiper = swiper.params.loop ? true : !(positions === swiper.minTranslate() || positions === swiper.maxTranslate());
        if (disableParentSwiper && swiper.params.nested) e.stopPropagation();
        if (!swiper.params.freeMode || !swiper.params.freeMode.enabled) {
          const newEvent = {
            time: now(),
            delta: Math.abs(delta),
            direction: Math.sign(delta),
            raw: event
          };
          if (recentWheelEvents.length >= 2) {
            recentWheelEvents.shift();
          }
          const prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
          recentWheelEvents.push(newEvent);
          if (prevEvent) {
            if (newEvent.direction !== prevEvent.direction || newEvent.delta > prevEvent.delta || newEvent.time > prevEvent.time + 150) {
              animateSlider(newEvent);
            }
          } else {
            animateSlider(newEvent);
          }
          if (releaseScroll(newEvent)) {
            return true;
          }
        } else {
          const newEvent = {
            time: now(),
            delta: Math.abs(delta),
            direction: Math.sign(delta)
          };
          const ignoreWheelEvents = lastEventBeforeSnap && newEvent.time < lastEventBeforeSnap.time + 500 && newEvent.delta <= lastEventBeforeSnap.delta && newEvent.direction === lastEventBeforeSnap.direction;
          if (!ignoreWheelEvents) {
            lastEventBeforeSnap = undefined;
            if (swiper.params.loop) {
              swiper.loopFix();
            }
            let position = swiper.getTranslate() + delta * params.sensitivity;
            const wasBeginning = swiper.isBeginning;
            const wasEnd = swiper.isEnd;
            if (position >= swiper.minTranslate()) position = swiper.minTranslate();
            if (position <= swiper.maxTranslate()) position = swiper.maxTranslate();
            swiper.setTransition(0);
            swiper.setTranslate(position);
            swiper.updateProgress();
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
            if (!wasBeginning && swiper.isBeginning || !wasEnd && swiper.isEnd) {
              swiper.updateSlidesClasses();
            }
            if (swiper.params.freeMode.sticky) {
              clearTimeout(timeout);
              timeout = undefined;
              if (recentWheelEvents.length >= 15) {
                recentWheelEvents.shift();
              }
              const prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
              const firstEvent = recentWheelEvents[0];
              recentWheelEvents.push(newEvent);
              if (prevEvent && (newEvent.delta > prevEvent.delta || newEvent.direction !== prevEvent.direction)) {
                recentWheelEvents.splice(0);
              } else if (recentWheelEvents.length >= 15 && newEvent.time - firstEvent.time < 500 && firstEvent.delta - newEvent.delta >= 1 && newEvent.delta <= 6) {
                const snapToThreshold = delta > 0 ? 0.8 : 0.2;
                lastEventBeforeSnap = newEvent;
                recentWheelEvents.splice(0);
                timeout = nextTick(() => {
                  swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
                }, 0);
              }
              if (!timeout) {
                timeout = nextTick(() => {
                  const snapToThreshold = 0.5;
                  lastEventBeforeSnap = newEvent;
                  recentWheelEvents.splice(0);
                  swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
                }, 500);
              }
            }
            if (!ignoreWheelEvents) emit('scroll', e);
            if (swiper.params.autoplay && swiper.params.autoplayDisableOnInteraction) swiper.autoplay.stop();
            if (position === swiper.minTranslate() || position === swiper.maxTranslate()) return true;
          }
        }
        if (e.preventDefault) e.preventDefault();else e.returnValue = false;
        return false;
      }
      function events(method) {
        let target = swiper.$el;
        if (swiper.params.mousewheel.eventsTarget !== 'container') {
          target = $(swiper.params.mousewheel.eventsTarget);
        }
        target[method]('mouseenter', handleMouseEnter);
        target[method]('mouseleave', handleMouseLeave);
        target[method]('wheel', handle);
      }
      function enable() {
        if (swiper.params.cssMode) {
          swiper.wrapperEl.removeEventListener('wheel', handle);
          return true;
        }
        if (swiper.mousewheel.enabled) return false;
        events('on');
        swiper.mousewheel.enabled = true;
        return true;
      }
      function disable() {
        if (swiper.params.cssMode) {
          swiper.wrapperEl.addEventListener(event, handle);
          return true;
        }
        if (!swiper.mousewheel.enabled) return false;
        events('off');
        swiper.mousewheel.enabled = false;
        return true;
      }
      on('init', () => {
        if (!swiper.params.mousewheel.enabled && swiper.params.cssMode) {
          disable();
        }
        if (swiper.params.mousewheel.enabled) enable();
      });
      on('destroy', () => {
        if (swiper.params.cssMode) {
          enable();
        }
        if (swiper.mousewheel.enabled) disable();
      });
      Object.assign(swiper.mousewheel, {
        enable,
        disable
      });
    }

    function createElementIfNotDefined(swiper, originalParams, params, checkProps) {
      const document = getDocument();
      if (swiper.params.createElements) {
        Object.keys(checkProps).forEach(key => {
          if (!params[key] && params.auto === true) {
            let element = swiper.$el.children(`.${checkProps[key]}`)[0];
            if (!element) {
              element = document.createElement('div');
              element.className = checkProps[key];
              swiper.$el.append(element);
            }
            params[key] = element;
            originalParams[key] = element;
          }
        });
      }
      return params;
    }

    function Navigation({
      swiper,
      extendParams,
      on,
      emit
    }) {
      extendParams({
        navigation: {
          nextEl: null,
          prevEl: null,
          hideOnClick: false,
          disabledClass: 'swiper-button-disabled',
          hiddenClass: 'swiper-button-hidden',
          lockClass: 'swiper-button-lock',
          navigationDisabledClass: 'swiper-navigation-disabled'
        }
      });
      swiper.navigation = {
        nextEl: null,
        $nextEl: null,
        prevEl: null,
        $prevEl: null
      };
      function getEl(el) {
        let $el;
        if (el) {
          $el = $(el);
          if (swiper.params.uniqueNavElements && typeof el === 'string' && $el.length > 1 && swiper.$el.find(el).length === 1) {
            $el = swiper.$el.find(el);
          }
        }
        return $el;
      }
      function toggleEl($el, disabled) {
        const params = swiper.params.navigation;
        if ($el && $el.length > 0) {
          $el[disabled ? 'addClass' : 'removeClass'](params.disabledClass);
          if ($el[0] && $el[0].tagName === 'BUTTON') $el[0].disabled = disabled;
          if (swiper.params.watchOverflow && swiper.enabled) {
            $el[swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
          }
        }
      }
      function update() {
        if (swiper.params.loop) return;
        const {
          $nextEl,
          $prevEl
        } = swiper.navigation;
        toggleEl($prevEl, swiper.isBeginning && !swiper.params.rewind);
        toggleEl($nextEl, swiper.isEnd && !swiper.params.rewind);
      }
      function onPrevClick(e) {
        e.preventDefault();
        if (swiper.isBeginning && !swiper.params.loop && !swiper.params.rewind) return;
        swiper.slidePrev();
        emit('navigationPrev');
      }
      function onNextClick(e) {
        e.preventDefault();
        if (swiper.isEnd && !swiper.params.loop && !swiper.params.rewind) return;
        swiper.slideNext();
        emit('navigationNext');
      }
      function init() {
        const params = swiper.params.navigation;
        swiper.params.navigation = createElementIfNotDefined(swiper, swiper.originalParams.navigation, swiper.params.navigation, {
          nextEl: 'swiper-button-next',
          prevEl: 'swiper-button-prev'
        });
        if (!(params.nextEl || params.prevEl)) return;
        const $nextEl = getEl(params.nextEl);
        const $prevEl = getEl(params.prevEl);
        if ($nextEl && $nextEl.length > 0) {
          $nextEl.on('click', onNextClick);
        }
        if ($prevEl && $prevEl.length > 0) {
          $prevEl.on('click', onPrevClick);
        }
        Object.assign(swiper.navigation, {
          $nextEl,
          nextEl: $nextEl && $nextEl[0],
          $prevEl,
          prevEl: $prevEl && $prevEl[0]
        });
        if (!swiper.enabled) {
          if ($nextEl) $nextEl.addClass(params.lockClass);
          if ($prevEl) $prevEl.addClass(params.lockClass);
        }
      }
      function destroy() {
        const {
          $nextEl,
          $prevEl
        } = swiper.navigation;
        if ($nextEl && $nextEl.length) {
          $nextEl.off('click', onNextClick);
          $nextEl.removeClass(swiper.params.navigation.disabledClass);
        }
        if ($prevEl && $prevEl.length) {
          $prevEl.off('click', onPrevClick);
          $prevEl.removeClass(swiper.params.navigation.disabledClass);
        }
      }
      on('init', () => {
        if (swiper.params.navigation.enabled === false) {
          disable();
        } else {
          init();
          update();
        }
      });
      on('toEdge fromEdge lock unlock', () => {
        update();
      });
      on('destroy', () => {
        destroy();
      });
      on('enable disable', () => {
        const {
          $nextEl,
          $prevEl
        } = swiper.navigation;
        if ($nextEl) {
          $nextEl[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.navigation.lockClass);
        }
        if ($prevEl) {
          $prevEl[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.navigation.lockClass);
        }
      });
      on('click', (_s, e) => {
        const {
          $nextEl,
          $prevEl
        } = swiper.navigation;
        const targetEl = e.target;
        if (swiper.params.navigation.hideOnClick && !$(targetEl).is($prevEl) && !$(targetEl).is($nextEl)) {
          if (swiper.pagination && swiper.params.pagination && swiper.params.pagination.clickable && (swiper.pagination.el === targetEl || swiper.pagination.el.contains(targetEl))) return;
          let isHidden;
          if ($nextEl) {
            isHidden = $nextEl.hasClass(swiper.params.navigation.hiddenClass);
          } else if ($prevEl) {
            isHidden = $prevEl.hasClass(swiper.params.navigation.hiddenClass);
          }
          if (isHidden === true) {
            emit('navigationShow');
          } else {
            emit('navigationHide');
          }
          if ($nextEl) {
            $nextEl.toggleClass(swiper.params.navigation.hiddenClass);
          }
          if ($prevEl) {
            $prevEl.toggleClass(swiper.params.navigation.hiddenClass);
          }
        }
      });
      const enable = () => {
        swiper.$el.removeClass(swiper.params.navigation.navigationDisabledClass);
        init();
        update();
      };
      const disable = () => {
        swiper.$el.addClass(swiper.params.navigation.navigationDisabledClass);
        destroy();
      };
      Object.assign(swiper.navigation, {
        enable,
        disable,
        update,
        init,
        destroy
      });
    }

    function classesToSelector(classes = '') {
      return `.${classes.trim().replace(/([\.:!\/])/g, '\\$1').replace(/ /g, '.')}`;
    }

    function Pagination({
      swiper,
      extendParams,
      on,
      emit
    }) {
      const pfx = 'swiper-pagination';
      extendParams({
        pagination: {
          el: null,
          bulletElement: 'span',
          clickable: false,
          hideOnClick: false,
          renderBullet: null,
          renderProgressbar: null,
          renderFraction: null,
          renderCustom: null,
          progressbarOpposite: false,
          type: 'bullets',
          dynamicBullets: false,
          dynamicMainBullets: 1,
          formatFractionCurrent: number => number,
          formatFractionTotal: number => number,
          bulletClass: `${pfx}-bullet`,
          bulletActiveClass: `${pfx}-bullet-active`,
          modifierClass: `${pfx}-`,
          currentClass: `${pfx}-current`,
          totalClass: `${pfx}-total`,
          hiddenClass: `${pfx}-hidden`,
          progressbarFillClass: `${pfx}-progressbar-fill`,
          progressbarOppositeClass: `${pfx}-progressbar-opposite`,
          clickableClass: `${pfx}-clickable`,
          lockClass: `${pfx}-lock`,
          horizontalClass: `${pfx}-horizontal`,
          verticalClass: `${pfx}-vertical`,
          paginationDisabledClass: `${pfx}-disabled`
        }
      });
      swiper.pagination = {
        el: null,
        $el: null,
        bullets: []
      };
      let bulletSize;
      let dynamicBulletIndex = 0;
      function isPaginationDisabled() {
        return !swiper.params.pagination.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0;
      }
      function setSideBullets($bulletEl, position) {
        const {
          bulletActiveClass
        } = swiper.params.pagination;
        $bulletEl[position]().addClass(`${bulletActiveClass}-${position}`)[position]().addClass(`${bulletActiveClass}-${position}-${position}`);
      }
      function update() {
        const rtl = swiper.rtl;
        const params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
        const $el = swiper.pagination.$el;
        let current;
        const total = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
        if (swiper.params.loop) {
          current = Math.ceil((swiper.activeIndex - swiper.loopedSlides) / swiper.params.slidesPerGroup);
          if (current > slidesLength - 1 - swiper.loopedSlides * 2) {
            current -= slidesLength - swiper.loopedSlides * 2;
          }
          if (current > total - 1) current -= total;
          if (current < 0 && swiper.params.paginationType !== 'bullets') current = total + current;
        } else if (typeof swiper.snapIndex !== 'undefined') {
          current = swiper.snapIndex;
        } else {
          current = swiper.activeIndex || 0;
        }
        if (params.type === 'bullets' && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
          const bullets = swiper.pagination.bullets;
          let firstIndex;
          let lastIndex;
          let midIndex;
          if (params.dynamicBullets) {
            bulletSize = bullets.eq(0)[swiper.isHorizontal() ? 'outerWidth' : 'outerHeight'](true);
            $el.css(swiper.isHorizontal() ? 'width' : 'height', `${bulletSize * (params.dynamicMainBullets + 4)}px`);
            if (params.dynamicMainBullets > 1 && swiper.previousIndex !== undefined) {
              dynamicBulletIndex += current - (swiper.previousIndex - swiper.loopedSlides || 0);
              if (dynamicBulletIndex > params.dynamicMainBullets - 1) {
                dynamicBulletIndex = params.dynamicMainBullets - 1;
              } else if (dynamicBulletIndex < 0) {
                dynamicBulletIndex = 0;
              }
            }
            firstIndex = Math.max(current - dynamicBulletIndex, 0);
            lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
            midIndex = (lastIndex + firstIndex) / 2;
          }
          bullets.removeClass(['', '-next', '-next-next', '-prev', '-prev-prev', '-main'].map(suffix => `${params.bulletActiveClass}${suffix}`).join(' '));
          if ($el.length > 1) {
            bullets.each(bullet => {
              const $bullet = $(bullet);
              const bulletIndex = $bullet.index();
              if (bulletIndex === current) {
                $bullet.addClass(params.bulletActiveClass);
              }
              if (params.dynamicBullets) {
                if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) {
                  $bullet.addClass(`${params.bulletActiveClass}-main`);
                }
                if (bulletIndex === firstIndex) {
                  setSideBullets($bullet, 'prev');
                }
                if (bulletIndex === lastIndex) {
                  setSideBullets($bullet, 'next');
                }
              }
            });
          } else {
            const $bullet = bullets.eq(current);
            const bulletIndex = $bullet.index();
            $bullet.addClass(params.bulletActiveClass);
            if (params.dynamicBullets) {
              const $firstDisplayedBullet = bullets.eq(firstIndex);
              const $lastDisplayedBullet = bullets.eq(lastIndex);
              for (let i = firstIndex; i <= lastIndex; i += 1) {
                bullets.eq(i).addClass(`${params.bulletActiveClass}-main`);
              }
              if (swiper.params.loop) {
                if (bulletIndex >= bullets.length) {
                  for (let i = params.dynamicMainBullets; i >= 0; i -= 1) {
                    bullets.eq(bullets.length - i).addClass(`${params.bulletActiveClass}-main`);
                  }
                  bullets.eq(bullets.length - params.dynamicMainBullets - 1).addClass(`${params.bulletActiveClass}-prev`);
                } else {
                  setSideBullets($firstDisplayedBullet, 'prev');
                  setSideBullets($lastDisplayedBullet, 'next');
                }
              } else {
                setSideBullets($firstDisplayedBullet, 'prev');
                setSideBullets($lastDisplayedBullet, 'next');
              }
            }
          }
          if (params.dynamicBullets) {
            const dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
            const bulletsOffset = (bulletSize * dynamicBulletsLength - bulletSize) / 2 - midIndex * bulletSize;
            const offsetProp = rtl ? 'right' : 'left';
            bullets.css(swiper.isHorizontal() ? offsetProp : 'top', `${bulletsOffset}px`);
          }
        }
        if (params.type === 'fraction') {
          $el.find(classesToSelector(params.currentClass)).text(params.formatFractionCurrent(current + 1));
          $el.find(classesToSelector(params.totalClass)).text(params.formatFractionTotal(total));
        }
        if (params.type === 'progressbar') {
          let progressbarDirection;
          if (params.progressbarOpposite) {
            progressbarDirection = swiper.isHorizontal() ? 'vertical' : 'horizontal';
          } else {
            progressbarDirection = swiper.isHorizontal() ? 'horizontal' : 'vertical';
          }
          const scale = (current + 1) / total;
          let scaleX = 1;
          let scaleY = 1;
          if (progressbarDirection === 'horizontal') {
            scaleX = scale;
          } else {
            scaleY = scale;
          }
          $el.find(classesToSelector(params.progressbarFillClass)).transform(`translate3d(0,0,0) scaleX(${scaleX}) scaleY(${scaleY})`).transition(swiper.params.speed);
        }
        if (params.type === 'custom' && params.renderCustom) {
          $el.html(params.renderCustom(swiper, current + 1, total));
          emit('paginationRender', $el[0]);
        } else {
          emit('paginationUpdate', $el[0]);
        }
        if (swiper.params.watchOverflow && swiper.enabled) {
          $el[swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
        }
      }
      function render() {
        const params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
        const $el = swiper.pagination.$el;
        let paginationHTML = '';
        if (params.type === 'bullets') {
          let numberOfBullets = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
          if (swiper.params.freeMode && swiper.params.freeMode.enabled && !swiper.params.loop && numberOfBullets > slidesLength) {
            numberOfBullets = slidesLength;
          }
          for (let i = 0; i < numberOfBullets; i += 1) {
            if (params.renderBullet) {
              paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
            } else {
              paginationHTML += `<${params.bulletElement} class="${params.bulletClass}"></${params.bulletElement}>`;
            }
          }
          $el.html(paginationHTML);
          swiper.pagination.bullets = $el.find(classesToSelector(params.bulletClass));
        }
        if (params.type === 'fraction') {
          if (params.renderFraction) {
            paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
          } else {
            paginationHTML = `<span class="${params.currentClass}"></span>` + ' / ' + `<span class="${params.totalClass}"></span>`;
          }
          $el.html(paginationHTML);
        }
        if (params.type === 'progressbar') {
          if (params.renderProgressbar) {
            paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
          } else {
            paginationHTML = `<span class="${params.progressbarFillClass}"></span>`;
          }
          $el.html(paginationHTML);
        }
        if (params.type !== 'custom') {
          emit('paginationRender', swiper.pagination.$el[0]);
        }
      }
      function init() {
        swiper.params.pagination = createElementIfNotDefined(swiper, swiper.originalParams.pagination, swiper.params.pagination, {
          el: 'swiper-pagination'
        });
        const params = swiper.params.pagination;
        if (!params.el) return;
        let $el = $(params.el);
        if ($el.length === 0) return;
        if (swiper.params.uniqueNavElements && typeof params.el === 'string' && $el.length > 1) {
          $el = swiper.$el.find(params.el);
          if ($el.length > 1) {
            $el = $el.filter(el => {
              if ($(el).parents('.swiper')[0] !== swiper.el) return false;
              return true;
            });
          }
        }
        if (params.type === 'bullets' && params.clickable) {
          $el.addClass(params.clickableClass);
        }
        $el.addClass(params.modifierClass + params.type);
        $el.addClass(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        if (params.type === 'bullets' && params.dynamicBullets) {
          $el.addClass(`${params.modifierClass}${params.type}-dynamic`);
          dynamicBulletIndex = 0;
          if (params.dynamicMainBullets < 1) {
            params.dynamicMainBullets = 1;
          }
        }
        if (params.type === 'progressbar' && params.progressbarOpposite) {
          $el.addClass(params.progressbarOppositeClass);
        }
        if (params.clickable) {
          $el.on('click', classesToSelector(params.bulletClass), function onClick(e) {
            e.preventDefault();
            let index = $(this).index() * swiper.params.slidesPerGroup;
            if (swiper.params.loop) index += swiper.loopedSlides;
            swiper.slideTo(index);
          });
        }
        Object.assign(swiper.pagination, {
          $el,
          el: $el[0]
        });
        if (!swiper.enabled) {
          $el.addClass(params.lockClass);
        }
      }
      function destroy() {
        const params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        const $el = swiper.pagination.$el;
        $el.removeClass(params.hiddenClass);
        $el.removeClass(params.modifierClass + params.type);
        $el.removeClass(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        if (swiper.pagination.bullets && swiper.pagination.bullets.removeClass) swiper.pagination.bullets.removeClass(params.bulletActiveClass);
        if (params.clickable) {
          $el.off('click', classesToSelector(params.bulletClass));
        }
      }
      on('init', () => {
        if (swiper.params.pagination.enabled === false) {
          disable();
        } else {
          init();
          render();
          update();
        }
      });
      on('activeIndexChange', () => {
        if (swiper.params.loop) {
          update();
        } else if (typeof swiper.snapIndex === 'undefined') {
          update();
        }
      });
      on('snapIndexChange', () => {
        if (!swiper.params.loop) {
          update();
        }
      });
      on('slidesLengthChange', () => {
        if (swiper.params.loop) {
          render();
          update();
        }
      });
      on('snapGridLengthChange', () => {
        if (!swiper.params.loop) {
          render();
          update();
        }
      });
      on('destroy', () => {
        destroy();
      });
      on('enable disable', () => {
        const {
          $el
        } = swiper.pagination;
        if ($el) {
          $el[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.pagination.lockClass);
        }
      });
      on('lock unlock', () => {
        update();
      });
      on('click', (_s, e) => {
        const targetEl = e.target;
        const {
          $el
        } = swiper.pagination;
        if (swiper.params.pagination.el && swiper.params.pagination.hideOnClick && $el && $el.length > 0 && !$(targetEl).hasClass(swiper.params.pagination.bulletClass)) {
          if (swiper.navigation && (swiper.navigation.nextEl && targetEl === swiper.navigation.nextEl || swiper.navigation.prevEl && targetEl === swiper.navigation.prevEl)) return;
          const isHidden = $el.hasClass(swiper.params.pagination.hiddenClass);
          if (isHidden === true) {
            emit('paginationShow');
          } else {
            emit('paginationHide');
          }
          $el.toggleClass(swiper.params.pagination.hiddenClass);
        }
      });
      const enable = () => {
        swiper.$el.removeClass(swiper.params.pagination.paginationDisabledClass);
        if (swiper.pagination.$el) {
          swiper.pagination.$el.removeClass(swiper.params.pagination.paginationDisabledClass);
        }
        init();
        render();
        update();
      };
      const disable = () => {
        swiper.$el.addClass(swiper.params.pagination.paginationDisabledClass);
        if (swiper.pagination.$el) {
          swiper.pagination.$el.addClass(swiper.params.pagination.paginationDisabledClass);
        }
        destroy();
      };
      Object.assign(swiper.pagination, {
        enable,
        disable,
        render,
        update,
        init,
        destroy
      });
    }

    function Autoplay({
      swiper,
      extendParams,
      on,
      emit
    }) {
      let timeout;
      swiper.autoplay = {
        running: false,
        paused: false
      };
      extendParams({
        autoplay: {
          enabled: false,
          delay: 3000,
          waitForTransition: true,
          disableOnInteraction: true,
          stopOnLastSlide: false,
          reverseDirection: false,
          pauseOnMouseEnter: false
        }
      });
      function run() {
        if (!swiper.size) {
          swiper.autoplay.running = false;
          swiper.autoplay.paused = false;
          return;
        }
        const $activeSlideEl = swiper.slides.eq(swiper.activeIndex);
        let delay = swiper.params.autoplay.delay;
        if ($activeSlideEl.attr('data-swiper-autoplay')) {
          delay = $activeSlideEl.attr('data-swiper-autoplay') || swiper.params.autoplay.delay;
        }
        clearTimeout(timeout);
        timeout = nextTick(() => {
          let autoplayResult;
          if (swiper.params.autoplay.reverseDirection) {
            if (swiper.params.loop) {
              swiper.loopFix();
              autoplayResult = swiper.slidePrev(swiper.params.speed, true, true);
              emit('autoplay');
            } else if (!swiper.isBeginning) {
              autoplayResult = swiper.slidePrev(swiper.params.speed, true, true);
              emit('autoplay');
            } else if (!swiper.params.autoplay.stopOnLastSlide) {
              autoplayResult = swiper.slideTo(swiper.slides.length - 1, swiper.params.speed, true, true);
              emit('autoplay');
            } else {
              stop();
            }
          } else if (swiper.params.loop) {
            swiper.loopFix();
            autoplayResult = swiper.slideNext(swiper.params.speed, true, true);
            emit('autoplay');
          } else if (!swiper.isEnd) {
            autoplayResult = swiper.slideNext(swiper.params.speed, true, true);
            emit('autoplay');
          } else if (!swiper.params.autoplay.stopOnLastSlide) {
            autoplayResult = swiper.slideTo(0, swiper.params.speed, true, true);
            emit('autoplay');
          } else {
            stop();
          }
          if (swiper.params.cssMode && swiper.autoplay.running) run();else if (autoplayResult === false) {
            run();
          }
        }, delay);
      }
      function start() {
        if (typeof timeout !== 'undefined') return false;
        if (swiper.autoplay.running) return false;
        swiper.autoplay.running = true;
        emit('autoplayStart');
        run();
        return true;
      }
      function stop() {
        if (!swiper.autoplay.running) return false;
        if (typeof timeout === 'undefined') return false;
        if (timeout) {
          clearTimeout(timeout);
          timeout = undefined;
        }
        swiper.autoplay.running = false;
        emit('autoplayStop');
        return true;
      }
      function pause(speed) {
        if (!swiper.autoplay.running) return;
        if (swiper.autoplay.paused) return;
        if (timeout) clearTimeout(timeout);
        swiper.autoplay.paused = true;
        if (speed === 0 || !swiper.params.autoplay.waitForTransition) {
          swiper.autoplay.paused = false;
          run();
        } else {
          ['transitionend', 'webkitTransitionEnd'].forEach(event => {
            swiper.$wrapperEl[0].addEventListener(event, onTransitionEnd);
          });
        }
      }
      function onVisibilityChange() {
        const document = getDocument();
        if (document.visibilityState === 'hidden' && swiper.autoplay.running) {
          pause();
        }
        if (document.visibilityState === 'visible' && swiper.autoplay.paused) {
          run();
          swiper.autoplay.paused = false;
        }
      }
      function onTransitionEnd(e) {
        if (!swiper || swiper.destroyed || !swiper.$wrapperEl) return;
        if (e.target !== swiper.$wrapperEl[0]) return;
        ['transitionend', 'webkitTransitionEnd'].forEach(event => {
          swiper.$wrapperEl[0].removeEventListener(event, onTransitionEnd);
        });
        swiper.autoplay.paused = false;
        if (!swiper.autoplay.running) {
          stop();
        } else {
          run();
        }
      }
      function onMouseEnter() {
        if (swiper.params.autoplay.disableOnInteraction) {
          stop();
        } else {
          emit('autoplayPause');
          pause();
        }
        ['transitionend', 'webkitTransitionEnd'].forEach(event => {
          swiper.$wrapperEl[0].removeEventListener(event, onTransitionEnd);
        });
      }
      function onMouseLeave() {
        if (swiper.params.autoplay.disableOnInteraction) {
          return;
        }
        swiper.autoplay.paused = false;
        emit('autoplayResume');
        run();
      }
      function attachMouseEvents() {
        if (swiper.params.autoplay.pauseOnMouseEnter) {
          swiper.$el.on('mouseenter', onMouseEnter);
          swiper.$el.on('mouseleave', onMouseLeave);
        }
      }
      function detachMouseEvents() {
        swiper.$el.off('mouseenter', onMouseEnter);
        swiper.$el.off('mouseleave', onMouseLeave);
      }
      on('init', () => {
        if (swiper.params.autoplay.enabled) {
          start();
          const document = getDocument();
          document.addEventListener('visibilitychange', onVisibilityChange);
          attachMouseEvents();
        }
      });
      on('beforeTransitionStart', (_s, speed, internal) => {
        if (swiper.autoplay.running) {
          if (internal || !swiper.params.autoplay.disableOnInteraction) {
            swiper.autoplay.pause(speed);
          } else {
            stop();
          }
        }
      });
      on('sliderFirstMove', () => {
        if (swiper.autoplay.running) {
          if (swiper.params.autoplay.disableOnInteraction) {
            stop();
          } else {
            pause();
          }
        }
      });
      on('touchEnd', () => {
        if (swiper.params.cssMode && swiper.autoplay.paused && !swiper.params.autoplay.disableOnInteraction) {
          run();
        }
      });
      on('destroy', () => {
        detachMouseEvents();
        if (swiper.autoplay.running) {
          stop();
        }
        const document = getDocument();
        document.removeEventListener('visibilitychange', onVisibilityChange);
      });
      Object.assign(swiper.autoplay, {
        pause,
        run,
        start,
        stop
      });
    }

    function freeMode({
      swiper,
      extendParams,
      emit,
      once
    }) {
      extendParams({
        freeMode: {
          enabled: false,
          momentum: true,
          momentumRatio: 1,
          momentumBounce: true,
          momentumBounceRatio: 1,
          momentumVelocityRatio: 1,
          sticky: false,
          minimumVelocity: 0.02
        }
      });
      function onTouchStart() {
        const translate = swiper.getTranslate();
        swiper.setTranslate(translate);
        swiper.setTransition(0);
        swiper.touchEventsData.velocities.length = 0;
        swiper.freeMode.onTouchEnd({
          currentPos: swiper.rtl ? swiper.translate : -swiper.translate
        });
      }
      function onTouchMove() {
        const {
          touchEventsData: data,
          touches
        } = swiper;
        if (data.velocities.length === 0) {
          data.velocities.push({
            position: touches[swiper.isHorizontal() ? 'startX' : 'startY'],
            time: data.touchStartTime
          });
        }
        data.velocities.push({
          position: touches[swiper.isHorizontal() ? 'currentX' : 'currentY'],
          time: now()
        });
      }
      function onTouchEnd({
        currentPos
      }) {
        const {
          params,
          $wrapperEl,
          rtlTranslate: rtl,
          snapGrid,
          touchEventsData: data
        } = swiper;
        const touchEndTime = now();
        const timeDiff = touchEndTime - data.touchStartTime;
        if (currentPos < -swiper.minTranslate()) {
          swiper.slideTo(swiper.activeIndex);
          return;
        }
        if (currentPos > -swiper.maxTranslate()) {
          if (swiper.slides.length < snapGrid.length) {
            swiper.slideTo(snapGrid.length - 1);
          } else {
            swiper.slideTo(swiper.slides.length - 1);
          }
          return;
        }
        if (params.freeMode.momentum) {
          if (data.velocities.length > 1) {
            const lastMoveEvent = data.velocities.pop();
            const velocityEvent = data.velocities.pop();
            const distance = lastMoveEvent.position - velocityEvent.position;
            const time = lastMoveEvent.time - velocityEvent.time;
            swiper.velocity = distance / time;
            swiper.velocity /= 2;
            if (Math.abs(swiper.velocity) < params.freeMode.minimumVelocity) {
              swiper.velocity = 0;
            }
            if (time > 150 || now() - lastMoveEvent.time > 300) {
              swiper.velocity = 0;
            }
          } else {
            swiper.velocity = 0;
          }
          swiper.velocity *= params.freeMode.momentumVelocityRatio;
          data.velocities.length = 0;
          let momentumDuration = 1000 * params.freeMode.momentumRatio;
          const momentumDistance = swiper.velocity * momentumDuration;
          let newPosition = swiper.translate + momentumDistance;
          if (rtl) newPosition = -newPosition;
          let doBounce = false;
          let afterBouncePosition;
          const bounceAmount = Math.abs(swiper.velocity) * 20 * params.freeMode.momentumBounceRatio;
          let needsLoopFix;
          if (newPosition < swiper.maxTranslate()) {
            if (params.freeMode.momentumBounce) {
              if (newPosition + swiper.maxTranslate() < -bounceAmount) {
                newPosition = swiper.maxTranslate() - bounceAmount;
              }
              afterBouncePosition = swiper.maxTranslate();
              doBounce = true;
              data.allowMomentumBounce = true;
            } else {
              newPosition = swiper.maxTranslate();
            }
            if (params.loop && params.centeredSlides) needsLoopFix = true;
          } else if (newPosition > swiper.minTranslate()) {
            if (params.freeMode.momentumBounce) {
              if (newPosition - swiper.minTranslate() > bounceAmount) {
                newPosition = swiper.minTranslate() + bounceAmount;
              }
              afterBouncePosition = swiper.minTranslate();
              doBounce = true;
              data.allowMomentumBounce = true;
            } else {
              newPosition = swiper.minTranslate();
            }
            if (params.loop && params.centeredSlides) needsLoopFix = true;
          } else if (params.freeMode.sticky) {
            let nextSlide;
            for (let j = 0; j < snapGrid.length; j += 1) {
              if (snapGrid[j] > -newPosition) {
                nextSlide = j;
                break;
              }
            }
            if (Math.abs(snapGrid[nextSlide] - newPosition) < Math.abs(snapGrid[nextSlide - 1] - newPosition) || swiper.swipeDirection === 'next') {
              newPosition = snapGrid[nextSlide];
            } else {
              newPosition = snapGrid[nextSlide - 1];
            }
            newPosition = -newPosition;
          }
          if (needsLoopFix) {
            once('transitionEnd', () => {
              swiper.loopFix();
            });
          }
          if (swiper.velocity !== 0) {
            if (rtl) {
              momentumDuration = Math.abs((-newPosition - swiper.translate) / swiper.velocity);
            } else {
              momentumDuration = Math.abs((newPosition - swiper.translate) / swiper.velocity);
            }
            if (params.freeMode.sticky) {
              const moveDistance = Math.abs((rtl ? -newPosition : newPosition) - swiper.translate);
              const currentSlideSize = swiper.slidesSizesGrid[swiper.activeIndex];
              if (moveDistance < currentSlideSize) {
                momentumDuration = params.speed;
              } else if (moveDistance < 2 * currentSlideSize) {
                momentumDuration = params.speed * 1.5;
              } else {
                momentumDuration = params.speed * 2.5;
              }
            }
          } else if (params.freeMode.sticky) {
            swiper.slideToClosest();
            return;
          }
          if (params.freeMode.momentumBounce && doBounce) {
            swiper.updateProgress(afterBouncePosition);
            swiper.setTransition(momentumDuration);
            swiper.setTranslate(newPosition);
            swiper.transitionStart(true, swiper.swipeDirection);
            swiper.animating = true;
            $wrapperEl.transitionEnd(() => {
              if (!swiper || swiper.destroyed || !data.allowMomentumBounce) return;
              emit('momentumBounce');
              swiper.setTransition(params.speed);
              setTimeout(() => {
                swiper.setTranslate(afterBouncePosition);
                $wrapperEl.transitionEnd(() => {
                  if (!swiper || swiper.destroyed) return;
                  swiper.transitionEnd();
                });
              }, 0);
            });
          } else if (swiper.velocity) {
            emit('_freeModeNoMomentumRelease');
            swiper.updateProgress(newPosition);
            swiper.setTransition(momentumDuration);
            swiper.setTranslate(newPosition);
            swiper.transitionStart(true, swiper.swipeDirection);
            if (!swiper.animating) {
              swiper.animating = true;
              $wrapperEl.transitionEnd(() => {
                if (!swiper || swiper.destroyed) return;
                swiper.transitionEnd();
              });
            }
          } else {
            swiper.updateProgress(newPosition);
          }
          swiper.updateActiveIndex();
          swiper.updateSlidesClasses();
        } else if (params.freeMode.sticky) {
          swiper.slideToClosest();
          return;
        } else if (params.freeMode) {
          emit('_freeModeNoMomentumRelease');
        }
        if (!params.freeMode.momentum || timeDiff >= params.longSwipesMs) {
          swiper.updateProgress();
          swiper.updateActiveIndex();
          swiper.updateSlidesClasses();
        }
      }
      Object.assign(swiper, {
        freeMode: {
          onTouchStart,
          onTouchMove,
          onTouchEnd
        }
      });
    }

    const events$5 = window.PoleneLibs.Events.default;
    const {
      intersection: intersection$1
    } = window.PoleneLibs.Observer;
    const {
      dispatchEvent: dispatchEvent$5
    } = window.PoleneLibs.Utils;
    const {
      getElementsByRef: getElementsByRef$5,
      getRefs: getRefs$2
    } = window.PoleneLibs.Refs;
    const {
      close
    } = window.PoleneLibs.SvgTemplates;
    const autoPlay = (swiper, {
      speed,
      signal
    }) => {
      const computedDirection = document.documentElement.getAttribute('dir') === 'rtl' ? 'ltr' : 'rtl';
      const slidesAnchors = Array.from(swiper.el.querySelectorAll('a'));
      let running = true;
      let hovered = false;
      let observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          const slide = entry.target;
          const index = slide.getAttribute('href');
          if (!slide || !index) return;
          if (entry.isIntersecting) {
            slide.removeAttribute('tabindex');
            slide.setAttribute('aria-hidden', 'false');
          } else {
            slide.setAttribute('tabindex', '-1');
            slide.setAttribute('aria-hidden', 'true');
            if (document.activeElement == slide) slide.blur();
          }
        });
      }, {
        threshold: 0.5
      });
      slidesAnchors.forEach(anchor => {
        anchor.setAttribute('tabindex', '-1');
        observer.observe(anchor);
      });
      const onPointerEnter = () => hovered = true;
      const onPointerLeave = () => hovered = false;
      const normalizedSpeed = speed ? speed / 10 : 0.5;
      swiper.el.addEventListener('pointerenter', onPointerEnter, {
        signal
      });
      swiper.el.addEventListener('focusin', onPointerEnter, {
        signal
      });
      swiper.el.addEventListener('pointerleave', onPointerLeave, {
        signal
      });
      swiper.el.addEventListener('focusout', onPointerLeave, {
        signal
      });
      swiper.on('slideChangeTransitionEnd', () => {
        const containerRect = swiper.$el[0].getBoundingClientRect();
        let lastVisibleSlide = null;
        slidesAnchors.forEach(slide => {
          const rect = slide.getBoundingClientRect();
          if (rect.left >= containerRect.left && rect.right <= containerRect.right + rect.width / 2) lastVisibleSlide = slide;
        });
        if (swiper.activeIndex > swiper.previousIndex) slidesAnchors[swiper.activeIndex].focus();else if (lastVisibleSlide && swiper.activeIndex < swiper.previousIndex) lastVisibleSlide.focus();
      });
      const tick = () => {
        if (running) requestAnimationFrame(tick);
        const dir = computedDirection !== 'rtl' ? 1 : -1;
        if (swiper.touchEventsData.isTouched || swiper.animating) return;
        if (hovered) return;
        swiper.setTransition(0);
        swiper.setTranslate(-swiper.translate * dir - normalizedSpeed);
        swiper.updateProgress();
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
        if (swiper.params.loop) {
          swiper.loopFix({
            direction: dir ? 'next' : 'prev',
            byMousewheel: true
          });
        }
      };
      tick();
      return {
        stop: () => {
          running = false;
        },
        start() {
          running = true;
          tick();
        },
        destroy: () => {
          observer.disconnect();
        }
      };
    };
    const makeVisibleSlidesFocusable = (slides, containerRect) => {
      let lastVisibleSlide = null;
      slides.forEach(slide => {
        const rect = slide.getBoundingClientRect();
        if (rect.left >= containerRect.left && rect.right <= containerRect.right + 20) {
          slide.setAttribute('tabindex', '0');
          slide.setAttribute('aria-hidden', 'false');
          lastVisibleSlide = slide;
        } else {
          slide.setAttribute('tabindex', '-1');
          slide.setAttribute('aria-hidden', 'true');
        }
      });
      return lastVisibleSlide;
    };
    const manageFocus = swiper => {
      const slides = Array.from(swiper.slides);
      const containerRect = swiper.$el[0].getBoundingClientRect();
      const lastVisibleSlide = makeVisibleSlidesFocusable(slides, containerRect);
      if (swiper.activeIndex > swiper.previousIndex) slides[swiper.activeIndex].focus();else if (lastVisibleSlide && swiper.activeIndex < swiper.previousIndex) lastVisibleSlide.focus();
    };
    const classes$4 = {
      peek: 'is-peeking'
    };
    const selectors$3 = {
      activeSlide: '.swiper-slide-active',
      nextSlide: '.swiper-slide-next'
    };
    const configurations = {
      'product-legacy-hero': {
        options: {},
        config: {
          freeMode: {
            enabled: false,
            sticky: false
          },
          spaceBetween: 0,
          slidesPerView: 1,
          centeredSlides: true,
          loop: true,
          pagination: {
            el: '.swiper-pagination',
            type: 'bullets'
          }
        }
      },
      'image-carousel': {
        options: {
          hasNextClick: true
        },
        config: {
          freeMode: {
            enabled: false,
            sticky: false
          },
          centeredSlides: false,
          loop: false
        }
      },
      'variant-selector': {
        options: {
          hasNextClick: false
        },
        config: {
          spaceBetween: 4,
          breakpoints: {
            600: {
              slidesPerView: 'auto',
              slidesPerGroup: 'auto'
            },
            1024: {
              slidesPerView: 6,
              slidesPerGroup: 6
            }
          },
          loop: false,
          centeredSlides: false,
          navigation: {
            nextEl: '.product-legacy-carousel__button-next',
            prevEl: '.product-legacy-carousel__button-prev'
          },
          on: {
            init: function (swiper) {
              swiper.initialized = false;
              const activeSlide = swiper.el.querySelector('.is-active');
              if (activeSlide) {
                const activeIndex = Array.from(swiper.slides).indexOf(activeSlide);
                if (activeIndex >= 6) {
                  swiper.slideTo(activeIndex, 0);
                }
                requestAnimationFrame(() => {
                  makeVisibleSlidesFocusable(Array.from(swiper.slides), swiper.$el[0].getBoundingClientRect());
                  setTimeout(() => {
                    swiper.initialized = true;
                  }, 100);
                });
              } else {
                swiper.initialized = true;
              }
            },
            slideChangeTransitionEnd: swiper => {
              if (swiper.initialized) {
                manageFocus(swiper);
              }
            }
          }
        }
      }
    };
    var productLegacyCarousel = () => {
      const {
        productLegacyCarousel: carousel
      } = getElementsByRef$5('product-legacy-carousel');
      if (!carousel) return;
      const carousels = Array.isArray(carousel) ? [...carousel] : [carousel];
      const swipers = carousels.map(carousel => {
        const controller = new AbortController();
        const {
          signal
        } = controller;
        let swiper;
        let hasPeeked = false;
        let convention;
        let autoPlayer;
        let observer;
        const initSwiper = ({
          container,
          config,
          options,
          autoplaySpeed
        }) => {
          swiper = new Swiper$1(container, config);
          if (options.autoplay) autoPlayer = autoPlay(swiper, {
            speed: autoplaySpeed,
            signal
          });
          if (swiper.slides.length > 2 && !!options.hasNextClick) {
            swiper.slides.forEach(slide => {
              slide.addEventListener('mouseenter', handleMouseEnter, {
                signal
              });
            });
          }
        };
        const handleMouseEnter = e => {
          if (!swiper) return;
          const next = e.target.closest(selectors$3.nextSlide);
          const active = e.target.closest(selectors$3.activeSlide);
          const isFirstItem = swiper.activeIndex === 0;
          const isLastItem = swiper.activeIndex === swiper.slides.length - 2;
          if (next && !isLastItem) {
            dispatchEvent$5(window, events$5.CHANGE_CURSOR, {
              type: 'next',
              contrast: true
            });
          } else if (active && !isFirstItem) {
            dispatchEvent$5(window, events$5.CHANGE_CURSOR, {
              type: 'prev',
              contrast: true
            });
          } else {
            dispatchEvent$5(window, events$5.CHANGE_CURSOR, {
              type: 'default',
              contrast: false
            });
          }
        };
        const handleNextClick = e => {
          if (!swiper) return;
          const next = e.target.closest(selectors$3.nextSlide);
          const active = e.target.closest(selectors$3.activeSlide);
          const firstItemClicked = swiper.clickedIndex === 0;
          const lastItemClicked = swiper.clickedIndex === swiper.slides.length - 1;
          if (next && !lastItemClicked) {
            swiper.slideNext();
          }
          if (active && !firstItemClicked) {
            swiper.slidePrev();
          }
        };
        const handleIntersection = ([entry]) => {
          if (!swiper) return;
          const peekIndex = swiper.activeIndex + 2;
          if (peekIndex > 3) return;
          const peekItem = swiper.slides[peekIndex];
          if (entry.isIntersecting && !hasPeeked) {
            peekItem.classList.add(classes$4.peek);
            hasPeeked = true;
          }
        };
        const resetCursor = () => {
          dispatchEvent$5(window, events$5.CHANGE_CURSOR, {
            type: 'default',
            contrast: false
          });
        };
        const removeAllEventListeners = () => {
          if (autoPlayer) autoPlayer.destroy();
          if (observer) observer.disconnect();
          controller.abort();
        };
        const {
          configType,
          configHorizontalScroll,
          configAutoplay,
          configAutoplaySpeed,
          configPagination
        } = carousel.dataset;
        if (!configType) return removeAllEventListeners;
        const options = configurations[configType].options;
        const {
          productLegacyCarouselContainer: container
        } = getRefs$2(carousel);
        if (configAutoplay) {
          configurations[configType].options.autoplay = configAutoplay === 'true';
        }
        if (configPagination && configPagination === 'true') {
          configurations[configType].config.pagination = {
            el: '.swiper-pagination',
            type: 'bullets'
          };
        }
        convention = {
          modules: [Mousewheel, freeMode, Autoplay, Pagination, Navigation],
          freeMode: {
            enabled: true,
            sticky: false
          },
          pagination: false,
          slidesPerView: 'auto',
          direction: 'horizontal',
          watchOverflow: true,
          loop: true,
          centeredSlides: true,
          allowTouchMove: configHorizontalScroll ? configHorizontalScroll === 'true' : true,
          mousewheel: {
            invert: false,
            forceToAxis: true,
            enabled: configHorizontalScroll ? configHorizontalScroll === 'true' : true
          },
          ...configurations[configType].config
        };
        initSwiper({
          container: container,
          config: convention,
          options: options,
          autoplaySpeed: parseFloat(configAutoplaySpeed ? configAutoplaySpeed : '0.5')
        });
        if (configType === 'product-legacy-hero') {
          if (!swiper?.slides.length) return removeAllEventListeners;
          const lightbox = new PhotoSwipeLightbox({
            closeSVG: close,
            bgOpacity: 1,
            gallery: carousel,
            children: swiper.slides,
            zoom: false,
            counter: false,
            initialZoomLevel: 'fill',
            secondaryZoomLevel: 1,
            maxZoomLevel: 2,
            pswpModule: PhotoSwipe
          });
          lightbox.init();
        }
        if (options.hasNextClick) {
          carousel.addEventListener('click', handleNextClick, {
            signal
          });
          carousel.addEventListener('mouseleave', resetCursor, {
            signal
          });
          if (!swiper || 'imagesToLoad' in swiper && Array.isArray(swiper.imagesToLoad) && swiper.imagesToLoad.length <= 2) return removeAllEventListeners;
          observer = intersection$1(carousel, handleIntersection, {
            threshold: [0.8]
          });
        }
        return removeAllEventListeners;
      });
      return () => {
        swipers.forEach(teardown => teardown());
      };
    };

    var productLegacyCarousel$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: productLegacyCarousel
    });

    const {
      breakpoints: breakpoints$1
    } = window.PoleneLibs.Breakpoints;
    const {
      intersection
    } = window.PoleneLibs.Observer;
    const {
      getElementsByRef: getElementsByRef$4
    } = window.PoleneLibs.Refs;
    let scrolledPassed = false;
    const classes$3 = {
      showBuyBar: 'buy-bar-visible',
      isPreOrder: 'is-preorder',
      titleVisible: 'title-visible'
    };
    var productLegacyHeroInfo = async () => {
      const {
        productDetails,
        productForm,
        stickyContainer
      } = getElementsByRef$4(['product-details', 'product-form', 'sticky-container']);
      if (!productDetails || !productForm) return;
      const controller = new AbortController();
      const {
        signal
      } = controller;
      let observer;
      let isMobile = true;
      const init = () => {
        setScreenSize();
        setEventListeners();
        observer = intersection(productDetails, handleIntersection, {
          threshold: [0]
        });
      };
      const setScreenSize = () => {
        isMobile = window.innerWidth < breakpoints$1.md;
      };
      const setEventListeners = () => {
        window.addEventListener('scroll', handleScroll, {
          signal
        });
      };
      const handleScroll = () => {
        if (!isMobile || !stickyContainer) return;
        stickyContainer.classList.toggle(classes$3.titleVisible, window.scrollY > window.innerHeight * 0.7);
      };
      const handleIntersection = ([entry]) => {
        if (isMobile) return;
        if (entry.isIntersecting) {
          scrolledPassed = true;
          document.body.classList.remove(classes$3.showBuyBar);
        } else {
          if (scrolledPassed) {
            document.body.classList.add(classes$3.showBuyBar);
            scrolledPassed = false;
          }
        }
      };
      setTimeout(() => {
        init();
      });
      return () => {
        observer?.unobserve(productDetails);
        controller.abort();
      };
    };

    var productLegacyHeroInfo$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: productLegacyHeroInfo
    });

    const events$4 = window.PoleneLibs.Events.default;
    const {
      dispatchEvent: dispatchEvent$4,
      scrollToPosition
    } = window.PoleneLibs.Utils;
    const {
      getElementsByRef: getElementsByRef$3,
      getRefs: getRefs$1
    } = window.PoleneLibs.Refs;
    var productLegacyBuyBar = () => {
      const {
        buyBar,
        addToCartBtn,
        productDetails,
        stickyContainer
      } = getElementsByRef$3(['buy-bar', 'add-to-cart-btn', 'product-details', 'sticky-container']);
      if (!buyBar || !addToCartBtn) return;
      const {
        toTopTrigger,
        optionsClose,
        buyBarLabel
      } = getRefs$1(buyBar);
      const controller = new AbortController();
      const {
        signal
      } = controller;
      const init = () => {
        optionsClose?.addEventListener('click', handleClose, {
          signal
        });
        toTopTrigger.addEventListener('click', handleClick, {
          signal
        });
        [productDetails, stickyContainer].flat().forEach(scope => {
          scope?.addEventListener(events$4.VARIANT_SELECTED, handleVariantSelected, {
            signal
          });
        });
      };
      const handleVariantSelected = e => {
        const text = e.detail.isPreorder ? window.translations?.preorder_cta : window.translations?.add_to_cart;
        if (buyBarLabel && text) buyBarLabel.textContent = text;
      };
      const handleClick = e => {
        e.preventDefault();
        scrollToPosition(0, 1000, () => {
          if (Array.isArray(addToCartBtn)) addToCartBtn.forEach(btn => btn.focus());else addToCartBtn.focus();
        });
      };
      const handleClose = () => {
        dispatchEvent$4(window, events$4.CLOSE_OPTIONS);
      };
      init();
      return () => {
        controller.abort();
      };
    };

    var productLegacyBuyBar$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: productLegacyBuyBar
    });

    const {
      getElementByRef: getElementByRef$4
    } = window.PoleneLibs.Refs;
    const classes$2 = {
      pastFooter: 'is-past-footer'
    };
    var productLegacyStickyBuyBar = () => {
      const {
        stickyContainer,
        footer
      } = getElementByRef$4(['sticky-container', 'footer']);
      if (!stickyContainer || !footer) return;
      const observer = new IntersectionObserver(([entry]) => {
        stickyContainer.classList.toggle(classes$2.pastFooter, entry.isIntersecting);
      });
      observer.observe(footer);
      return () => observer.disconnect();
    };

    var productLegacyStickyBuyBar$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: productLegacyStickyBuyBar
    });

    const events$3 = window.PoleneLibs.Events.default;
    const scrollLock = window.PoleneLibs.ScrollLock.default;
    const {
      dispatchEvent: dispatchEvent$3,
      isMobile: isMobile$2,
      inertOutside,
      releaseInert,
      getVisibleFocusableElements
    } = window.PoleneLibs.Utils;
    const {
      getElementByRef: getElementByRef$3,
      getElementsByRef: getElementsByRef$2
    } = window.PoleneLibs.Refs;
    const {
      breakpoints
    } = window.PoleneLibs.Breakpoints;
    const selectors$2 = {
      item: '.js-item',
      contentItems: '.js-content',
      colorOptions: '.js-color-option',
      interactive: 'a[href], button, input, select, textarea, label, summary, [role="button"]'
    };
    const classes$1 = {
      active: 'is-active',
      visible: 'is-visible',
      added: 'is-added',
      colorOption: 'js-color-option',
      isOverflow: 'is-overflow'
    };
    let currentContent = null;
    let cursorState = 'default';
    var productLegacyDetailList = async () => {
      const {
        productDetails
      } = getElementByRef$3(['product-details']);
      if (!productDetails) return;
      const {
        toggleList,
        swapContainer,
        xyz3dTrigger,
        xyz3dView
      } = getElementByRef$3(['toggle-list', 'swap-container', 'xyz-3d-trigger', 'xyz-3d-view'], productDetails);
      const defaultImgView = swapContainer?.querySelector('.img-container--default');
      const {
        contentItems,
        toggles,
        accordionItems
      } = getElementsByRef$2(['content-items', 'toggles', 'accordion-items'], productDetails);
      const items = Array.isArray(contentItems) ? contentItems : [contentItems];
      const toggleItems = Array.isArray(toggles) ? toggles : [toggles];
      const accordions = Array.isArray(accordionItems) ? accordionItems : [accordionItems];
      const controller = new AbortController();
      const {
        signal
      } = controller;
      const init = () => {
        setEventListeners();
      };
      const setEventListeners = () => {
        toggleList?.addEventListener('click', handleToggleClick, {
          signal
        });
        swapContainer?.addEventListener('click', handleContainerClick, {
          signal
        });
        swapContainer?.addEventListener('mouseenter', handleMouseOver, {
          signal
        });
        swapContainer?.addEventListener('mouseleave', handleMouseLeave, {
          signal
        });
        swapContainer?.addEventListener('keydown', event => {
          if (event.key === 'Enter' && !isInteractive(event.target)) {
            handleContainerClick(event);
          }
        }, {
          signal
        });
        swapContainer?.addEventListener('keydown', handlePanelKeydown, {
          signal
        });
        if (Array.isArray(items)) {
          items?.forEach(item => {
            item?.firstElementChild?.addEventListener('mouseenter', handleMouseLeave, {
              signal
            });
            item?.firstElementChild?.addEventListener('mouseleave', handleMouseOver, {
              signal
            });
          });
        }
        window.addEventListener(events$3.CLOSE_OPTIONS, closeOptions, {
          signal
        });
        window.matchMedia(`(min-width: ${breakpoints.md}px)`).addEventListener('change', handleBreakpointChange, {
          signal
        });
        xyz3dTrigger?.addEventListener('click', handleXyz3dToggle, {
          signal
        });
        document.addEventListener('keydown', handleDocumentKeydown, {
          signal
        });
      };
      let is3dOpen = false;
      let is3dStarted = false;
      let backgroundInert = [];
      let is3dScrollLocked = false;
      const release3dOverlay = () => {
        releaseInert(backgroundInert);
        backgroundInert = [];
        if (is3dScrollLocked) {
          scrollLock(false);
          is3dScrollLocked = false;
        }
      };
      signal.addEventListener('abort', release3dOverlay, {
        once: true
      });
      const handleXyz3dToggle = () => {
        if (!xyz3dTrigger || !xyz3dView) return;
        is3dOpen = !is3dOpen;
        xyz3dView.classList.toggle(classes$1.visible, is3dOpen);
        defaultImgView?.classList.toggle(classes$1.visible, !is3dOpen);
        xyz3dTrigger.classList.toggle(classes$1.active, is3dOpen);
        xyz3dTrigger.setAttribute('aria-expanded', String(is3dOpen));
        if (is3dOpen) {
          const keep = xyz3dTrigger.closest('[data-item-content="img"]');
          if (isMobile$2() && keep) {
            backgroundInert = inertOutside(keep, document.body);
            scrollLock(true);
            is3dScrollLocked = true;
          }
        } else {
          release3dOverlay();
        }
        if (is3dOpen && !is3dStarted) {
          is3dStarted = true;
          customElements.whenDefined('product-xyz-3d').then(() => {
            xyz3dView.querySelector('product-xyz-3d')?.toggleViewer();
          });
        }
      };
      const close3d = () => {
        if (!is3dOpen) return;
        const hadFocus = !!xyz3dView?.contains(document.activeElement);
        handleXyz3dToggle();
        if (hadFocus) xyz3dTrigger?.focus();
      };
      const handleDocumentKeydown = event => {
        if (event.key !== 'Escape' || event.defaultPrevented || !is3dOpen || !isMobile$2()) return;
        const overlay = xyz3dTrigger?.closest('[data-item-content="img"]');
        const target = event.target;
        const isFromOverlay = target === document.body || target instanceof Node && !!overlay?.contains(target);
        if (!isFromOverlay) return;
        close3d();
      };
      const handleBreakpointChange = () => {
        close3d();
        closeOptions();
      };
      const setToggleAriaState = ({
        item,
        value
      }) => {
        item.setAttribute('aria-expanded', value.toString());
      };
      const getToggle = content => toggleItems.find(toggle => toggle?.dataset.item === content);
      const isInteractive = target => target instanceof Element && !!target.closest(selectors$2.interactive);
      const setPanelInert = (item, inert) => {
        if (inert && item.contains(document.activeElement)) getToggle(item.dataset.itemContent)?.focus();
        item.inert = inert;
      };
      const setItemVisibility = (item, visible) => {
        if (!item) return;
        setPanelInert(item, !visible);
        item.classList.toggle(classes$1.visible, visible);
      };
      const syncToggles = () => {
        toggleItems.forEach(toggle => {
          if (!toggle) return;
          const isOpen = toggle.dataset.item === currentContent;
          toggle.classList.toggle(classes$1.active, isOpen);
          setToggleAriaState({
            item: toggle,
            value: isOpen
          });
        });
      };
      const syncAccordions = () => {
        accordions.forEach(item => {
          if (!item) return;
          const isOpen = item.dataset.itemContent === currentContent;
          item.style.maxHeight = isOpen ? `${item.scrollHeight}px` : '0px';
          setPanelInert(item, !isOpen);
        });
      };
      const handlePanelKeydown = event => {
        const target = event.target;
        const panel = items.find(item => item?.dataset.itemContent !== 'img' && item?.contains(target));
        if (!panel) return;
        if (event.key === 'Escape') {
          event.preventDefault();
          resetContent();
          return;
        }
        if (event.key !== 'Tab') return;
        const toggle = getToggle(panel.dataset.itemContent);
        if (!toggle) return;
        const focusables = getVisibleFocusableElements(panel);
        const isLeaving = event.shiftKey ? !focusables.includes(target) || target === focusables[0] : !focusables.length || target === focusables[focusables.length - 1];
        if (!isLeaving) return;
        event.preventDefault();
        (event.shiftKey ? toggle : getFocusableAfter(toggle, panel) ?? toggle).focus();
      };
      const getFocusableAfter = (toggle, panel) => getVisibleFocusableElements(document.body).find(element => !!(toggle.compareDocumentPosition(element) & Node.DOCUMENT_POSITION_FOLLOWING) && !toggle.contains(element) && !panel.contains(element) && !element.closest('[inert]'));
      const handleMouseOver = () => {
        dispatchEvent$3(window, events$3.CHANGE_CURSOR, {
          type: cursorState,
          contrast: false
        });
      };
      const handleMouseLeave = () => {
        if (cursorState === 'default') return;
        dispatchEvent$3(window, events$3.CHANGE_CURSOR, {
          type: 'default',
          contrast: false
        });
      };
      const closeOptions = () => {
        currentContent = null;
        cursorState = 'default';
        items?.forEach(item => setItemVisibility(item, item?.dataset.itemContent === 'img'));
        syncAccordions();
        syncToggles();
        if (swapContainer) swapContainer.style.overflowY = 'hidden';
      };
      const handleToggleClick = e => {
        const item = e.target.closest(selectors$2.item);
        if (!item) return;
        const content = item.dataset.item;
        if (content === currentContent) {
          resetContent();
          return;
        }
        currentContent = content;
        cursorState = 'close';
        setVisibleContent(content);
        syncToggles();
      };
      const resetContent = () => {
        currentContent = null;
        cursorState = 'default';
        if (swapContainer) swapContainer.style.overflowY = 'hidden';
        dispatchEvent$3(window, events$3.CHANGE_CURSOR, {
          type: 'default',
          contrast: false
        });
        setVisibleContent('img');
        syncToggles();
      };
      const handleContainerClick = e => {
        if (e.target.classList && e.target.classList.contains(classes$1.colorOption) || isInteractive(e.target) || currentContent === 'img' || currentContent === null) return;
        resetContent();
      };
      const setVisibleContent = content => {
        if (isMobile$2()) {
          syncAccordions();
        } else {
          items.forEach(item => {
            if (item?.dataset.itemContent !== content) setItemVisibility(item, false);
          });
          const visibleItem = items.find(item => item?.dataset.itemContent === content);
          setItemVisibility(visibleItem, true);
          if (content !== 'img') visibleItem?.querySelector('.content')?.focus();
        }
      };
      setTimeout(() => {
        init();
      });
      return () => {
        controller.abort();
      };
    };

    var productLegacyDetailList$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: productLegacyDetailList
    });

    const cleanPath = path => path.replace(/\/+/g, '/');
    const cleanPaths = paths => {
      return Object.fromEntries(Object.entries(paths).map(([key, path]) => [key, cleanPath(path)]));
    };
    const ROOT_PATH = window?.Shopify?.routes?.root || '/';
    cleanPath(`${ROOT_PATH}/apps/polene-theme-features`);
    cleanPaths({
      WISHLIST: `${ROOT_PATH}/pages/wishlist`,
      ACCOUNT: `${ROOT_PATH}/account`,
      LOGIN: `${ROOT_PATH}/account/login`,
      LOGIN_MULTI_PASS: `${ROOT_PATH}/account/login/multipass`
    });
    window.P1?.klaviyo?.public_key;
    window.P1?.klaviyo?.list_id;
    const MIXPANEL_BRIDGE_KEY = 'mixpanel:bridge';
    const MIXPANEL_BRIDGE_VERSION = 1;
    const ATC_SOURCE_MAX_AGE = 60000;
    const ATC_SOURCE_FALLBACK = 'unknown';

    const isPlainObject = value => typeof value === 'object' && value !== null && !Array.isArray(value);
    const normalizeVariantId = variantId => {
      const digits = String(variantId ?? '').match(/\d+/g);
      return digits ? digits[digits.length - 1] : null;
    };
    const persist = (merged, fresh) => {
      try {
        sessionStorage.setItem(MIXPANEL_BRIDGE_KEY, JSON.stringify({
          v: MIXPANEL_BRIDGE_VERSION,
          ...merged
        }));
      } catch {
        try {
          sessionStorage.removeItem(MIXPANEL_BRIDGE_KEY);
          sessionStorage.setItem(MIXPANEL_BRIDGE_KEY, JSON.stringify({
            v: MIXPANEL_BRIDGE_VERSION,
            ...fresh
          }));
        } catch {
          return;
        }
      }
    };
    const readBridge = () => {
      try {
        const raw = sessionStorage.getItem(MIXPANEL_BRIDGE_KEY);
        if (!raw) return {};
        const parsed = JSON.parse(raw);
        return isPlainObject(parsed) ? parsed : {};
      } catch {
        return {};
      }
    };
    const recordAtcSources = (variantIds, source) => {
      const ids = variantIds.map(normalizeVariantId).filter(id => id !== null);
      if (!ids.length) return;
      const now = Date.now();
      const fresh = {};
      ids.forEach(id => {
        fresh[id] = {
          source,
          ts: now
        };
      });
      const bridge = readBridge();
      const stored = isPlainObject(bridge.atc_sources) ? bridge.atc_sources : {};
      const kept = {};
      Object.entries(stored).forEach(([id, entry]) => {
        if (!isPlainObject(entry)) return;
        const {
          source: entrySource,
          ts
        } = entry;
        if (typeof entrySource !== 'string' || typeof ts !== 'number') return;
        if (now - ts > ATC_SOURCE_MAX_AGE) return;
        kept[id] = {
          source: entrySource,
          ts
        };
      });
      persist({
        ...bridge,
        atc_sources: {
          ...kept,
          ...fresh
        }
      }, {
        atc_sources: fresh
      });
    };

    const {
      wrappedLoader
    } = window.PoleneLibs.ElementTemplates;
    const events$2 = window.PoleneLibs.Events.default;
    const {
      dispatchEvent: dispatchEvent$2,
      parseProductForm
    } = window.PoleneLibs.Utils;
    const {
      getRefs,
      getElementByRef: getElementByRef$2
    } = window.PoleneLibs.Refs;
    const {
      morphSection
    } = window.PoleneLibs.SectionRenderer;
    const {
      dispatchCartError,
      cartErrorMessage
    } = window.PoleneLibs.CartEvents;
    const root = window.Shopify?.routes.root;
    const selectors$1 = {
      cartCounter: '.js-cart-counter',
      variantInput: '.js-variant-input'
    };
    const updateCartContent = async (section, json) => {
      try {
        const cartComponent = document.querySelector('component-cart-items');
        const sectionId = cartComponent?.getAttribute('data-section-id') || 'main-cart';
        await morphSection(sectionId, section);
        dispatchEvent$2(window, events$2.CART_UPDATED, json);
        dispatchEvent$2(window, events$2.CART_DOM_UPDATED);
      } catch (error) {
        const {
          cart
        } = getRefs();
        if (cart) {
          cart.innerHTML = section;
          setCartCount(0);
        }
      }
    };
    const setCartCount = amount => {
      const counters = document.querySelectorAll(selectors$1.cartCounter);
      counters.forEach(counter => {
        const currentText = counter.innerHTML;
        const newText = counter.classList.contains('visually-hidden') ? currentText.replace(/\d+/, amount.toString()) : amount.toString();
        counter.innerHTML = newText;
      });
    };
    const triggeredProductForm = {};
    const handleAddToCart = async ({
      productForm,
      submitBtn,
      submitBtns
    }) => {
      const forms = Array.isArray(productForm) ? productForm : [productForm];
      const form = forms[0];
      const formData = new FormData(form);
      const items = parseProductForm(formData);
      const inputs = form.querySelectorAll('input');
      if (!submitBtn) return false;
      const uniqueBtns = new Set([submitBtn]);
      if (submitBtns) submitBtns.forEach(btn => uniqueBtns.add(btn));
      const allBtns = Array.from(uniqueBtns);
      const defaultStates = new Map();
      allBtns.forEach(btn => defaultStates.set(btn, btn.dataset.state));
      let eContainer;
      const states = {
        success: 'success',
        loading: 'loading',
        default: 'default',
        disabled: 'disabled'
      };
      if (submitBtn.dataset.state == states.disabled) {
        let variantId = null;
        if (!items.length) {
          variantId = form.querySelectorAll(selectors$1.variantInput)[0].value;
        } else {
          variantId = items[0].id;
          const hasOptions = form.getElementsByTagName('option');
          if (hasOptions && items[0].id === '0') {
            variantId = form.getElementsByTagName('option')[1].value;
          }
        }
        const handle = form.dataset.handle || form.querySelector('input[data-handle]')?.value || form.closest('[data-handle]')?.dataset.handle;
        dispatchEvent$2(window, events$2.TOGGLE_BIS, {
          variantId,
          handle
        });
        return false;
      }
      const btnParent = submitBtn.closest('.product-size-selector__actions, .product-add-to-cart, [data-ref="product-card"]');
      const formParent = form.closest('[data-ref="product-card"]') || form.closest('component-product-form') || form.nextElementSibling;
      const nextElementSibling = btnParent || formParent;
      if (nextElementSibling) {
        const {
          errorContainer
        } = getRefs(nextElementSibling);
        if (errorContainer) {
          eContainer = Array.isArray(errorContainer) ? errorContainer : [errorContainer];
        }
      }
      allBtns.forEach(btn => {
        if (!btn.firstElementChild) {
          btn.innerHTML = wrappedLoader;
        }
        btn.dataset.state = states.loading;
      });
      const cartComponent = document.querySelector('component-cart-items');
      const sectionId = cartComponent?.getAttribute('data-section-id') || 'main-cart';
      const resetBtnsState = () => {
        allBtns.forEach(btn => {
          const originalState = defaultStates.get(btn);
          if (originalState !== undefined) btn.dataset.state = originalState;
        });
      };
      const source = submitBtn.closest('[data-atc-source]')?.dataset.atcSource ?? ATC_SOURCE_FALLBACK;
      recordAtcSources(items.map(item => item?.id), source);
      try {
        const response = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            items,
            sections: `${sectionId},cart-notification-content`
          })
        });
        const json = await response.json().catch(() => null);
        if (response.ok) {
          if (cartComponent && json.sections && json.sections[sectionId]) {
            await updateCartContent(json.sections[sectionId], json);
          }
          dispatchEvent$2(window, events$2.CART_UPDATED, json);
          allBtns.forEach(btn => {
            btn.dataset.state = states.success;
          });
          if (eContainer) eContainer.forEach(el => el.innerHTML = '');
          const buttonsWithLabels = [];
          allBtns.forEach(btn => {
            const {
              defaultLabel,
              successLabel
            } = getElementByRef$2(['default-label', 'success-label'], btn);
            if (defaultLabel && successLabel) {
              buttonsWithLabels.push({
                btn,
                defaultLabel,
                successLabel
              });
              defaultLabel.classList.add('is-hidden');
              defaultLabel.setAttribute('aria-hidden', 'true');
              successLabel.classList.remove('is-hidden');
              successLabel.setAttribute('aria-hidden', 'false');
            }
          });
          setTimeout(() => {
            buttonsWithLabels.forEach(({
              defaultLabel,
              successLabel
            }) => {
              defaultLabel.classList.remove('is-hidden');
              defaultLabel.setAttribute('aria-hidden', 'false');
              successLabel.classList.add('is-hidden');
              successLabel.setAttribute('aria-hidden', 'true');
            });
            resetBtnsState();
          }, 3000);
          const handleKey = form.dataset.handle;
          if (!handleKey) return true;
          if (handleKey in triggeredProductForm) {
            clearTimeout(triggeredProductForm[handleKey]);
            delete triggeredProductForm[handleKey];
          }
          triggeredProductForm[handleKey] = setTimeout(() => {
            resetBtnsState();
            inputs.forEach(input => {
              input.checked = false;
            });
            clearTimeout(triggeredProductForm[handleKey]);
            delete triggeredProductForm[handleKey];
          }, 3000);
          return true;
        } else {
          dispatchCartError({
            endpoint: 'cart/add.js',
            method: 'POST',
            status: response.status,
            message: cartErrorMessage(json)
          });
          resetBtnsState();
          if (eContainer && json?.description) {
            eContainer.forEach(el => {
              el.innerHTML = json.description;
              el.classList.add('is-visible');
            });
            setTimeout(() => {
              eContainer.forEach(el => {
                el.innerHTML = '';
                el.classList.remove('is-visible');
              });
            }, 5000);
          }
          return false;
        }
      } catch (error) {
        dispatchCartError({
          endpoint: 'cart/add.js',
          method: 'POST',
          status: null,
          message: cartErrorMessage(error)
        });
        resetBtnsState();
        return false;
      }
    };

    const {
      getElementByRef: getElementByRef$1,
      getElementsByRef: getElementsByRef$1
    } = window.PoleneLibs.Refs;
    const events$1 = window.PoleneLibs.Events.default;
    const {
      dispatchEvent: dispatchEvent$1,
      isMobile: isMobile$1,
      updateGlobalModals
    } = window.PoleneLibs.Utils;
    const selectors = {
      sizeSelector: '.js-size-selector',
      productForm: '.js-product-form',
      productAnchor: '.js-product-anchor',
      addToCart: '.js-add-to-cart',
      faveBtn: '.js-fave-btn'
    };
    const classes = {
      preorderInput: 'preorder-note',
      mobile: 'is-mobile',
      preorderOverlay: 'is-preorder-overlay'
    };
    class ComponentProductForm extends HTMLElement {
      productForm = this.getElementsByTagName('form')[0];
      submitBtns = Array.from(this.querySelectorAll('button[type="submit"]'));
      formErrors = this.querySelector('[data-ref="form-errors"]');
      isProcessingAddToCart = false;
      resetTimeout = 0;
      formType = 'basic';
      isVariants = this.submitBtns.some(btn => btn.dataset.isVariants === 'true');
      constructor() {
        super();
      }
      connectedCallback() {
        this.init();
      }
      disconnectedCallback() {
        this.productForm.removeEventListener('input', this.handleFormChange);
        this.productForm.removeEventListener('submit', this.handleFormSubmit);
        if (this.productForm) {
          this.productForm.removeEventListener('input', this.handleFormChange);
        }
        const labels = this.querySelectorAll('.product-size-selector__variants__variant__label');
        labels.forEach(label => {
          label.removeEventListener('keydown', this.handleRadioLabelKeydown);
        });
      }
      init() {
        this.formType = this.dataset.formType || 'basic';
        if (this.productForm) {
          if (this.formType !== 'quick' || this.formType === 'quick' && !isMobile$1()) {
            this.productForm.addEventListener('input', this.handleFormChange);
            this.productForm.addEventListener('change', this.handleFormChange);
          }
          this.productForm.addEventListener('submit', this.handleFormSubmit);
        }
        if (this.submitBtns.length > 0) {
          this.submitBtns.forEach(btn => {
            btn.addEventListener('click', this.handleFormErrors);
          });
        }
        this.setupRadioLabelKeydown();
      }
      resetErrors = () => {
        if (this.formErrors) {
          this.formErrors.querySelectorAll('span').forEach(error => {
            error.classList.remove('is-visible');
          });
        }
      };
      handleFormErrors = event => {
        this.resetErrors();
        const target = event.currentTarget;
        if (target?.dataset.state === 'disabled') {
          const {
            errorNoSizeSelected
          } = getElementByRef$1('error-no-size-selected', this);
          if (errorNoSizeSelected) errorNoSizeSelected.classList.add('is-visible');
        }
      };
      setupRadioLabelKeydown = () => {
        const labels = this.querySelectorAll('.product-size-selector__variants__variant__label');
        if (labels.length > 0) {
          labels.forEach(label => {
            label.addEventListener('keydown', this.handleRadioLabelKeydown);
          });
        }
      };
      handleRadioLabelKeydown = event => {
        if (event.key !== 'Enter') return;
        const label = event.currentTarget;
        if (!label || !label.htmlFor) return;
        const radioButton = document.getElementById(label.htmlFor);
        if (radioButton && radioButton.type === 'radio' && this.productForm.contains(radioButton)) {
          event.preventDefault();
          radioButton.click();
        }
      };
      updatePreorderInputsState = targetElement => {
        const {
          preorderInputs: selectedPreorderInputs
        } = getElementByRef$1('preorder-inputs', targetElement);
        const {
          preorderInputs
        } = getElementsByRef$1('preorder-inputs', this.productForm);
        const allPreorderInputs = Array.isArray(preorderInputs) ? preorderInputs : [preorderInputs];
        const toggleInputsDisabled = (container, disabled) => {
          if (!container) return;
          container.querySelectorAll('input').forEach(input => {
            if (disabled) {
              input.setAttribute('disabled', 'true');
            } else {
              input.removeAttribute('disabled');
            }
          });
        };
        if (allPreorderInputs) {
          allPreorderInputs.forEach(preorderInput => {
            if (preorderInput) toggleInputsDisabled(preorderInput, true);
          });
        }
        if (selectedPreorderInputs) toggleInputsDisabled(selectedPreorderInputs, false);
      };
      isInCartNotification = () => {
        return Boolean(this.closest('[data-ref="cart-notification"]'));
      };
      handleFormChange = event => {
        this.resetErrors();
        if (!(event.target instanceof HTMLElement)) return;
        let dataset;
        let value;
        if (event.target instanceof HTMLSelectElement) {
          const selected = event.target.selectedOptions && event.target.selectedOptions[0];
          dataset = selected?.dataset;
          value = selected?.value || event.target.value;
          if (event.target.name !== 'id') {
            event.target.setAttribute('name', 'id');
          }
        } else if (event.target instanceof HTMLInputElement) {
          dataset = event.target.dataset;
          value = event.target.value;
        } else {
          return;
        }
        if (this.isProcessingAddToCart) return;
        if (event.target instanceof HTMLSelectElement && value) {
          let hiddenIdInput = this.productForm.querySelector('input[name="id"]');
          if (!hiddenIdInput) {
            hiddenIdInput = document.createElement('input');
            hiddenIdInput.type = 'hidden';
            hiddenIdInput.name = 'id';
            this.productForm.appendChild(hiddenIdInput);
          }
          hiddenIdInput.value = value;
        }
        if (event.target instanceof HTMLInputElement && event.target.type === 'radio' && event.target.name === 'variant_size') {
          const radioValue = event.target.value;
          if (radioValue) {
            let hiddenIdInput = this.productForm.querySelector('input[name="id"]');
            if (!hiddenIdInput) {
              hiddenIdInput = document.createElement('input');
              hiddenIdInput.type = 'hidden';
              hiddenIdInput.name = 'id';
              this.productForm.appendChild(hiddenIdInput);
            }
            hiddenIdInput.value = radioValue;
          }
        }
        if (dataset?.state && dataset?.label && this.submitBtns.length > 0) {
          this.submitBtns.forEach(btn => {
            const {
              defaultLabel
            } = getElementByRef$1('default-label', btn);
            if (defaultLabel) defaultLabel.textContent = dataset.label;
            btn.dataset.state = dataset.state;
            btn.classList.toggle('bis-modal-trigger', dataset.state === 'disabled');
            updateGlobalModals();
            if (event.target instanceof HTMLInputElement) btn.dataset.variantid = event.target.value;
          });
          const {
            productContext
          } = getElementByRef$1('product-context', this);
          if (productContext) {
            productContext.innerHTML = dataset?.context ? dataset.context : '&nbsp;';
          }
          const targetParent = event.target.parentElement;
          const scope = event.target instanceof HTMLSelectElement ? this.productForm : targetParent;
          if (scope) {
            this.updatePreorderInputsState(scope);
          }
        } else if (dataset?.availability == 'false') {
          const handle = this.dataset.handle;
          dispatchEvent$1(window, events$1.TOGGLE_BIS, {
            variantId: value,
            handle
          });
          return;
        }
        if (this.formType === 'quick' && this.submitBtns.length > 0 && this.submitBtns[0].dataset.state === 'active') {
          this.handleQuickAddToCart();
        }
        return;
      };
      handleQuickAddToCart = () => {
        if (!this.productForm || this.submitBtns.length === 0) return;
        const submitBtn = this.submitBtns[0];
        if (this.isProcessingAddToCart) return;
        if (submitBtn.dataset.state === 'inactive' || submitBtn.dataset.state === 'disabled' || submitBtn.dataset.state === 'modal' || submitBtn.dataset.state === 'coming-soon') {
          return;
        }
        if (this.classList.contains('quick-buy-form') && this.productForm.querySelector(selectors.sizeSelector) && isMobile$1() && !this.isInCartNotification()) {
          this.updateCartNotification(this.productForm, classes.mobile, 'variantSelector');
          return;
        }
        const preOrderInput = this.productForm.getElementsByClassName(classes.preorderInput);
        if (preOrderInput.length && isMobile$1()) {
          this.updateCartNotification(this.productForm, classes.preorderOverlay, 'preorder');
          return;
        }
        this.isProcessingAddToCart = true;
        handleAddToCart({
          productForm: this.productForm,
          submitBtn,
          submitBtns: this.submitBtns
        });
        setTimeout(() => {
          this.isProcessingAddToCart = false;
        }, 1000);
      };
      handleFormSubmit = async event => {
        this.resetErrors();
        if (!(event.currentTarget instanceof HTMLElement)) return;
        event.preventDefault();
        const productForm = event.currentTarget;
        const submitBtn = event.submitter;
        if (this.isProcessingAddToCart || !submitBtn || !productForm) return;
        const preOrderInput = productForm.getElementsByClassName(classes.preorderInput);
        if (this.isVariants && isMobile$1()) return;
        if (preOrderInput.length && isMobile$1()) {
          this.updateCartNotification(productForm, classes.preorderOverlay, 'preorder');
          return;
        }
        if (['inactive', 'modal', 'coming-soon'].includes(submitBtn.dataset.state ?? '')) {
          return;
        }
        this.isProcessingAddToCart = true;
        const success = await handleAddToCart({
          productForm,
          submitBtn,
          submitBtns: this.submitBtns
        });
        if (success && submitBtn.dataset.state !== 'disabled' && !isMobile$1()) {
          const parentModal = submitBtn.closest('component-modal');
          parentModal?.close?.();
        }
        setTimeout(() => {
          this.isProcessingAddToCart = false;
        }, 1000);
      };
      updateCartNotification = (form, className, state) => {
        if (this.isProcessingAddToCart) {
          clearTimeout(this.resetTimeout);
        }
        this.isProcessingAddToCart = true;
        const clone = form.cloneNode(true);
        let elementForNotification = clone;
        if (state === 'variantSelector') {
          elementForNotification = this.cloneNode(true);
        }
        const hostHandle = this?.dataset?.handle;
        const resolvedHandle = form?.dataset?.handle || hostHandle;
        if (resolvedHandle && elementForNotification?.setAttribute) {
          elementForNotification.setAttribute('data-handle', String(resolvedHandle));
        }
        this.resetTimeout = Number(setTimeout(() => {
          this.isProcessingAddToCart = false;
        }, 500));
      };
      static define() {
        if (!customElements.get('component-product-form')) {
          customElements.define('component-product-form', ComponentProductForm);
        }
      }
    }
    var componentProductForm = () => {
      ComponentProductForm.define();
    };

    var componentProductForm$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: componentProductForm
    });

    const {
      getElementsByRef
    } = window.PoleneLibs.Refs;
    class ComponentTabs extends HTMLElement {
      tabs = [];
      panels = [];
      activePanel = undefined;
      activeTab = undefined;
      isLastInFocusTrap = false;
      constructor() {
        super();
      }
      connectedCallback() {
        this.initializeElements();
        this.setupEventListeners();
        this.setupAccessibility();
      }
      disconnectedCallback() {
        this.removeEventListeners();
      }
      initializeElements = () => {
        const {
          tab,
          tabPanel
        } = getElementsByRef(['tab', 'tab-panel'], this);
        if (!tab || !tabPanel) return;
        this.tabs = Array.isArray(tab) ? tab : [tab];
        this.panels = Array.isArray(tabPanel) ? tabPanel : [tabPanel];
        this.activeTab = this.tabs.find(trigger => trigger?.classList.contains('active'));
        this.activePanel = this.panels.find(panel => panel?.classList.contains('active') && this.activeTab?.dataset.panelId === panel.id);
        this.isLastInFocusTrap = this.dataset.isLastInFocusTrap === 'true';
      };
      setupEventListeners = () => {
        this.tabs.forEach(tab => tab?.addEventListener('click', this.handleClick));
      };
      removeEventListeners = () => {
        this.tabs.forEach(tab => tab?.removeEventListener('click', this.handleClick));
      };
      setupAccessibility = () => {
        if (this.isLastInFocusTrap) {
          this.panels.forEach(panel => {
            if (panel && panel.lastElementChild) panel.lastElementChild.setAttribute('data-is-last-focus', 'true');
          });
        }
      };
      handleClick = event => {
        const triggeredTab = event.currentTarget;
        const {
          panelId
        } = triggeredTab.dataset;
        if (triggeredTab === this.activeTab) return;
        this.switchTab(triggeredTab);
        if (panelId) this.switchPanel(panelId);
      };
      switchTab = targetTab => {
        if (this.activeTab) {
          this.activeTab.classList.remove('active');
          this.activeTab.ariaSelected = 'false';
        }
        if (!targetTab.classList.contains('active')) {
          targetTab.classList.add('active');
          targetTab.ariaSelected = 'true';
        }
        this.activeTab = targetTab;
      };
      switchPanel = targetPanelId => {
        const newActivePanel = this.panels.find(panel => targetPanelId === panel?.id);
        if (this.activePanel) {
          this.activePanel.classList.remove('active');
          this.activePanel.ariaHidden = 'true';
        }
        if (newActivePanel && !newActivePanel.classList.contains('active')) {
          newActivePanel.classList.add('active');
          newActivePanel.ariaHidden = 'false';
          this.activePanel = newActivePanel;
        }
      };
      static define = () => {
        if (!customElements.get('component-tabs')) {
          customElements.define('component-tabs', ComponentTabs);
        }
      };
    }
    var componentTabs = () => {
      ComponentTabs.define();
    };

    var componentTabs$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        ComponentTabs: ComponentTabs,
        default: componentTabs
    });

    const events = window.PoleneLibs.Events.default;
    const {
      dispatchEvent
    } = window.PoleneLibs.Utils;
    const {
      getElementByRef
    } = window.PoleneLibs.Refs;
    class ComponentZoomableImage extends HTMLElement {
      controller = undefined;
      themeContainer = undefined;
      fsImageContainer = undefined;
      zoomBtn = undefined;
      isZoomed = false;
      rect = undefined;
      cursorX = 0;
      cursorY = 0;
      addedFullscreenClass = false;
      constructor() {
        super();
      }
      connectedCallback() {
        this.controller = new AbortController();
        this.initializeElements();
        this.setupEventListeners();
      }
      disconnectedCallback() {
        this.controller?.abort();
      }
      initializeElements = () => {
        const {
          themeZoomableImage
        } = getElementByRef('theme-zoomable-image');
        const {
          fsImageContainer,
          imageZoomTrigger
        } = getElementByRef(['fs-image-container', 'image-zoom-trigger'], this);
        this.themeContainer = themeZoomableImage;
        this.fsImageContainer = fsImageContainer;
        this.zoomBtn = imageZoomTrigger;
        this.rect = this.getBoundingClientRect();
        if (this.themeContainer && this.fsImageContainer) this.themeContainer.appendChild(this.fsImageContainer);
      };
      setupEventListeners = () => {
        this.zoomBtn?.addEventListener('click', this.handleClick, {
          signal: this.controller?.signal
        });
        this.zoomBtn?.addEventListener('focusout', this.handleFocusout, {
          signal: this.controller?.signal
        });
        this.addEventListener('mouseenter', this.handleMouseEnter, {
          signal: this.controller?.signal
        });
        this.addEventListener('mouseleave', this.handleMouseLeave, {
          signal: this.controller?.signal
        });
        this.addEventListener('mousemove', this.handleMouseMove, {
          signal: this.controller?.signal
        });
        this.addEventListener('keydown', this.handleKeyDown, {
          signal: this.controller?.signal
        });
        this.fsImageContainer?.addEventListener('click', this.handleClick, {
          signal: this.controller?.signal
        });
        this.fsImageContainer?.addEventListener('mousemove', this.handleMouseMove, {
          signal: this.controller?.signal
        });
      };
      handleFocusout = e => {
        if (this.isZoomed && this.zoomBtn) {
          e.preventDefault();
          this.zoomBtn.focus();
        }
      };
      handleKeyDown = e => {
        if (e.key === 'Escape' && this.isZoomed) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          this.zoomOut();
        }
      };
      handleClick = () => {
        if (!this.isZoomed) this.zoomIn();else this.zoomOut();
      };
      zoomIn = () => {
        dispatchEvent(window, events.CHANGE_CURSOR, {
          type: 'close',
          contrast: true
        });
        this.showImage();
        if (this.zoomBtn) this.zoomBtn.ariaPressed = 'true';
        this.isZoomed = true;
        if (!document.body.classList.contains('fullscreen-active')) {
          document.body.classList.add('fullscreen-active');
          this.addedFullscreenClass = true;
        } else {
          this.addedFullscreenClass = false;
        }
      };
      zoomOut = () => {
        if (this.isCursorInRect()) dispatchEvent(window, events.CHANGE_CURSOR, {
          type: 'zoom',
          contrast: true
        });else dispatchEvent(window, events.CHANGE_CURSOR, {
          type: 'default',
          contrast: false
        });
        this.hideImage();
        if (this.zoomBtn) this.zoomBtn.ariaPressed = 'false';
        this.isZoomed = false;
        if (this.addedFullscreenClass) {
          document.body.classList.remove('fullscreen-active');
          this.addedFullscreenClass = false;
        }
      };
      showImage = () => {
        if (!this.fsImageContainer || !this.themeContainer) return;
        this.fsImageContainer.classList.add('active');
        this.fsImageContainer.ariaHidden = 'false';
        this.themeContainer.classList.add('active');
        this.themeContainer.ariaHidden = 'false';
        this.scrollToCenter(this.fsImageContainer);
      };
      hideImage = () => {
        if (!this.fsImageContainer || !this.themeContainer) return;
        this.fsImageContainer.classList.remove('active');
        this.fsImageContainer.ariaHidden = 'true';
        this.themeContainer.classList.remove('active');
        this.themeContainer.ariaHidden = 'true';
      };
      handleMouseEnter = () => {
        if (this.isZoomed) return;
        dispatchEvent(window, events.CHANGE_CURSOR, {
          type: 'zoom',
          contrast: true
        });
      };
      handleMouseLeave = () => {
        if (this.isZoomed) return;
        dispatchEvent(window, events.CHANGE_CURSOR, {
          type: 'default',
          contrast: false
        });
      };
      handleMouseMove = e => {
        this.cursorX = e.clientX;
        this.cursorY = e.clientY;
      };
      isCursorInRect = () => {
        this.rect = this.getBoundingClientRect();
        return this.rect && this.cursorX >= this.rect.left && this.cursorX <= this.rect.right && this.cursorY >= this.rect.top && this.cursorY <= this.rect.bottom;
      };
      scrollToCenter = container => {
        container.scrollLeft = container.scrollWidth / 2 - container.clientWidth / 2;
        container.scrollTop = container.scrollHeight / 2 - container.clientHeight / 2;
      };
      static define = () => {
        if (!customElements.get('component-zoomable-image')) customElements.define('component-zoomable-image', ComponentZoomableImage);
      };
    }
    var componentZoomableImage = () => {
      ComponentZoomableImage.define();
    };

    var componentZoomableImage$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        ComponentZoomableImage: ComponentZoomableImage,
        default: componentZoomableImage
    });

    const {
      buildPowerXyzUrl,
      isMobile
    } = window.PoleneLibs.Utils;
    class ProductXYZ3D extends HTMLElement {
      controller = undefined;
      isEnabled = this.hasAttribute('is-enabled') || false;
      powerInstance = null;
      trigger = null;
      packshotContainer = null;
      packshotImg = null;
      isPackshot = this.dataset?.isPackshot === 'true' || false;
      viewerButtons = null;
      secondarySKU = this.getAttribute('data-secondary-sku') || null;
      constructor() {
        super();
      }
      connectedCallback() {
        this.controller = new AbortController();
        this.initializeElements();
      }
      disconnectedCallback() {
        this.resetPackshotState();
        this.powerInstance = null;
        this.controller?.abort();
      }
      initializeElements = async () => {
        const viewer = this.querySelector('power-viewer');
        if (!viewer) {
          throw new Error('Viewer not found');
        }
        this.viewer = viewer;
        if (!this.isEnabled) {
          this.destroy();
        }
        if (this.isPackshot) {
          if (isMobile()) {
            if (!this.classList.contains('sm-only')) {
              this.destroy();
            }
          } else {
            if (this.classList.contains('sm-only')) {
              this.destroy();
            }
          }
        }
        const isMain3dAvailable = await this.check3DAvailability(this.viewer.getAttribute('company-eid') || '', this.viewer.getAttribute('sku') || '');
        if (this.secondarySKU) {
          const isSecondary3dAvailable = await this.check3DAvailability(this.viewer.getAttribute('company-eid') || '', this.secondarySKU);
          if (!isSecondary3dAvailable) {
            this.trigger?.classList.add('is-hidden');
          }
        }
        const viewerButtons = this.querySelector('[data-ref="viewer-buttons"]');
        const packshotImg = this.querySelector('img.packshot-img');
        const packshotContainerSelector = isMobile() ? '.product-packshot__container' : '.product-packshot__container-desktop';
        if (packshotImg) {
          this.packshotImg = packshotImg;
        }
        this.packshotContainer = document.querySelector(packshotContainerSelector);
        if (this.isPackshot && !this.packshotContainer) return;
        if (viewerButtons) {
          this.viewerButtons = viewerButtons;
        }
        if (this.dataset.insideTrigger) {
          const xyzTriggerViewInside = this.querySelector(`[data-ref='${this.dataset.insideTrigger}'] input[type="checkbox"]	`);
          if (xyzTriggerViewInside) {
            this.trigger = xyzTriggerViewInside;
          }
        }
        if (isMain3dAvailable) {
          const viewerId = this.viewer.getAttribute('id');
          if (!viewerId) {
            throw new Error('Viewer ID not found');
          }
          if (this.powerInstance) return;
          if (typeof POWERViewer === 'undefined') {
            return;
          }
          this.powerInstance = new POWERViewer({
            id: viewerId
          });
          this.setupEventListeners();
        } else {
          this.destroy();
        }
      };
      destroy = () => {
        const viewerContainer = this.querySelector('[data-ref="xyz-viewer-container"]');
        if (viewerContainer) {
          viewerContainer.remove();
        }
      };
      setupEventListeners = () => {
        if (this.trigger) {
          this.trigger?.addEventListener('click', this.handleTriggerClick, {
            signal: this.controller?.signal
          });
          this.trigger?.addEventListener('keydown', this.handleTriggerKeydown, {
            signal: this.controller?.signal
          });
        }
        this.powerInstance?.onLoad(() => {
          this.toggleViewer();
        });
        document.addEventListener('modal', event => {
          const modalEvent = event;
          if (modalEvent.detail.type === 'gallery' && modalEvent.detail.action) {
            this.updatePackshotGalleryViewer({
              galleryState: modalEvent.detail.action
            });
          }
          if (modalEvent.detail.type === '3d-viewer') {
            this.toggleViewer();
          }
        });
      };
      handleTriggerKeydown = e => {
        if (e.key === 'Enter') {
          e.preventDefault();
          this.trigger?.click();
        }
      };
      handleTriggerClick = () => {
        const primarySKU = this.getAttribute('sku');
        const secondarySKU = this.getAttribute('secondary-sku');
        if (this.trigger?.checked) {
          this.trigger.value = 'open';
          if (secondarySKU) {
            this.viewer.setAttribute('sku', secondarySKU);
          }
        } else {
          if (this.trigger) this.trigger.value = 'close';
          if (primarySKU) {
            this.viewer.setAttribute('sku', primarySKU);
          }
        }
      };
      check3DAvailability = async (companyEid, SKU) => {
        const url = buildPowerXyzUrl(companyEid, SKU);
        if (!url) return false;
        try {
          const response = await fetch(url);
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          return true;
        } catch (error) {
          return false;
        }
      };
      toggleViewer = () => {
        this.viewer?.classList.remove('is-hidden');
        this.querySelector('[data-ref="xyz-viewer-container"]')?.classList.remove('is-hidden');
        if (this.viewer.getAttribute('start') && this.viewer.getAttribute('start') === 'manual') {
          this.viewer.setAttribute('start', 'eager');
        }
        if (this.viewerButtons) {
          this.viewerButtons.classList.remove('is-hidden');
        }
        if (this.trigger && this.secondarySKU) {
          this.trigger.classList.remove('is-hidden');
        }
        if (this.isPackshot && this.packshotContainer) {
          if (this.viewerButtons) {
            if (isMobile()) {
              const galleryButton = this.packshotContainer.querySelector('.power-xyz-3d-viewer-container > button');
              if (galleryButton) {
                galleryButton.setAttribute('disabled', 'true');
              }
            } else {
              this.packshotContainer.setAttribute('disabled', 'true');
            }
          }
        }
        if (this.packshotImg) {
          this.packshotImg.classList.add('is-hidden');
        }
        const zoomableImage = this.querySelector('.component-zoomable-image');
        if (zoomableImage) {
          zoomableImage.remove();
        }
      };
      updatePackshotGalleryViewer = ({
        galleryState
      }) => {
        if (this.packshotContainer) {
          const viewer = this.viewer;
          const mobileClass = isMobile() ? '.sm-only' : '';
          const packshotGallery = this.closest(`product-packshot${mobileClass}`)?.querySelector('.gallery-power-xyz-3d');
          if (packshotGallery) {
            packshotGallery.innerHTML = '';
            if (galleryState === 'open') {
              this.querySelector('power-viewer')?.remove();
              packshotGallery.appendChild(viewer);
            } else {
              const packshotViewerContainer = this.closest('product-packshot')?.querySelector('[data-ref="xyz-viewer-container"]');
              if (packshotViewerContainer) {
                packshotViewerContainer.appendChild(viewer);
              }
            }
          }
        }
      };
      resetPackshotState = () => {
        if (!this.isPackshot || !this.packshotContainer) return;
        if (this.viewerButtons) {
          if (isMobile()) {
            const galleryButton = this.packshotContainer.querySelector('.power-xyz-3d-viewer-container > button');
            if (galleryButton) {
              galleryButton.removeAttribute('disabled');
            }
          } else {
            this.packshotContainer.removeAttribute('disabled');
          }
        }
        const packshotImg = this.querySelector('img.packshot-img');
        packshotImg?.classList.remove('is-hidden');
        const zoomableImage = this.querySelector('.component-zoomable-image');
        zoomableImage?.classList.remove('is-hidden');
      };
      static define = () => {
        if (!customElements.get('product-xyz-3d')) {
          customElements.define('product-xyz-3d', ProductXYZ3D);
        }
      };
    }
    var componentProductXyz3d = () => {
      ProductXYZ3D.define();
    };

    var componentProductXyz3d$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        ProductXYZ3D: ProductXYZ3D,
        default: componentProductXyz3d
    });

})();
